// Generated by Avo VERSION 109.65.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: string, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: object) => void;
  setUserProperties?: (userId: string, userProperties: object) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: object) => void;
  revenue?: (amount: number, eventProperties: object) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: object,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: object,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: object,
    groupTypesToGroupIds: object,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: object,
  shapeUserProps?: object,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "1kzOk9JwwKaVhDYWGqS9";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: int;
  right: int;
}

interface bottomLeftParameters {
  bottom: int;
  left: int;
}

interface topRightParameters {
  top: int;
  right: int;
}

interface topLeftParameters {
  top: int;
  left: int;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: int;
  right?: int;
  bottom?: int;
  left?: int;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggePosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: object) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: string, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "QXDhwo8D19CXSEmejAk5",
          "br": "YrmPdcOBQ",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "yXbFvXu5GZ3j0uXXEPGy",
          "se": (new Date()).toISOString(),
          "so": "MoCW_anXb",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: string, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "QXDhwo8D19CXSEmejAk5",
          "br": "YrmPdcOBQ",
          "en": env,
          "ty": type,
          "sc": "yXbFvXu5GZ3j0uXXEPGy",
          "se": (new Date()).toISOString(),
          "so": "MoCW_anXb",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "yXbFvXu5GZ3j0uXXEPGy",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface MilestoneContext {
  milestoneContextweekOf: string
  milestoneContextmilestoneNumber: number
  milestoneContextsessionDuration: string
}

export interface Filters {
}

export const FlowContext = {
  'ONBOARDING': 'onboarding',
  'RESUBSCRIBE': 'resubscribe',
  'CROSSGRADE': 'crossgrade',
  'AFFILIATE': 'affiliate',
} as const;
export type FlowContextType = typeof FlowContext;
export type FlowContextValueType = FlowContextType[keyof FlowContextType];

export const EventType = {
  'VIEW': 'view',
  'CLICK': 'click',
  'CONVERSION': 'conversion',
} as const;
export type EventTypeType = typeof EventType;
export type EventTypeValueType = EventTypeType[keyof EventTypeType];

export const PlayGoal = {
  'HABIT': 'habit',
  'SONGS': 'songs',
  'PERFORM': 'perform',
  'CREATIVE': 'creative',
  'NOT_SURE': 'not-sure',
} as const;
export type PlayGoalType = typeof PlayGoal;
export type PlayGoalValueType = PlayGoalType[keyof PlayGoalType];

export const ActivityType = {
  'LESSON_VIDEO': 'lesson-video',
  'PRACTICE_MODE': 'practice-mode',
  'FEEDBACK_MODE': 'feedback-mode',
  'CHORD_CHALLENGE': 'chord-challenge',
} as const;
export type ActivityTypeType = typeof ActivityType;
export type ActivityTypeValueType = ActivityTypeType[keyof ActivityTypeType];

export const Instrument = {
  'BASS': 'bass',
  'UKULELE': 'ukulele',
  'ELECTRIC_GUITAR': 'electric-guitar',
  'ACOUSTIC_GUITAR': 'acoustic-guitar',
} as const;
export type InstrumentType = typeof Instrument;
export type InstrumentValueType = InstrumentType[keyof InstrumentType];

export const Index = {
  'PROD_PLAY_SEARCH': 'prod_play_search',
} as const;
export type IndexType = typeof Index;
export type IndexValueType = IndexType[keyof IndexType];

export const AppStore = {
  'APPLE': 'apple',
  'GOOGLE': 'google',
} as const;
export type AppStoreType = typeof AppStore;
export type AppStoreValueType = AppStoreType[keyof AppStoreType];

export const PlayPathGenre = {
  'ROCK': 'rock',
  'POP': 'pop',
  'BLUES': 'blues',
  'FUNK': 'funk',
  'FOLK': 'folk',
  'UKULELE': 'ukulele',
  'COUNTRY': 'country',
  'RNBSOUL': 'rnbsoul',
} as const;
export type PlayPathGenreType = typeof PlayPathGenre;
export type PlayPathGenreValueType = PlayPathGenreType[keyof PlayPathGenreType];

export const UserLogic = {
  'NEW': 'new',
  'RETURNING': 'returning',
} as const;
export type UserLogicType = typeof UserLogic;
export type UserLogicValueType = UserLogicType[keyof UserLogicType];

export const ActivityInstrument = {
  'BASS': 'bass',
  'UKULELE': 'ukulele',
  'ELECTRIC_GUITAR': 'electric-guitar',
  'ACOUSTIC_GUITAR': 'acoustic-guitar',
} as const;
export type ActivityInstrumentType = typeof ActivityInstrument;
export type ActivityInstrumentValueType = ActivityInstrumentType[keyof ActivityInstrumentType];

export const PlayPathInstrument = {
  'ELECTRIC_GUITAR': 'electric-guitar',
  'BASS': 'bass',
  'UKULELE': 'ukulele',
  'ACOUSTIC_GUITAR': 'acoustic-guitar',
} as const;
export type PlayPathInstrumentType = typeof PlayPathInstrument;
export type PlayPathInstrumentValueType = PlayPathInstrumentType[keyof PlayPathInstrumentType];

export const LessonType = {
  'EXERCISE': 'exercise',
  'SONG': 'song',
  'RIFF': 'riff',
  'BASICS': 'basics',
  'THEORY': 'theory',
  'TECHNIQUE': 'technique',
  'TONE': 'tone',
  'CHORD': 'chord',
  'SKILL': 'skill',
} as const;
export type LessonTypeType = typeof LessonType;
export type LessonTypeValueType = LessonTypeType[keyof LessonTypeType];

export const SiteId = {
  'PLAY_WEB': 'play_web',
  'DIGITAL_SERVICES': 'digital_services',
} as const;
export type SiteIdType = typeof SiteId;
export type SiteIdValueType = SiteIdType[keyof SiteIdType];

export const ActivityGenre = {
  'ROCK': 'rock',
  'POP': 'pop',
  'COUNTRY': 'country',
  'FOLK': 'folk',
  'FUNK': 'funk',
  'UKULELE': 'ukulele',
  'BLUES': 'blues',
  'RNBSOUL': 'rnbsoul',
} as const;
export type ActivityGenreType = typeof ActivityGenre;
export type ActivityGenreValueType = ActivityGenreType[keyof ActivityGenreType];

export const Playlist = {
  'ROCK_LEVEL_1': 'Rock Level 1',
  'ROCK_LEVEL_2': 'Rock Level 2',
  'ROCK_LEVEL_3': 'Rock Level 3',
  'ROCK_LEVEL_4': 'Rock Level 4',
  'ROCK_LEVEL_5': 'Rock Level 5',
  'POP_LEVEL_1': 'Pop Level 1',
  'POP_LEVEL_2': 'Pop Level 2',
  'POP_LEVEL_3': 'Pop Level 3',
  'POP_LEVEL_4': 'Pop Level 4',
  'POP_LEVEL_5': 'Pop Level 5',
  'BLUES_LEVEL_1': 'Blues Level 1',
  'BLUES_LEVEL_2': 'Blues Level 2',
  'BLUES_LEVEL_3': 'Blues Level 3',
  'BLUES_LEVEL_4': 'Blues Level 4',
  'BLUES_LEVEL_5': 'Blues Level 5',
  'FUNK_LEVEL_1': 'Funk Level 1',
  'FUNK_LEVEL_2': 'Funk Level 2',
  'FUNK_LEVEL_3': 'Funk Level 3',
  'FUNK_LEVEL_4': 'Funk Level 4',
  'FUNK_LEVEL_5': 'Funk Level 5',
  'UKULELE_LEVEL_1': 'Ukulele Level 1',
  'UKULELE_LEVEL_2': 'Ukulele Level 2',
  'UKULELE_LEVEL_3': 'Ukulele Level 3',
  'UKULELE_LEVEL_4': 'Ukulele Level 4',
  'UKULELE_LEVEL_5': 'Ukulele Level 5',
  'FOLK_LEVEL_1': 'Folk Level 1',
  'FOLK_LEVEL_2': 'Folk Level 2',
  'FOLK_LEVEL_3': 'Folk Level 3',
  'FOLK_LEVEL_4': 'Folk Level 4',
  'FOLK_LEVEL_5': 'Folk Level 5',
  'COUNTRY_LEVEL_1': 'Country Level 1',
  'COUNTRY_LEVEL_2': 'Country Level 2',
  'COUNTRY_LEVEL_3': 'Country Level 3',
  'COUNTRY_LEVEL_4': 'Country Level 4',
  'COUNTRY_LEVEL_5': 'Country Level 5',
} as const;
export type PlaylistType = typeof Playlist;
export type PlaylistValueType = PlaylistType[keyof PlaylistType];

export const CtaLocation = {
  'FOOTER': 'footer',
} as const;
export type CtaLocationType = typeof CtaLocation;
export type CtaLocationValueType = CtaLocationType[keyof CtaLocationType];

export const Genre = {
  'ROCK': 'rock',
  'POP': 'pop',
  'COUNTRY': 'country',
  'FOLK': 'folk',
  'FUNK': 'funk',
  'UKULELE': 'ukulele',
  'BLUES': 'blues',
  'RNBSOUL': 'rnbsoul',
} as const;
export type GenreType = typeof Genre;
export type GenreValueType = GenreType[keyof GenreType];

export const PlaySubStatus = {
  'ACTIVE': 'active',
  'PENDING': 'pending',
  'CANCELLED': 'cancelled',
  'EXPIRED': 'expired',
} as const;
export type PlaySubStatusType = typeof PlaySubStatus;
export type PlaySubStatusValueType = PlaySubStatusType[keyof PlaySubStatusType];

export const Path = {
  'ROCK': 'Rock',
  'FOLK': 'Folk',
  'POP': 'Pop',
  'COUNTRY': 'Country',
  'BLUES': 'Blues',
  'FUNK': 'Funk',
  'UKULELE': 'Ukulele',
  'RNBSOUL': 'Rnbsoul',
} as const;
export type PathType = typeof Path;
export type PathValueType = PathType[keyof PathType];

export const StreakType = {
  'STARTED': 'started',
  'PROGRESS1': 'progress1',
  'PROGRESS2': 'progress2',
  'COMPLETED': 'completed',
} as const;
export type StreakTypeType = typeof StreakType;
export type StreakTypeValueType = StreakTypeType[keyof StreakTypeType];

export const Goal = {
  'HABIT': 'habit',
  'SONGS': 'songs',
  'PERFORM': 'perform',
  'CREATIVE': 'creative',
  'NOT_SURE': 'not-sure',
} as const;
export type GoalType = typeof Goal;
export type GoalValueType = GoalType[keyof GoalType];

export const MilestoneType = {
  'DAILY_STREAK': 'Daily Streak',
} as const;
export type MilestoneTypeType = typeof MilestoneType;
export type MilestoneTypeValueType = MilestoneTypeType[keyof MilestoneTypeType];

export const AdProvider = {
  'FENDER_INTERNAL': 'fender_internal',
} as const;
export type AdProviderType = typeof AdProvider;
export type AdProviderValueType = AdProviderType[keyof AdProviderType];

let PlayWeb: any;

export function initAvo(options: {env: AvoEnv; webDebugger?: boolean;
  webDebuggerOptions?: webDebuggerOptions; strict?: boolean; noop?: boolean;
  reportFailureAs?: 'error' | 'warn' | 'log'; inspector?: AvoInspector;
  avoLogger?: AvoLogger}, destinationOptions: any,
  PlayWebDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }

    PlayWeb = PlayWebDestination;
    if (__AVO_ENV__ === 'prod') {
      PlayWeb && PlayWeb.make && PlayWeb.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      PlayWeb && PlayWeb.make && PlayWeb.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Play Web. Head to destination settings in Avo to set a staging key.");
      PlayWeb && PlayWeb.make && PlayWeb.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertTestDriveDaysRemainingOptional(
  testDriveDaysRemaining: number | null | undefined, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (testDriveDaysRemaining !== undefined && testDriveDaysRemaining !== null) {
    messages = messages.concat(AvoAssert.assertInt("86KMuJqYOJ", _label ? "test_drive_days_remaining" + ': ' + _label : "test_drive_days_remaining", testDriveDaysRemaining));
    messages = messages.concat(AvoAssert.assertMin("86KMuJqYOJ", _label ? "test_drive_days_remaining" + ": " + _label : "test_drive_days_remaining", 0, testDriveDaysRemaining));
    messages = messages.concat(AvoAssert.assertMax("86KMuJqYOJ", _label ? "test_drive_days_remaining" + ": " + _label : "test_drive_days_remaining", 7, testDriveDaysRemaining));
  }
  return messages;
}

function assertMilestoneContext(milestoneContext: MilestoneContext,
  _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertObject("VNFcJ28SMBX", _label ? "milestone_context" + ': ' + _label : "milestone_context", milestoneContext));
  if (milestoneContext !== null && milestoneContext !== undefined) {
  }
  return messages;
}

function assertTablaturePickLevel(tablaturePickLevel: number, _label?: string
  ) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("c47t9iNYDw-M", _label ? "tablature_pick_level" + ': ' + _label : "tablature_pick_level", tablaturePickLevel));
  messages = messages.concat(AvoAssert.assertMin("c47t9iNYDw-M", _label ? "tablature_pick_level" + ": " + _label : "tablature_pick_level", 1, tablaturePickLevel));
  messages = messages.concat(AvoAssert.assertMax("c47t9iNYDw-M", _label ? "tablature_pick_level" + ": " + _label : "tablature_pick_level", 3, tablaturePickLevel));
  return messages;
}

function assertCheckpointPercentOptional(
  checkpointPercent: number | null | undefined, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (checkpointPercent !== undefined && checkpointPercent !== null) {
    messages = messages.concat(AvoAssert.assertInt("o2Hyp08Kr_X6", _label ? "checkpoint_percent" + ': ' + _label : "checkpoint_percent", checkpointPercent));
    messages = messages.concat(AvoAssert.assertMin("o2Hyp08Kr_X6", _label ? "checkpoint_percent" + ": " + _label : "checkpoint_percent", 0, checkpointPercent));
    messages = messages.concat(AvoAssert.assertMax("o2Hyp08Kr_X6", _label ? "checkpoint_percent" + ": " + _label : "checkpoint_percent", 100, checkpointPercent));
  }
  return messages;
}

function assertTestDriveHoursRemainingOptional(
  testDriveHoursRemaining: number | null | undefined, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (testDriveHoursRemaining !== undefined && testDriveHoursRemaining !== null) {
    messages = messages.concat(AvoAssert.assertInt("r0HcTPKEc", _label ? "test_drive_hours_remaining" + ': ' + _label : "test_drive_hours_remaining", testDriveHoursRemaining));
    messages = messages.concat(AvoAssert.assertMin("r0HcTPKEc", _label ? "test_drive_hours_remaining" + ": " + _label : "test_drive_hours_remaining", 0, testDriveHoursRemaining));
    messages = messages.concat(AvoAssert.assertMax("r0HcTPKEc", _label ? "test_drive_hours_remaining" + ": " + _label : "test_drive_hours_remaining", 168, testDriveHoursRemaining));
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface SignInLinkClickedProperties {
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  marketingVersion: string;
}
/**
 * Sign In Link Clicked: This event fires on mobile splash screen, when user clicks to sign into their pre-existing account. Formerly "Clicked Sign In" or "Account Sign-In Clicked".
 *
 * When to trigger this event:
 * 1. User clicks "Sign in" after "Already have a Fender account?"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-lZSNEE9Bd/trigger/EUJ7qH4Gu
 * 2. This event fires when user clicks the header sign in button to login to their pre-existing account on the Play Unauth Landing Page
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-lZSNEE9Bd/trigger/trPbqZQpz
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.marketingVersion: This property indicates the version for this page (e.g.: Play v5)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-lZSNEE9Bd}
 */
export function signInLinkClicked(properties: SignInLinkClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-lZSNEE9Bd", "42e013bae26e5f65df3898b3bd8a4a97840c792f6bcc4ec3d2faec0649f6f439", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Sign In Link Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "site_id": properties.siteId,
      "marketing_version": properties.marketingVersion,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-lZSNEE9Bd", "Sign In Link Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "aKtObcCELA", name: "marketing_version", value: properties.marketingVersion},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  eventProperties["marketing_version"] = properties.marketingVersion;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign In Link Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "site_id": properties.siteId,
        "marketing_version": properties.marketingVersion,
        }, "-lZSNEE9Bd", "42e013bae26e5f65df3898b3bd8a4a97840c792f6bcc4ec3d2faec0649f6f439");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Sign In Link Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionOfferProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
}
/**
 * Subscription Offer: This screen is displayed to a user as a step in the freemium onboarding flow before choosing path and experiencing Fender Play. This flow was deprecated 8/1/2022.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/WoGSE0ff2o2/trigger/4oFzBdCGz
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/WoGSE0ff2o2}
 */
export function subscriptionOffer(properties: SubscriptionOfferProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WoGSE0ff2o2", "f332064d7ef05686bf53b332b9970d77a484762081e38d491ff582bff8258b82", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Offer", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WoGSE0ff2o2", "Subscription Offer", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionOfferAnnualClickedProperties {
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  adBodycopy: string;
  adDisplaychance: number;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Subscription Offer Annual Clicked: This event fires when a user accepts the annual subscription offer as part of freemium onboarding flow. This flow was deprecated 8/1/2022.
 *
 * When to trigger this event:
 * 1. User clicks "Get all access"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/v89-Qa0C0NS/trigger/VWdCQUp_0
 *
 * @param properties the properties associatied with this event
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adDisplaychance: The chance that a user will see a modal/popup ad when a Lesson screen/page loads.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/v89-Qa0C0NS}
 */
export function subscriptionOfferAnnualClicked(
  properties: SubscriptionOfferAnnualClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "v89-Qa0C0NS", "5f8c1eb27cdb5d05cc3170a692b42a704d61ae850d8bb7a2dd63c5e025548d5c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Offer Annual Clicked", {
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "ad_bodycopy": properties.adBodycopy,
      "ad_displaychance": properties.adDisplaychance,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("v89-Qa0C0NS", "Subscription Offer Annual Clicked", messages, [
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "MHT_saFDq-5", name: "ad_displaychance", value: properties.adDisplaychance},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["ad_displaychance"] = properties.adDisplaychance;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Offer Annual Clicked", {
        "ad_provider": properties.adProvider,
        "ad_identifier": properties.adIdentifier,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_filename": properties.adFilename,
        "ad_bodycopy": properties.adBodycopy,
        "ad_displaychance": properties.adDisplaychance,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "v89-Qa0C0NS", "5f8c1eb27cdb5d05cc3170a692b42a704d61ae850d8bb7a2dd63c5e025548d5c");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Offer Annual Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionOfferDeclinedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  adBodycopy: string;
  adDisplaychance: number;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
}
/**
 * Subscription Offer Declined: This event fires when a user declines the annual subscription offer as part of freemium onboarding flow. This flow was deprecated 8/1/2022.
 *
 * When to trigger this event:
 * 1. User clicks "Start for free" link
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/9ULfauZIbBc/trigger/Uk-It8ASh
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adDisplaychance: The chance that a user will see a modal/popup ad when a Lesson screen/page loads.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/9ULfauZIbBc}
 */
export function subscriptionOfferDeclined(
  properties: SubscriptionOfferDeclinedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9ULfauZIbBc", "ed5cbac1808d474c08c480e12bdd5095ae71e11cfc14c2f161b41c1028b483ae", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Offer Declined", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "ad_bodycopy": properties.adBodycopy,
      "ad_displaychance": properties.adDisplaychance,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9ULfauZIbBc", "Subscription Offer Declined", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "MHT_saFDq-5", name: "ad_displaychance", value: properties.adDisplaychance},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["ad_displaychance"] = properties.adDisplaychance;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Offer Declined", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ad_provider": properties.adProvider,
        "ad_identifier": properties.adIdentifier,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_filename": properties.adFilename,
        "ad_bodycopy": properties.adBodycopy,
        "ad_displaychance": properties.adDisplaychance,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        }, "9ULfauZIbBc", "ed5cbac1808d474c08c480e12bdd5095ae71e11cfc14c2f161b41c1028b483ae");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Offer Declined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TrialStartedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  utmMediumFirst: string | null | undefined;
  utmMediumLast: string | null | undefined;
  utmSourceFirst: string | null | undefined;
  utmSourceLast: string | null | undefined;
  utmCampaignFirst: string | null | undefined;
  utmCampaignLast: string | null | undefined;
  sku: string;
  value: number;
  siteidLegacy: string | null | undefined;
}
/**
 * Trial Started: This event fires automatically after a user selects either a freemium trial or a paid subscription trial and a SKU is sent, which is used for paid media to track conversions.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.utmMediumFirst: Populated with 'web_campaign_medium_first' from Segment Personas Profile API so we can determine the original campaign medium this web user arrived from.
 * @param properties.utmMediumLast: Populated with 'web_campaign_medium_last' from Segment Personas Profile API so we can determine the most recent campaign medium this web user arrived from.
This is a high priority property to pass for paid media attribution.
 * @param properties.utmSourceFirst: Populated with 'web_campaign_source_first' (if web fired event) or 'mobile_campaign_source_first' (if mobile fired event) from Segment Personas Profile API so we can determine the original campaign source this user arrived from.
 * @param properties.utmSourceLast: Populated with 'web_campaign_source_last' (if web fired event) or 'mobile_campaign_source_last' (if mobile fired event) from Segment Personas Profile API so we can determine the most recent campaign source this user arrived from.
This is a critical property to pass for paid media attribution.
 * @param properties.utmCampaignFirst: Populated with 'web_campaign_name_first' (if web fired event) or 'mobile_campaign_name_first' (if mobile fired event) from Segment Personas Profile API so we can determine the original campaign name this user arrived from.
 * @param properties.utmCampaignLast: Populated with 'web_campaign_name_last' (if web fired event) or 'mobile_campaign_name_last' (if mobile fired event) from Segment Personas Profile API so we can determine the latest campaign name this user arrived from.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 * @param properties.value: Total value of the product after quantity. Should be '0' for Trial Started. See Segment Ecommerce spec for more info.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/aHJ8U-il5aG}
 */
export function trialStarted(properties: TrialStartedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aHJ8U-il5aG", "c14063b228b156b84605affaf8795adb949df509d2f7bf9d3af8f77e998930c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Trial Started", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "utm_medium_first": properties.utmMediumFirst,
      "utm_medium_last": properties.utmMediumLast,
      "utm_source_first": properties.utmSourceFirst,
      "utm_source_last": properties.utmSourceLast,
      "utm_campaign_first": properties.utmCampaignFirst,
      "utm_campaign_last": properties.utmCampaignLast,
      "sku": properties.sku,
      "value": properties.value,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aHJ8U-il5aG", "Trial Started", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "hJcSiSbe8l", name: "utm_medium_first", value: properties.utmMediumFirst},
      {id: "YTuW7WAHdN", name: "utm_medium_last", value: properties.utmMediumLast},
      {id: "CE8Su0sB17", name: "utm_source_first", value: properties.utmSourceFirst},
      {id: "XBWpDhypLL", name: "utm_source_last", value: properties.utmSourceLast},
      {id: "cVpj26DI28", name: "utm_campaign_first", value: properties.utmCampaignFirst},
      {id: "XG7iBP1kCI", name: "utm_campaign_last", value: properties.utmCampaignLast},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      {id: "X3hxIVYvmu", name: "value", value: properties.value},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.utmMediumFirst !== undefined && properties.utmMediumFirst !== null) {
    eventPropertiesPlayWeb["utm_medium_first"] = properties.utmMediumFirst;
  }
  if (properties.utmMediumLast !== undefined && properties.utmMediumLast !== null) {
    eventPropertiesPlayWeb["utm_medium_last"] = properties.utmMediumLast;
  }
  if (properties.utmSourceFirst !== undefined && properties.utmSourceFirst !== null) {
    eventPropertiesPlayWeb["utm_source_first"] = properties.utmSourceFirst;
  }
  if (properties.utmSourceLast !== undefined && properties.utmSourceLast !== null) {
    eventPropertiesPlayWeb["utm_source_last"] = properties.utmSourceLast;
  }
  if (properties.utmCampaignFirst !== undefined && properties.utmCampaignFirst !== null) {
    eventPropertiesPlayWeb["utm_campaign_first"] = properties.utmCampaignFirst;
  }
  if (properties.utmCampaignLast !== undefined && properties.utmCampaignLast !== null) {
    eventPropertiesPlayWeb["utm_campaign_last"] = properties.utmCampaignLast;
  }
  eventPropertiesPlayWeb["sku"] = properties.sku;
  eventPropertiesPlayWeb["value"] = properties.value;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Trial Started", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "utm_medium_first": properties.utmMediumFirst,
        "utm_medium_last": properties.utmMediumLast,
        "utm_source_first": properties.utmSourceFirst,
        "utm_source_last": properties.utmSourceLast,
        "utm_campaign_first": properties.utmCampaignFirst,
        "utm_campaign_last": properties.utmCampaignLast,
        "sku": properties.sku,
        "value": properties.value,
        "siteId": properties.siteidLegacy,
        }, "aHJ8U-il5aG", "c14063b228b156b84605affaf8795adb949df509d2f7bf9d3af8f77e998930c0");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Trial Started", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface SubscriptionAdBannerClickedProperties {
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  adBodycopy: string | null | undefined;
  adDisplaychance: number;
  ctaButtoncopy: string | null | undefined;
  ctaButtoncolor: string | null | undefined;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  screen: string | null | undefined;
}
/**
 * Subscription Ad Banner Clicked: This event fires when a freemium user clicks the "upgrade" button on the persistent banner on one of these views: Path, Course Details, Songs, Collections, More (mobile only), Skills
 *
 * When to trigger this event:
 * 1. User views banner at top of the screen, before scrolling
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/qFlbyzzta8g/trigger/drXQki8Ir
 * 2. User views banner at bottom of the screen once scrolling
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/qFlbyzzta8g/trigger/rdCcXlIaw
 *
 * @param properties the properties associatied with this event
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adDisplaychance: The chance that a user will see a modal/popup ad when a Lesson screen/page loads.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.screen: This property indicates the name or type of screen this event is seen on.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/qFlbyzzta8g}
 */
export function subscriptionAdBannerClicked(
  properties: SubscriptionAdBannerClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qFlbyzzta8g", "3f8e475fc973a0ac1fe91e7c4822434c719bc60531c0576b49f1c757f938f095", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Ad Banner Clicked", {
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "ad_bodycopy": properties.adBodycopy,
      "ad_displaychance": properties.adDisplaychance,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "screen": properties.screen,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qFlbyzzta8g", "Subscription Ad Banner Clicked", messages, [
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "MHT_saFDq-5", name: "ad_displaychance", value: properties.adDisplaychance},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "crcwHDE1m6d7", name: "screen", value: properties.screen},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  if (properties.adBodycopy !== undefined && properties.adBodycopy !== null) {
    eventProperties["ad_bodycopy"] = properties.adBodycopy;
  }
  eventProperties["ad_displaychance"] = properties.adDisplaychance;
  if (properties.ctaButtoncopy !== undefined && properties.ctaButtoncopy !== null) {
    eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  }
  if (properties.ctaButtoncolor !== undefined && properties.ctaButtoncolor !== null) {
    eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  }
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  if (properties.screen !== undefined && properties.screen !== null) {
    eventProperties["screen"] = properties.screen;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Ad Banner Clicked", {
        "ad_provider": properties.adProvider,
        "ad_identifier": properties.adIdentifier,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_filename": properties.adFilename,
        "ad_bodycopy": properties.adBodycopy,
        "ad_displaychance": properties.adDisplaychance,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "screen": properties.screen,
        }, "qFlbyzzta8g", "3f8e475fc973a0ac1fe91e7c4822434c719bc60531c0576b49f1c757f938f095");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Ad Banner Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionAdModalProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  adBodycopy: string;
  adDisplaychance: number;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  courseId: string | null | undefined;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Subscription Ad Modal: This modal displays when a lesson screen loads (variable percentage rate), with a randomly-chosen content variation
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adDisplaychance: The chance that a user will see a modal/popup ad when a Lesson screen/page loads.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/h0tmfkqMDNT}
 */
export function subscriptionAdModal(properties: SubscriptionAdModalProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "h0tmfkqMDNT", "16fecb583ae2b17d7d574a37b9ab0fa58c634df68348362475b230589ba41138", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Ad Modal", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "ad_bodycopy": properties.adBodycopy,
      "ad_displaychance": properties.adDisplaychance,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("h0tmfkqMDNT", "Subscription Ad Modal", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "MHT_saFDq-5", name: "ad_displaychance", value: properties.adDisplaychance},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["ad_displaychance"] = properties.adDisplaychance;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  if (properties.courseId !== undefined && properties.courseId !== null) {
    eventProperties["course_id"] = properties.courseId;
  }
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionAdModalAcceptedProperties {
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  adBodycopy: string;
  adDisplaychance: number;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  testDriveDaysRemaining: number | null | undefined;
  testDriveHoursRemaining: number | null | undefined;
}
/**
 * Subscription Ad Modal Accepted: This event fires when a user accepts the upgrade offer from the modal in the freemium experience. They are taken to the Upgrade screen.
 *
 * @param properties the properties associatied with this event
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adDisplaychance: The chance that a user will see a modal/popup ad when a Lesson screen/page loads.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.testDriveDaysRemaining: The number of days remaining in the user's Free to Play 'Test Drive' trial period. After their test drive has expired, this value should be 0.
 * @param properties.testDriveHoursRemaining: The number of hours remaining in the user's Free to Play 'Test Drive' trial period. After their test drive has expired, this value should be 0.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/XQTq-THe4sU}
 */
export function subscriptionAdModalAccepted(
  properties: SubscriptionAdModalAcceptedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTestDriveDaysRemainingOptional(properties.testDriveDaysRemaining));
    messages = messages.concat(assertTestDriveHoursRemainingOptional(properties.testDriveHoursRemaining));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XQTq-THe4sU", "d59b11c23593bee33801ded489b6ed0c4a8076d9c1f858c9f2b41ca4a2b36aef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Ad Modal Accepted", {
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "ad_bodycopy": properties.adBodycopy,
      "ad_displaychance": properties.adDisplaychance,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "test_drive_days_remaining": properties.testDriveDaysRemaining,
      "test_drive_hours_remaining": properties.testDriveHoursRemaining,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XQTq-THe4sU", "Subscription Ad Modal Accepted", messages, [
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "MHT_saFDq-5", name: "ad_displaychance", value: properties.adDisplaychance},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "86KMuJqYOJ", name: "test_drive_days_remaining", value: properties.testDriveDaysRemaining},
      {id: "r0HcTPKEc", name: "test_drive_hours_remaining", value: properties.testDriveHoursRemaining},
      ], []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Subscription Ad Modal Accepted': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["ad_displaychance"] = properties.adDisplaychance;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.testDriveDaysRemaining !== undefined && properties.testDriveDaysRemaining !== null) {
    eventProperties["test_drive_days_remaining"] = properties.testDriveDaysRemaining;
  }
  if (properties.testDriveHoursRemaining !== undefined && properties.testDriveHoursRemaining !== null) {
    eventProperties["test_drive_hours_remaining"] = properties.testDriveHoursRemaining;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Ad Modal Accepted", {
        "ad_provider": properties.adProvider,
        "ad_identifier": properties.adIdentifier,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_filename": properties.adFilename,
        "ad_bodycopy": properties.adBodycopy,
        "ad_displaychance": properties.adDisplaychance,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "test_drive_days_remaining": properties.testDriveDaysRemaining,
        "test_drive_hours_remaining": properties.testDriveHoursRemaining,
        }, "XQTq-THe4sU", "d59b11c23593bee33801ded489b6ed0c4a8076d9c1f858c9f2b41ca4a2b36aef");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Ad Modal Accepted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionAdModalDeclinedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adFilename: string | null | undefined;
  adBodycopy: string;
  adDisplaychance: number;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  testDriveHoursRemaining: number | null | undefined;
  testDriveDaysRemaining: number | null | undefined;
}
/**
 * Subscription Ad Modal Declined: This event fires when a user declines the upgrade offer. The modal ad is dismissed.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adFilename: The filename or full URL of the primary image used in the ad.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adDisplaychance: The chance that a user will see a modal/popup ad when a Lesson screen/page loads.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.testDriveHoursRemaining: The number of hours remaining in the user's Free to Play 'Test Drive' trial period. After their test drive has expired, this value should be 0.
 * @param properties.testDriveDaysRemaining: The number of days remaining in the user's Free to Play 'Test Drive' trial period. After their test drive has expired, this value should be 0.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/wdV9ytclY3g}
 */
export function subscriptionAdModalDeclined(
  properties: SubscriptionAdModalDeclinedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTestDriveHoursRemainingOptional(properties.testDriveHoursRemaining));
    messages = messages.concat(assertTestDriveDaysRemainingOptional(properties.testDriveDaysRemaining));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wdV9ytclY3g", "d3b0723e17b660dd482ab0c6ee9b92b653fdf8ffbbe6ad40977a7e093e72f25a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Ad Modal Declined", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_filename": properties.adFilename,
      "ad_bodycopy": properties.adBodycopy,
      "ad_displaychance": properties.adDisplaychance,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "test_drive_hours_remaining": properties.testDriveHoursRemaining,
      "test_drive_days_remaining": properties.testDriveDaysRemaining,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wdV9ytclY3g", "Subscription Ad Modal Declined", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "pzMf-pwVW7U", name: "ad_filename", value: properties.adFilename},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "MHT_saFDq-5", name: "ad_displaychance", value: properties.adDisplaychance},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "r0HcTPKEc", name: "test_drive_hours_remaining", value: properties.testDriveHoursRemaining},
      {id: "86KMuJqYOJ", name: "test_drive_days_remaining", value: properties.testDriveDaysRemaining},
      ], []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Subscription Ad Modal Declined': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  if (properties.adFilename !== undefined && properties.adFilename !== null) {
    eventProperties["ad_filename"] = properties.adFilename;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["ad_displaychance"] = properties.adDisplaychance;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  if (properties.testDriveHoursRemaining !== undefined && properties.testDriveHoursRemaining !== null) {
    eventProperties["test_drive_hours_remaining"] = properties.testDriveHoursRemaining;
  }
  if (properties.testDriveDaysRemaining !== undefined && properties.testDriveDaysRemaining !== null) {
    eventProperties["test_drive_days_remaining"] = properties.testDriveDaysRemaining;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Ad Modal Declined", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "ad_provider": properties.adProvider,
        "ad_identifier": properties.adIdentifier,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_filename": properties.adFilename,
        "ad_bodycopy": properties.adBodycopy,
        "ad_displaychance": properties.adDisplaychance,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "test_drive_hours_remaining": properties.testDriveHoursRemaining,
        "test_drive_days_remaining": properties.testDriveDaysRemaining,
        }, "wdV9ytclY3g", "d3b0723e17b660dd482ab0c6ee9b92b653fdf8ffbbe6ad40977a7e093e72f25a");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Ad Modal Declined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionUpgradeProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  name: string;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  courseId: string | null | undefined;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Subscription Upgrade: This screen loads when a user taps the persistent banner CTA, or the modal ad "accept" CTA as part of the freemium flow, and displays options for plans.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mUqt2aKMiBt/trigger/T9CLmnVWx
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mUqt2aKMiBt}
 */
export function subscriptionUpgrade(properties: SubscriptionUpgradeProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mUqt2aKMiBt", "868abba6a54efca54ff61e90837f9acdfa8aaf8c3200d10c49ff144319368451", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Upgrade", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "name": properties.name,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mUqt2aKMiBt", "Subscription Upgrade", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.lessonId !== undefined && properties.lessonId !== null) {
    eventProperties["lesson_id"] = properties.lessonId;
  }
  if (properties.lessonSlug !== undefined && properties.lessonSlug !== null) {
    eventProperties["lesson_slug"] = properties.lessonSlug;
  }
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["name"] = properties.name;
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  eventProperties["playlist"] = properties.playlist;
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  if (properties.courseId !== undefined && properties.courseId !== null) {
    eventProperties["course_id"] = properties.courseId;
  }
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionUpgradeAnnualClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  ctaButtoncolor: string;
  ctaButtoncopy: string;
}
/**
 * Subscription Upgrade Annual Clicked: This event fires when a user selects an annual plan to upgrade to from their freemium plan.
 *
 * When to trigger this event:
 * 1. User clicks "Select this plan" on annual plan
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mg2zxYRg9t-/trigger/dr7nO93ZW
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mg2zxYRg9t-}
 */
export function subscriptionUpgradeAnnualClicked(
  properties: SubscriptionUpgradeAnnualClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mg2zxYRg9t-", "d76d676388c2b0fbd894b2183ff0815619d6ee5ba2e3105ba139a3063c1ed6a9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Upgrade Annual Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "cta_buttoncopy": properties.ctaButtoncopy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mg2zxYRg9t-", "Subscription Upgrade Annual Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Upgrade Annual Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "cta_buttoncopy": properties.ctaButtoncopy,
        }, "mg2zxYRg9t-", "d76d676388c2b0fbd894b2183ff0815619d6ee5ba2e3105ba139a3063c1ed6a9");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Upgrade Annual Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionUpgradeMonthlyClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType;
  ctaButtoncolor: string;
  ctaButtoncopy: string;
}
/**
 * Subscription Upgrade Monthly Clicked: This event fires when a user selects a monthly plan to upgrade to from their freemium plan.
 *
 * When to trigger this event:
 * 1. User clicks "Select this plan" on monthly plan
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/D0CCDYJdeRP/trigger/kVqCOVU_K
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/D0CCDYJdeRP}
 */
export function subscriptionUpgradeMonthlyClicked(
  properties: SubscriptionUpgradeMonthlyClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "D0CCDYJdeRP", "bcb135e81d26e084f6e56addac9ef5737dd025d17378e08d4eba0165a8d19c6e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Upgrade Monthly Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "cta_buttoncopy": properties.ctaButtoncopy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("D0CCDYJdeRP", "Subscription Upgrade Monthly Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Upgrade Monthly Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "cta_buttoncopy": properties.ctaButtoncopy,
        }, "D0CCDYJdeRP", "bcb135e81d26e084f6e56addac9ef5737dd025d17378e08d4eba0165a8d19c6e");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Upgrade Monthly Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionUpgradeDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
}
/**
 * Subscription Upgrade Dismissed: This event fires when a user backs out of the upgrade flow from a freemium plan.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MjoLKaRjAdk}
 */
export function subscriptionUpgradeDismissed(
  properties: SubscriptionUpgradeDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MjoLKaRjAdk", "04bbf454865d4a61185480367a8200ff793162947d0d2f65e500faa178464bf3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Upgrade Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MjoLKaRjAdk", "Subscription Upgrade Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Upgrade Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        }, "MjoLKaRjAdk", "04bbf454865d4a61185480367a8200ff793162947d0d2f65e500faa178464bf3");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Upgrade Dismissed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CompletedOrderProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  utmMediumFirst: string | null | undefined;
  utmMediumLast: string | null | undefined;
  utmSourceFirst: string | null | undefined;
  utmSourceLast: string | null | undefined;
  utmCampaignFirst: string | null | undefined;
  utmCampaignLast: string | null | undefined;
  templateId: number | null | undefined;
  campaignId: number;
  customDestinationAmount_: number;
  userId_: string;
  playSubCreated: string;
  playSubIap: boolean;
  playSubPaymentSource: string;
  playSubSku: string;
  playSubStatus: PlaySubStatusValueType;
  coupon: string | null | undefined;
  countryCode: string | null | undefined;
  paymentMethod: string | null | undefined;
  timeZoneIdentifier: string | null | undefined;
  lastPurchaseCurrency: string;
  revenue: number | null | undefined;
  currency: string | null | undefined;
  currencyCode: string | null | undefined;
  price: number;
  sku: string;
  isSubscriptionOffer: boolean | null | undefined;
  isPreviouslyFreemium: boolean | null | undefined;
}
/**
 * Completed Order: This event fires when our subscription API returns a success message after a paid subscription is started (with or without trial) via Apple, Google, or Zuora. Crucial for paid media conversion tracking.
 *
 * When to trigger this event:
 * 1. Subscription is started
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Iw3RUNgZkP/trigger/BjxoXghbI
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.utmMediumFirst: Populated with 'web_campaign_medium_first' from Segment Personas Profile API so we can determine the original campaign medium this web user arrived from.
 * @param properties.utmMediumLast: Populated with 'web_campaign_medium_last' from Segment Personas Profile API so we can determine the most recent campaign medium this web user arrived from.
This is a high priority property to pass for paid media attribution.
 * @param properties.utmSourceFirst: Populated with 'web_campaign_source_first' (if web fired event) or 'mobile_campaign_source_first' (if mobile fired event) from Segment Personas Profile API so we can determine the original campaign source this user arrived from.
 * @param properties.utmSourceLast: Populated with 'web_campaign_source_last' (if web fired event) or 'mobile_campaign_source_last' (if mobile fired event) from Segment Personas Profile API so we can determine the most recent campaign source this user arrived from.
This is a critical property to pass for paid media attribution.
 * @param properties.utmCampaignFirst: Populated with 'web_campaign_name_first' (if web fired event) or 'mobile_campaign_name_first' (if mobile fired event) from Segment Personas Profile API so we can determine the original campaign name this user arrived from.
 * @param properties.utmCampaignLast: Populated with 'web_campaign_name_last' (if web fired event) or 'mobile_campaign_name_last' (if mobile fired event) from Segment Personas Profile API so we can determine the latest campaign name this user arrived from.
 * @param properties.templateId: This property describes the template ID, as provided by Iterable into the client if the user clicked on an email campaign.
 * @param properties.campaignId: This property describes the campaign ID, as sent by Iterable to the client when a user clicks on a campaign.
 * @param properties.customDestinationAmount_: The amount of money charged to the current user.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.playSubCreated: This trait indicates the start date of the user's current/most recent subscription. See other play_sub properties for more context, or use dw_subscription_datetime_start if you want this more reliably from our Subscription History data warehouse.
 * @param properties.playSubIap: This trait indicates whether the current Play subscription is an In-App Purchase (Native) or not. Value will be true or false. See other play_sub traits for more context.
 * @param properties.playSubPaymentSource: This trait indicates the source of the payment for the user's current Play subscription, e.g. zuora, apple, google, as pulled by clients from backend. See other play_sub traits for more context. Use dw_subscription_system if you want this more reliably from the Subscription History data warehouse.
 * @param properties.playSubSku: This trait indicates the current SKU of this user's Play subscription, as pulled by the client from the backend. See other play_sub traits for more context. Use dw_subscription_sku if you'd like this more reliably from the Subscription History data warehouse.
 * @param properties.playSubStatus: This trait indicates the latest status of the user's Play subscription, e.g. active, pending, cancelled, expired. This is pulled by the client from the backend. See other play_sub traits for more context. Use dw_subscription_status if you'd like this more reliably from the Subscription History data warehouse.
 * @param properties.coupon: Coupon code associated with a product (e.g MAY_DEALS_3). See Segment Ecommerce Spec
 * @param properties.countryCode: This property indicates the two-character country code for the event/transaction.
 * @param properties.paymentMethod: String representing the payment method chosen. See Segment Ecommerce spec for more info.
 * @param properties.timeZoneIdentifier: This property indicates the name of the time zone, e.g. 'America/New_York'
 * @param properties.lastPurchaseCurrency: When a purchase event happens (e.g. Order Completed), fire this user property updated with the currency code from that transaction.
 * @param properties.revenue: Revenue ($) associated with the transaction (excluding shipping and tax). See Segment V2 Ecommerce Spec for more info.
 * @param properties.currency: This property indicates the currency of the transaction. See also 'currency_code'
 * @param properties.currencyCode: This property indicates the currency of the transactions. See also 'currency'.
 * @param properties.price: This property indicates the price ($) of the product being viewed as part of the products array, as defined by the Segment V2 Ecommerce spec. This must always be an integer/float and never a string. (e.g: 8.31)
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 * @param properties.isSubscriptionOffer: This property indicates whether this subscription was started from a special offer screen as part of app onboarding (true) or not (false).
 * @param properties.isPreviouslyFreemium: This property indicates whether the user is upgrading to a paid subscription SKU from a freemium/unpaid SKU (true) or not (false)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Iw3RUNgZkP}
 */
export function completedOrder(properties: CompletedOrderProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Iw3RUNgZkP", "bb9c75a95b522c8c95915a2beb818fc44f940556e905940664adcb65aae97f2e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Completed Order", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "utm_medium_first": properties.utmMediumFirst,
      "utm_medium_last": properties.utmMediumLast,
      "utm_source_first": properties.utmSourceFirst,
      "utm_source_last": properties.utmSourceLast,
      "utm_campaign_first": properties.utmCampaignFirst,
      "utm_campaign_last": properties.utmCampaignLast,
      "templateId": properties.templateId,
      "campaignId": properties.campaignId,
      "coupon": properties.coupon,
      "country_code": properties.countryCode,
      "payment_method": properties.paymentMethod,
      "time_zone_identifier": properties.timeZoneIdentifier,
      "revenue": properties.revenue,
      "currency": properties.currency,
      "currency_code": properties.currencyCode,
      "price": properties.price,
      "sku": properties.sku,
      "is_subscription_offer": properties.isSubscriptionOffer,
      "is_previously_freemium": properties.isPreviouslyFreemium,
      }, {
      "play_sub_created": properties.playSubCreated,
      "play_sub_iap": properties.playSubIap,
      "play_sub_payment_source": properties.playSubPaymentSource,
      "play_sub_sku": properties.playSubSku,
      "play_sub_status": properties.playSubStatus,
      "last_purchase_currency": properties.lastPurchaseCurrency,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Iw3RUNgZkP", "Completed Order", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "hJcSiSbe8l", name: "utm_medium_first", value: properties.utmMediumFirst},
      {id: "YTuW7WAHdN", name: "utm_medium_last", value: properties.utmMediumLast},
      {id: "CE8Su0sB17", name: "utm_source_first", value: properties.utmSourceFirst},
      {id: "XBWpDhypLL", name: "utm_source_last", value: properties.utmSourceLast},
      {id: "cVpj26DI28", name: "utm_campaign_first", value: properties.utmCampaignFirst},
      {id: "XG7iBP1kCI", name: "utm_campaign_last", value: properties.utmCampaignLast},
      {id: "qAEe34O158", name: "templateId", value: properties.templateId},
      {id: "UDxukBwzy9Kw", name: "campaignId", value: properties.campaignId},
      {id: "d7iFm_auAB", name: "coupon", value: properties.coupon},
      {id: "MtjpHq5b4s9w", name: "country_code", value: properties.countryCode},
      {id: "lPTmmvhKnrCD", name: "payment_method", value: properties.paymentMethod},
      {id: "BQFcL7noJd", name: "time_zone_identifier", value: properties.timeZoneIdentifier},
      {id: "t0RLy2nDSpcs", name: "revenue", value: properties.revenue},
      {id: "1_MYPffvd491", name: "currency", value: properties.currency},
      {id: "V_EiSp1cmSEs", name: "currency_code", value: properties.currencyCode},
      {id: "YvsM7OtA55hU", name: "price", value: properties.price},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      {id: "hEFMZNsKxW", name: "is_subscription_offer", value: properties.isSubscriptionOffer},
      {id: "DCtFA8wHo7", name: "is_previously_freemium", value: properties.isPreviouslyFreemium},
      ], [
      {id:"eP_fbgtQi", name: "play_sub_created", value: properties.playSubCreated},
      {id:"4N30t4UOSX", name: "play_sub_iap", value: properties.playSubIap},
      {id:"0kUp9XkLD7", name: "play_sub_payment_source", value: properties.playSubPaymentSource},
      {id:"yXSggu1vw0", name: "play_sub_sku", value: properties.playSubSku},
      {id:"iL8GRqMVH9", name: "play_sub_status", value: properties.playSubStatus},
      {id:"80pbHoW8_l", name: "last_purchase_currency", value: properties.lastPurchaseCurrency},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.utmMediumFirst !== undefined && properties.utmMediumFirst !== null) {
    eventProperties["utm_medium_first"] = properties.utmMediumFirst;
  }
  if (properties.utmMediumLast !== undefined && properties.utmMediumLast !== null) {
    eventProperties["utm_medium_last"] = properties.utmMediumLast;
  }
  if (properties.utmSourceFirst !== undefined && properties.utmSourceFirst !== null) {
    eventProperties["utm_source_first"] = properties.utmSourceFirst;
  }
  if (properties.utmSourceLast !== undefined && properties.utmSourceLast !== null) {
    eventProperties["utm_source_last"] = properties.utmSourceLast;
  }
  if (properties.utmCampaignFirst !== undefined && properties.utmCampaignFirst !== null) {
    eventProperties["utm_campaign_first"] = properties.utmCampaignFirst;
  }
  if (properties.utmCampaignLast !== undefined && properties.utmCampaignLast !== null) {
    eventProperties["utm_campaign_last"] = properties.utmCampaignLast;
  }
  if (properties.templateId !== undefined && properties.templateId !== null) {
    eventProperties["templateId"] = properties.templateId;
  }
  eventProperties["campaignId"] = properties.campaignId;
  if (properties.coupon !== undefined && properties.coupon !== null) {
    eventProperties["coupon"] = properties.coupon;
  }
  if (properties.countryCode !== undefined && properties.countryCode !== null) {
    eventProperties["country_code"] = properties.countryCode;
  }
  if (properties.paymentMethod !== undefined && properties.paymentMethod !== null) {
    eventProperties["payment_method"] = properties.paymentMethod;
  }
  if (properties.timeZoneIdentifier !== undefined && properties.timeZoneIdentifier !== null) {
    eventProperties["time_zone_identifier"] = properties.timeZoneIdentifier;
  }
  if (properties.revenue !== undefined && properties.revenue !== null) {
    eventProperties["revenue"] = properties.revenue;
  }
  if (properties.currency !== undefined && properties.currency !== null) {
    eventProperties["currency"] = properties.currency;
  }
  if (properties.currencyCode !== undefined && properties.currencyCode !== null) {
    eventProperties["currency_code"] = properties.currencyCode;
  }
  eventProperties["price"] = properties.price;
  eventProperties["sku"] = properties.sku;
  if (properties.isSubscriptionOffer !== undefined && properties.isSubscriptionOffer !== null) {
    eventProperties["is_subscription_offer"] = properties.isSubscriptionOffer;
  }
  if (properties.isPreviouslyFreemium !== undefined && properties.isPreviouslyFreemium !== null) {
    eventProperties["is_previously_freemium"] = properties.isPreviouslyFreemium;
  }

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_sub_created"] = properties.playSubCreated;
  userProperties["play_sub_iap"] = properties.playSubIap;
  userProperties["play_sub_payment_source"] = properties.playSubPaymentSource;
  userProperties["play_sub_sku"] = properties.playSubSku;
  userProperties["play_sub_status"] = properties.playSubStatus;
  userProperties["last_purchase_currency"] = properties.lastPurchaseCurrency;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Order", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "utm_medium_first": properties.utmMediumFirst,
        "utm_medium_last": properties.utmMediumLast,
        "utm_source_first": properties.utmSourceFirst,
        "utm_source_last": properties.utmSourceLast,
        "utm_campaign_first": properties.utmCampaignFirst,
        "utm_campaign_last": properties.utmCampaignLast,
        "templateId": properties.templateId,
        "campaignId": properties.campaignId,
        "coupon": properties.coupon,
        "country_code": properties.countryCode,
        "payment_method": properties.paymentMethod,
        "time_zone_identifier": properties.timeZoneIdentifier,
        "revenue": properties.revenue,
        "currency": properties.currency,
        "currency_code": properties.currencyCode,
        "price": properties.price,
        "sku": properties.sku,
        "is_subscription_offer": properties.isSubscriptionOffer,
        "is_previously_freemium": properties.isPreviouslyFreemium,
        }, "Iw3RUNgZkP", "bb9c75a95b522c8c95915a2beb818fc44f940556e905940664adcb65aae97f2e");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Completed Order", (Object as any).assign({}, eventProperties));
    if (PlayWeb.revenue) {
      PlayWeb.revenue(properties.customDestinationAmount_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Revenue method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingTourProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Onboarding Tour: The "onboarding tour" has been displayed to the user. Users see this if they have just completed the onboarding quiz where they pick their instrument and genre.
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/WmRpFrQ5Gy}
 */
export function onboardingTour(properties: OnboardingTourProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WmRpFrQ5Gy", "86f12adc9e03782a7109d55369907c1822300b15fda87281fb04aa3edb5b4f9d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Tour", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WmRpFrQ5Gy", "Onboarding Tour", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionResubscribeProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
  adHeadlinecopy: string | null | undefined;
}
/**
 * Subscription Resubscribe: This event fires when the user views the Resubscribe screen/page. This is shown to authenticated users in a cancelled state, so they can choose a plan to regain access to Play.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/KqTk0LCqBx/trigger/wQRiLo0Le
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/KqTk0LCqBx}
 */
export function subscriptionResubscribe(
  properties: SubscriptionResubscribeProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KqTk0LCqBx", "75031eabd33ed1dcccbaa6a4b73890975c82c132da511930fc79d5bfb573147b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Resubscribe", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "ad_headlinecopy": properties.adHeadlinecopy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KqTk0LCqBx", "Subscription Resubscribe", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionResubscribeAnnualClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  sku: string;
}
/**
 * Subscription Resubscribe Annual Clicked: This event fires when the user clicks the CTA for the Annual Re-subscribe Plan.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/o_ChnjJw4Z}
 */
export function subscriptionResubscribeAnnualClicked(
  properties: SubscriptionResubscribeAnnualClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "o_ChnjJw4Z", "cc2ff2fc831b5cbd0486f189ad66cd5793031f0b28b46c2161ce2b9a141409c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Resubscribe Annual Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("o_ChnjJw4Z", "Subscription Resubscribe Annual Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Resubscribe Annual Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "sku": properties.sku,
        }, "o_ChnjJw4Z", "cc2ff2fc831b5cbd0486f189ad66cd5793031f0b28b46c2161ce2b9a141409c0");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Resubscribe Annual Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionResubscribeMonthlyClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  sku: string;
}
/**
 * Subscription Resubscribe Monthly Clicked: This event fires when the user clicks the CTA for the Monthly Re-subscribe Plan.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2vkZlE2E6G}
 */
export function subscriptionResubscribeMonthlyClicked(
  properties: SubscriptionResubscribeMonthlyClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2vkZlE2E6G", "1a2db09e1d6accbdc0353f4c472c7e9d6c071f58f5edb9a0a1eb3055e4a617c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Resubscribe Monthly Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2vkZlE2E6G", "Subscription Resubscribe Monthly Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Resubscribe Monthly Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "sku": properties.sku,
        }, "2vkZlE2E6G", "1a2db09e1d6accbdc0353f4c472c7e9d6c071f58f5edb9a0a1eb3055e4a617c7");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Resubscribe Monthly Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionResubscribeDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Subscription Resubscribe Dismissed: This event fires when the user backs out of the Re-subscription view, which shows them plans they can choose from to resubscribe to Play. On mobile, this is an "X" in the top right corner; on Web, there is a "back" link in the top-left corner.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/8QYTeaw2be}
 */
export function subscriptionResubscribeDismissed(
  properties: SubscriptionResubscribeDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8QYTeaw2be", "f48da600ab1157fd24b02039728f7c3c25ca4dad465d596578d28ed4065e4b53", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Resubscribe Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8QYTeaw2be", "Subscription Resubscribe Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Resubscribe Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "8QYTeaw2be", "f48da600ab1157fd24b02039728f7c3c25ca4dad465d596578d28ed4065e4b53");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Resubscribe Dismissed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SongsListProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Songs List: This event fires when a user clicks on the “Songs” button in the nav and views the Songs screen
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/PHwKblqLqk}
 */
export function songsList(properties: SongsListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PHwKblqLqk", "78ec4075b338e4e8cb23f4846f010dffc8104ac3bb6377291b1d001ba5025d61", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Songs List", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PHwKblqLqk", "Songs List", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ArticleDetailProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Article Detail: This event fires when an individual article is viewed. On web, this fires into Fender.com, not Fender Play. Formerly "fenderPlay.ArticleView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/DKpGZxHLWo}
 */
export function articleDetail(properties: ArticleDetailProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DKpGZxHLWo", "54b457632965e220168688ba19c47590d0b148a606616c2feaa15b2b4ddf3e20", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Article Detail", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DKpGZxHLWo", "Article Detail", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface MyPathProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * My Path: This event fires when "My Path" is viewed by the user. Formerly "/play/path" or even a specific level, like "/play/path/level-5".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eWkB39nnPA}
 */
export function myPath(properties: MyPathProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eWkB39nnPA", "b61b5304a3e25d526c5ef76e1543e6c468e95ccb63a09663421a9de6a799b3ad", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("My Path", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eWkB39nnPA", "My Path", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ArticlesListProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Articles List: This event fires when the user views the list of articles. Formerly "fenderPlay.ArticlesView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/II0ab9UJpf}
 */
export function articlesList(properties: ArticlesListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "II0ab9UJpf", "3e89c99840d522e0eea108559998942a2cc2c3f218c2854817b5968f36a311c4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Articles List", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("II0ab9UJpf", "Articles List", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SkillsListProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Skills List: This event fires when the user views the list of Skills. Formerly "fenderPlay.SkillsView".
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/gKnrpC9eLe/trigger/KfSUTw-KM
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/gKnrpC9eLe}
 */
export function skillsList(properties: SkillsListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gKnrpC9eLe", "34748ef0c148c0fa9c520a49b67136fc62d378a07069245a1531ccbed451fd64", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Skills List", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gKnrpC9eLe", "Skills List", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface LessonDetailProperties {
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Lesson Detail: This event fires when the user views the detail of a lesson, which usually includes a video and other content. Formerly "fenderPlay.LessonView" or "/play/course/wish-you-were-here-pink-floyd/lesson/wish-you-were-here-pink-floyd".
 *
 * @param properties the properties associatied with this event
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Tpn6q2f9cM}
 */
export function lessonDetail(properties: LessonDetailProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Tpn6q2f9cM", "cc21cd64693f18b37ad91b5aa85653c112e3c6461212d20cef58afa61ecfc258", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Detail", {
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Tpn6q2f9cM", "Lesson Detail", messages, [
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface CourseDetailProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Course Detail: This event fires when the user views the detail of a course. Formerly "fenderPlay.CourseView".
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/o_a8wGyotQ}
 */
export function courseDetail(properties: CourseDetailProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "o_a8wGyotQ", "7265258bbb64a157024408835982ee770a369ed0acd4275aff91008de2f42ab9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Course Detail", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("o_a8wGyotQ", "Course Detail", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingInstrumentPickerProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Onboarding Instrument Picker: This event fires when the user views the screen to pick their instrument for their initial path setting during the onboarding process. Formerly "fenderPlay.ChooseInstrumentQuiz" or "Onboarding Quiz Instrument".
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Yq9IRFGmZ2}
 */
export function onboardingInstrumentPicker(
  properties: OnboardingInstrumentPickerProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Yq9IRFGmZ2", "1dc9dd87a846173241ff2c6222e623b3c15b0ddfa4c9aea0910c27e21b80138a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Instrument Picker", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Yq9IRFGmZ2", "Onboarding Instrument Picker", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingStylePickerProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Onboarding Style Picker: This event fires when the user views the screen to pick their genre/style for their initial path (if applicable) as part of the onboarding flow. Formerly "fenderPlay.ChooseStyleQuiz".
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ztpMyE9yAL}
 */
export function onboardingStylePicker(
  properties: OnboardingStylePickerProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ztpMyE9yAL", "248a01ddc8d37443f76b749a2c89a18f23db0482f01dccf2b677e23c38b05cd9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Style Picker", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ztpMyE9yAL", "Onboarding Style Picker", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ChordsListProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
  instrument: InstrumentValueType;
}
/**
 * Chords List: This event fires when the user views a list of all chords for an instrument from the Skills section. Formerly "fenderPlay.AllChordsView".
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2qMmAHZr9k/trigger/MkFsEk_O8
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2qMmAHZr9k}
 */
export function chordsList(properties: ChordsListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2qMmAHZr9k", "c5d716ba7e500acb492577b571a923fac36de8b8a908bc4257b960d0fcd7d523", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Chords List", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "instrument": properties.instrument,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2qMmAHZr9k", "Chords List", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["instrument"] = properties.instrument;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ChordChallengeListProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Chord Challenge List: This event fires when the user views the list of Chord Challenges content. Formerly "fenderPlay.ChordChallengesView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/9AzBhTnxRK}
 */
export function chordChallengeList(properties: ChordChallengeListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9AzBhTnxRK", "6e6ff919cd4e1ed9d7d829a5b6e4bc86653756cda2511c20a6b900a663cbaa33", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Chord Challenge List", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9AzBhTnxRK", "Chord Challenge List", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ChordChallengeDetailProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Chord Challenge Detail: This event fires when the user views the details of a chord challenge. Formerly "fenderPlay.ChordChallengeView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/tpBXg75Lqw}
 */
export function chordChallengeDetail(
  properties: ChordChallengeDetailProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tpBXg75Lqw", "28ad44798a5b87523405dab3e625675943fdb61d9079884f82e96002ceecfbd6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Chord Challenge Detail", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tpBXg75Lqw", "Chord Challenge Detail", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ChordChallengePickerProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Chord Challenge Picker: This event fires when the user views the chord selection view as part of the chord challenge activity. Formerly "fenderPlay.ChooseProgressionView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/W4qOv6ZgtH}
 */
export function chordChallengePicker(
  properties: ChordChallengePickerProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "W4qOv6ZgtH", "b125dc50891f7c35f9517040535916bdbbdf5b21f91e55dccb7e6350f82bcba1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Chord Challenge Picker", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("W4qOv6ZgtH", "Chord Challenge Picker", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface ChordChallengeTourProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Chord Challenge Tour: This event fires when the user views the chord challenge introduction tour carousel. Formerly "fenderPlay.ChordChallengeOnboarding".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TFC_Eq4Cua}
 */
export function chordChallengeTour(properties: ChordChallengeTourProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "TFC_Eq4Cua", "5934b5619466c90e7c58c23eb2b340002e19e35ccd1da87f82b1c45fef93a055", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Chord Challenge Tour", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("TFC_Eq4Cua", "Chord Challenge Tour", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface MyAccountProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * My Account: This event fires when the user views "My Account". Note that on web, this fires into Fender Connect, not Fender Play. Formerly "fenderPlay.MyAccountView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/dKzZxzaeCM}
 */
export function myAccount(properties: MyAccountProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "dKzZxzaeCM", "fca136a25564683d31f23bcb5cb58f1d70b79509f2faee44d90483993823d249", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("My Account", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("dKzZxzaeCM", "My Account", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface CollectionsListProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Collections List: This event fires when a user views the list of collections of courses/lessons/content. Formerly "fenderPlay.CollectionsView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/VKa87s_ua2}
 */
export function collectionsList(properties: CollectionsListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VKa87s_ua2", "1e1646860ce51f0b1dc3c5a2035fb74085037d38a41060430b228bdfa5cce101", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Collections List", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VKa87s_ua2", "Collections List", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface CollectionDetailProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Collection Detail: This event fires when a user views the details of a collection of courses/lessons/content. Formerly "fenderPlay.CollectionDetailView".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/kOvtQOTeac}
 */
export function collectionDetail(properties: CollectionDetailProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kOvtQOTeac", "efa04e0f57d1dcac3e9925208b4a69d614d5a824caf7742e06fcd439741f6bbf", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Collection Detail", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kOvtQOTeac", "Collection Detail", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SearchResultsProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Search Results: This event is fired when the user views search results. Formerly fenderPlay.SearchPanelContainer.
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/L25Ovmt0AO}
 */
export function searchResults(properties: SearchResultsProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "L25Ovmt0AO", "0fa68b041028cb6e38de2b7a983aba4c67d3791ced1e2411e6e17d9bc00c3493", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Results", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("L25Ovmt0AO", "Search Results", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FavoritesListProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Favorites List: This event fires when the user views the list of their favorites. Formerly fenderPlay.Favorites.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ZoJMXmAp9I}
 */
export function favoritesList(properties: FavoritesListProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZoJMXmAp9I", "def9fbccf4672dd6b81e142863573b4815ec37f712bb16081bc8118838463e38", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Favorites List", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZoJMXmAp9I", "Favorites List", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FavoritesListFilterPickerProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Favorites List Filter Picker: This event fires when a user views the filter/options for the filtering when viewing their list of Favorites. Formerly fenderPlay.FavoritesFiltersView.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-VLVVxtk-8}
 */
export function favoritesListFilterPicker(
  properties: FavoritesListFilterPickerProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-VLVVxtk-8", "e0428a035c5504a5d5d70b13ccf2f80c3b0afbc5a2a566ded09ec58968a714c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Favorites List Filter Picker", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-VLVVxtk-8", "Favorites List Filter Picker", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FavoritesAlertProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Favorites Alert: This event fires when the popup message that an item has been added to, or removed from, favorites is displayed to the user. Formerly fenderPlay.FavoritesAlert.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/8_NO7lAxic}
 */
export function favoritesAlert(properties: FavoritesAlertProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8_NO7lAxic", "3c2e65ceea4720492cbc40f67c7bf1bdcbe88686a938cbb17d257a4b91387b5c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Favorites Alert", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8_NO7lAxic", "Favorites Alert", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface StreaksModalProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Streaks Modal: This event fires when a user taps on the streaks icon to learn more, or is awarded a streak. Formerly "fenderPlay.StreaksModal".
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/0cTjh2vcV0}
 */
export function streaksModal(properties: StreaksModalProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0cTjh2vcV0", "7ea81bfff4e51be9c6c61bbdae6ecb8a0bd9dd940f205a8e4cad0e69699e73ab", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Streaks Modal", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0cTjh2vcV0", "Streaks Modal", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface PracticeModeProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  customDestinationPageName_: string;
  practiceSheetId: string;
  practiceSheetSlug: string;
  practiceSheetTitle: string;
}
/**
 * Practice Mode: This event fires when the user views a practice mode (scrolling tablature feature). Formerly "fenderPlay.PracticeSheets". See also "Practice Mode Launched".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.practiceSheetSlug: The URL slug of the Practice Sheet object.
 * @param properties.practiceSheetTitle: The title/name of the Practice Sheet object.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/9IU0_d4FH7}
 */
export function practiceMode(properties: PracticeModeProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9IU0_d4FH7", "f428a0e2177d7564e4c4d78e97938e4bdca8520accbf3ca01abee58fa9f585fc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Practice Mode", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "practice_sheet_id": properties.practiceSheetId,
      "practice_sheet_slug": properties.practiceSheetSlug,
      "practice_sheet_title": properties.practiceSheetTitle,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9IU0_d4FH7", "Practice Mode", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "yXTt08qnhNIn", name: "practice_sheet_slug", value: properties.practiceSheetSlug},
      {id: "5r0YaYOdTY7x", name: "practice_sheet_title", value: properties.practiceSheetTitle},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  eventProperties["practice_sheet_id"] = properties.practiceSheetId;
  eventProperties["practice_sheet_slug"] = properties.practiceSheetSlug;
  eventProperties["practice_sheet_title"] = properties.practiceSheetTitle;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface TablatureFullscreenProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Tablature Fullscreen: This event fires when the user views tablature for a lesson as "fullscreen". This is different from Practice Mode. Formerly "fenderPlay.TabFullscreen".
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/DiYjN-Grdm}
 */
export function tablatureFullscreen(properties: TablatureFullscreenProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DiYjN-Grdm", "8de9eb4336880ed01c7fb944a4c3c6851822c374dccbc3bc1455dae97b062794", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tablature Fullscreen", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DiYjN-Grdm", "Tablature Fullscreen", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface MarkAsCompleteModalProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Mark as Complete Modal: Deprecated on Mobile: being removed.
This event fires when the user is shown a modal asking to confirm marking an object/piece of content as complete or not. Formerly "fenderPlay.MarkAsCompletePreferenceModal"
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/IaieTecS28}
 */
export function markAsCompleteModal(properties: MarkAsCompleteModalProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "IaieTecS28", "62706bf1b5eba39a2f3c7ee68aa1cd7c64c27772d7021e9a56b82d754f38e25b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Mark as Complete Modal", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("IaieTecS28", "Mark as Complete Modal", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface CheckoutStartedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  cartId: string | null | undefined;
  step: number | null | undefined;
  value: number | null | undefined;
}
/**
 * Checkout Started: This event fires when a user reaches a plan selection page or screen (e.g. Special Offer, Upgrade, Resubscribe) as a way of simulating an eComm shopping cart type flow. Product information may remain null until Completed Order fires.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.cartId: This property indicates the Cart ID to which the product was added to for this transaction.
 * @param properties.step: The current step/page that a user is seeing in a UI component like the Onboarding Tour or a step in a checkout process. Used to track how many of the total steps/pages a user sees.
 * @param properties.value: Total value of the product after quantity. Should be '0' for Trial Started. See Segment Ecommerce spec for more info.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2PvLIKgwABd}
 */
export function checkoutStarted(properties: CheckoutStartedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2PvLIKgwABd", "6bcc42796e6e2745258e659edf4b4861d3cd8fba5f8c50f53713e9240e2dc668", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Checkout Started", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "cart_id": properties.cartId,
      "step": properties.step,
      "value": properties.value,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2PvLIKgwABd", "Checkout Started", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "GJLSI4WrDu", name: "cart_id", value: properties.cartId},
      {id: "oh6t-j8ZgC", name: "step", value: properties.step},
      {id: "X3hxIVYvmu", name: "value", value: properties.value},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.cartId !== undefined && properties.cartId !== null) {
    eventProperties["cart_id"] = properties.cartId;
  }
  if (properties.step !== undefined && properties.step !== null) {
    eventProperties["step"] = properties.step;
  }
  if (properties.value !== undefined && properties.value !== null) {
    eventProperties["value"] = properties.value;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Started", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "cart_id": properties.cartId,
        "step": properties.step,
        "value": properties.value,
        }, "2PvLIKgwABd", "6bcc42796e6e2745258e659edf4b4861d3cd8fba5f8c50f53713e9240e2dc668");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Checkout Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CourseClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  songName: string | null | undefined;
  artistName: string | null | undefined;
  collectionName: string | null | undefined;
  collectionId: string | null | undefined;
}
/**
 * Course Clicked: This event is fired when a user clicks to launch a course. Formerly "Course Click".
 *
 * When to trigger this event:
 * 1. Top course should have is_locked = false, and bottom could should have is_locked = true
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/e0Pt8XUhFsig/trigger/mtMozR7kf
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.songName: This property indicates the name of the song related to this event.
 * @param properties.artistName: This property indicates the artist name related to this event.
 * @param properties.collectionName: The name of the Collection the user navigated through to reach this activity.
 * @param properties.collectionId: The object ID of the Collection the user navigated through to reach this activity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/e0Pt8XUhFsig}
 */
export function courseClicked(properties: CourseClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "e0Pt8XUhFsig", "127840982a57f82b7db0b9cc80312e3e520dcb81bf8802cb1d0ab4b793e6f5ee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Course Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "song_name": properties.songName,
      "artist_name": properties.artistName,
      "collection_name": properties.collectionName,
      "collection_id": properties.collectionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("e0Pt8XUhFsig", "Course Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "QnMiQTBryI", name: "song_name", value: properties.songName},
      {id: "OGv5NKrj3m", name: "artist_name", value: properties.artistName},
      {id: "lOwu9g624k-t", name: "collection_name", value: properties.collectionName},
      {id: "eoTgwiC_8ygd", name: "collection_id", value: properties.collectionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.songName !== undefined && properties.songName !== null) {
    eventProperties["song_name"] = properties.songName;
  }
  if (properties.artistName !== undefined && properties.artistName !== null) {
    eventProperties["artist_name"] = properties.artistName;
  }
  if (properties.collectionName !== undefined && properties.collectionName !== null) {
    eventProperties["collection_name"] = properties.collectionName;
  }
  if (properties.collectionId !== undefined && properties.collectionId !== null) {
    eventProperties["collection_id"] = properties.collectionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Course Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "song_name": properties.songName,
        "artist_name": properties.artistName,
        "collection_name": properties.collectionName,
        "collection_id": properties.collectionId,
        }, "e0Pt8XUhFsig", "127840982a57f82b7db0b9cc80312e3e520dcb81bf8802cb1d0ab4b793e6f5ee");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Course Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WatchedVideoProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string | null | undefined;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType | null | undefined;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType | null | undefined;
  collectionName: string | null | undefined;
  collectionId: string | null | undefined;
  locale: string | null | undefined;
  timeZone: string | null | undefined;
  watchedTo: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  watchedToSeconds: number | null | undefined;
  lesson: string;
  lessonTitle: string;
}
/**
 * Watched Video: This event fires when a user passes a certain timestamp (0%, 20 seconds, 30 seconds, 25%, 50%, 75%, 100%) on any video (e.g. lesson video, demo video) during playback. It is very critical for royalty reporting.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.collectionName: The name of the Collection the user navigated through to reach this activity.
 * @param properties.collectionId: The object ID of the Collection the user navigated through to reach this activity.
 * @param properties.locale: This property indicates the user's locale (language & country code) when this event fires. Web only.
 * @param properties.timeZone: This property indicates the user's time zone set when this event fires. Web only. Should be renamed to 'timezone' someday.
 * @param properties.watchedTo: This property indicates the quartile percentage (e.g. 25, 50, 75, 100) of the video watched at this time this event is fired. We hope to deprecate this someday in preference for watchedto_percentage.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.lesson: This is the lesson name, currently sent by Play Web, and used in royalty reporting. We will eventually need to switch this to lesson_name instead. Equivalent on Play Mobile is lessonTitle.
 * @param properties.lessonTitle: This is the lesson name, currently sent by Play Mobile, and used in royalty reporting. We will eventually need to switch this to lesson_name instead. Equivalent on Play Web is lesson.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/C9apWAdZqI7L}
 */
export function watchedVideo(properties: WatchedVideoProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "C9apWAdZqI7L", "30a1da4b3693dad226d6c7a1542c7ca15474a3600fdde81e2cfde56e9ef32a60", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Watched Video", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "collection_name": properties.collectionName,
      "collection_id": properties.collectionId,
      "locale": properties.locale,
      "timeZone": properties.timeZone,
      "watchedTo": properties.watchedTo,
      "watched_to_percentage": properties.watchedToPercentage,
      "watched_to_seconds": properties.watchedToSeconds,
      "lesson": properties.lesson,
      "lessonTitle": properties.lessonTitle,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("C9apWAdZqI7L", "Watched Video", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "lOwu9g624k-t", name: "collection_name", value: properties.collectionName},
      {id: "eoTgwiC_8ygd", name: "collection_id", value: properties.collectionId},
      {id: "Hegu4YQyDCM7", name: "locale", value: properties.locale},
      {id: "U00SL5vA5-XG", name: "timeZone", value: properties.timeZone},
      {id: "n4p_FyzbXC30", name: "watchedTo", value: properties.watchedTo},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "k8UAnAgVmj", name: "lesson", value: properties.lesson},
      {id: "EJpFw5DVL_", name: "lessonTitle", value: properties.lessonTitle},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.courseId !== undefined && properties.courseId !== null) {
    eventProperties["course_id"] = properties.courseId;
  }
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventProperties["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  if (properties.playlist !== undefined && properties.playlist !== null) {
    eventProperties["playlist"] = properties.playlist;
  }
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventProperties["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventProperties["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  if (properties.genre !== undefined && properties.genre !== null) {
    eventProperties["genre"] = properties.genre;
  }
  if (properties.collectionName !== undefined && properties.collectionName !== null) {
    eventProperties["collection_name"] = properties.collectionName;
  }
  if (properties.collectionId !== undefined && properties.collectionId !== null) {
    eventProperties["collection_id"] = properties.collectionId;
  }
  if (properties.locale !== undefined && properties.locale !== null) {
    eventProperties["locale"] = properties.locale;
  }
  if (properties.timeZone !== undefined && properties.timeZone !== null) {
    eventProperties["timeZone"] = properties.timeZone;
  }
  if (properties.watchedTo !== undefined && properties.watchedTo !== null) {
    eventProperties["watchedTo"] = properties.watchedTo;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  eventProperties["lesson"] = properties.lesson;
  eventProperties["lessonTitle"] = properties.lessonTitle;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Watched Video", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "collection_name": properties.collectionName,
        "collection_id": properties.collectionId,
        "locale": properties.locale,
        "timeZone": properties.timeZone,
        "watchedTo": properties.watchedTo,
        "watched_to_percentage": properties.watchedToPercentage,
        "watched_to_seconds": properties.watchedToSeconds,
        "lesson": properties.lesson,
        "lessonTitle": properties.lessonTitle,
        }, "C9apWAdZqI7L", "30a1da4b3693dad226d6c7a1542c7ca15474a3600fdde81e2cfde56e9ef32a60");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Watched Video", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  searchText: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Search Completed: This event fires when a user clicks on the search button or hits enter to perform a search for their entered terms. Formerly "Completed Search".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.searchText: This property indicates the search term typed by the user when performing a search.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/oU69Y7JWEF4F}
 */
export function searchCompleted(properties: SearchCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oU69Y7JWEF4F", "1420300177932e3fefe0b83d776f020c2c3c084e314dbe8b06f9268bf4c4ff52", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "search_text": properties.searchText,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oU69Y7JWEF4F", "Search Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "jRzjRkfVYAXF", name: "search_text", value: properties.searchText},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.searchText !== undefined && properties.searchText !== null) {
    eventPropertiesPlayWeb["search_text"] = properties.searchText;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "search_text": properties.searchText,
        "siteId": properties.siteidLegacy,
        }, "oU69Y7JWEF4F", "1420300177932e3fefe0b83d776f020c2c3c084e314dbe8b06f9268bf4c4ff52");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Search Completed", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface TablatureCollapsedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
}
/**
 * Tablature Collapsed: This event fires when a user collapses fullscreened tablature on a lesson. Formerly "Tablature Collapse". See also "Tablature Expanded".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/jqxOeXumdI4s}
 */
export function tablatureCollapsed(properties: TablatureCollapsedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "jqxOeXumdI4s", "29d746bab66d2fcf142f4fbff06951666e61e600d4261ac8d495e575adf8798a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tablature Collapsed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("jqxOeXumdI4s", "Tablature Collapsed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tablature Collapsed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        }, "jqxOeXumdI4s", "29d746bab66d2fcf142f4fbff06951666e61e600d4261ac8d495e575adf8798a");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Tablature Collapsed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TablatureExpandedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
}
/**
 * Tablature Expanded: User expands fullscreen tablature
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/bCVd3BjuJi0a}
 */
export function tablatureExpanded(properties: TablatureExpandedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bCVd3BjuJi0a", "67278aa9b94c2180453efca5c8283973644a9fd28650052e294d2b67220cb723", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tablature Expanded", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bCVd3BjuJi0a", "Tablature Expanded", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tablature Expanded", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        }, "bCVd3BjuJi0a", "67278aa9b94c2180453efca5c8283973644a9fd28650052e294d2b67220cb723");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Tablature Expanded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonChordsClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Chords Clicked: User clicked on "Chords" button from within a lesson view. Formerly "Selected Chords".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/l4T6FbGMhZyv}
 */
export function lessonChordsClicked(properties: LessonChordsClickedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "l4T6FbGMhZyv", "9e35749cefcadeb988b08688c44d8b5db75b195a6f304b9cfe963bc07d729aa8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Chords Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("l4T6FbGMhZyv", "Lesson Chords Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Chords Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "l4T6FbGMhZyv", "9e35749cefcadeb988b08688c44d8b5db75b195a6f304b9cfe963bc07d729aa8");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Chords Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface VideoPlaybackBufferCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
}
/**
 * Video Playback Buffer Completed: This event fires when playback finishes buffering content or a preroll ad.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/IZUpZQpVYMkq}
 */
export function videoPlaybackBufferCompleted(
  properties: VideoPlaybackBufferCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "IZUpZQpVYMkq", "0d0d3f7172117cf47673e1d83a584bf78dddb1204ebc48d6e9b6a23cfe684f66", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Playback Buffer Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("IZUpZQpVYMkq", "Video Playback Buffer Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Playback Buffer Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        }, "IZUpZQpVYMkq", "0d0d3f7172117cf47673e1d83a584bf78dddb1204ebc48d6e9b6a23cfe684f66");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Playback Buffer Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayerBack10Properties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  timestampFrom: string | null | undefined;
  timestampTo: string | null | undefined;
}
/**
 * Video Player Back 10: This event fires when the user clicks on button in video player chrome to skip back 10 seconds.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.timestampFrom: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.timestampTo: This property provides video playback information. See the Segment Video Spec for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2zUhsShatNcE}
 */
export function videoPlayerBack10(properties: VideoPlayerBack10Properties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2zUhsShatNcE", "fcf314130052c678d6627db88ff0407fc6892da452ecd218beb69bfd89b2b019", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Player Back 10", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "timestamp_from": properties.timestampFrom,
      "timestamp_to": properties.timestampTo,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2zUhsShatNcE", "Video Player Back 10", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "1tpa8FsoMBcE", name: "timestamp_from", value: properties.timestampFrom},
      {id: "Hc2F3KH_A_5u", name: "timestamp_to", value: properties.timestampTo},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  if (properties.timestampFrom !== undefined && properties.timestampFrom !== null) {
    eventProperties["timestamp_from"] = properties.timestampFrom;
  }
  if (properties.timestampTo !== undefined && properties.timestampTo !== null) {
    eventProperties["timestamp_to"] = properties.timestampTo;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Player Back 10", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "timestamp_from": properties.timestampFrom,
        "timestamp_to": properties.timestampTo,
        }, "2zUhsShatNcE", "fcf314130052c678d6627db88ff0407fc6892da452ecd218beb69bfd89b2b019");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Player Back 10", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayerForward10Properties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  timestampFrom: string | null | undefined;
  timestampTo: string | null | undefined;
}
/**
 * Video Player Forward 10: This event fires when the user clicks on button in video player chrome to skip ahead 10 seconds.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.timestampFrom: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.timestampTo: This property provides video playback information. See the Segment Video Spec for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/HVvquwtC3Yh1}
 */
export function videoPlayerForward10(
  properties: VideoPlayerForward10Properties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HVvquwtC3Yh1", "8f7b258d329b24ebca42460985e5ed93066c65898d1a576b0c9c69abf5e4e38d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Player Forward 10", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "timestamp_from": properties.timestampFrom,
      "timestamp_to": properties.timestampTo,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HVvquwtC3Yh1", "Video Player Forward 10", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "1tpa8FsoMBcE", name: "timestamp_from", value: properties.timestampFrom},
      {id: "Hc2F3KH_A_5u", name: "timestamp_to", value: properties.timestampTo},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  if (properties.timestampFrom !== undefined && properties.timestampFrom !== null) {
    eventProperties["timestamp_from"] = properties.timestampFrom;
  }
  if (properties.timestampTo !== undefined && properties.timestampTo !== null) {
    eventProperties["timestamp_to"] = properties.timestampTo;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Player Forward 10", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "timestamp_from": properties.timestampFrom,
        "timestamp_to": properties.timestampTo,
        }, "HVvquwtC3Yh1", "8f7b258d329b24ebca42460985e5ed93066c65898d1a576b0c9c69abf5e4e38d");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Player Forward 10", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayerScrubBackwardProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  timestampFrom: string | null | undefined;
  timestampTo: string | null | undefined;
}
/**
 * Video Player Scrub Backward: This event is fired when the user clicks behind the playhead in the video player scrub bar, presumably to return to an area they've already watched in order to repeat it.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.timestampFrom: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.timestampTo: This property provides video playback information. See the Segment Video Spec for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/gTXLHNzBTMtX}
 */
export function videoPlayerScrubBackward(
  properties: VideoPlayerScrubBackwardProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gTXLHNzBTMtX", "b070cf6ef2bde90488d76618ddeddda93fa6f77b69fb0902811277b1c0a501b3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Player Scrub Backward", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "timestamp_from": properties.timestampFrom,
      "timestamp_to": properties.timestampTo,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gTXLHNzBTMtX", "Video Player Scrub Backward", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "1tpa8FsoMBcE", name: "timestamp_from", value: properties.timestampFrom},
      {id: "Hc2F3KH_A_5u", name: "timestamp_to", value: properties.timestampTo},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  if (properties.timestampFrom !== undefined && properties.timestampFrom !== null) {
    eventProperties["timestamp_from"] = properties.timestampFrom;
  }
  if (properties.timestampTo !== undefined && properties.timestampTo !== null) {
    eventProperties["timestamp_to"] = properties.timestampTo;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Player Scrub Backward", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "timestamp_from": properties.timestampFrom,
        "timestamp_to": properties.timestampTo,
        }, "gTXLHNzBTMtX", "b070cf6ef2bde90488d76618ddeddda93fa6f77b69fb0902811277b1c0a501b3");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Player Scrub Backward", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayerScrubForwardProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  timestampFrom: string | null | undefined;
  timestampTo: string | null | undefined;
}
/**
 * Video Player Scrub Forward: This event is fired when the user selects an area in the scrub bar ahead of the playhead, presumably to skip ahead.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.timestampFrom: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.timestampTo: This property provides video playback information. See the Segment Video Spec for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/pV6Bdn4PqjhF}
 */
export function videoPlayerScrubForward(
  properties: VideoPlayerScrubForwardProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pV6Bdn4PqjhF", "25cb0720fcb3a5e6f2b6e6f372c66e6afedb08599bce17f19de25dd94495abe6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Player Scrub Forward", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "timestamp_from": properties.timestampFrom,
      "timestamp_to": properties.timestampTo,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pV6Bdn4PqjhF", "Video Player Scrub Forward", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "1tpa8FsoMBcE", name: "timestamp_from", value: properties.timestampFrom},
      {id: "Hc2F3KH_A_5u", name: "timestamp_to", value: properties.timestampTo},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  if (properties.timestampFrom !== undefined && properties.timestampFrom !== null) {
    eventProperties["timestamp_from"] = properties.timestampFrom;
  }
  if (properties.timestampTo !== undefined && properties.timestampTo !== null) {
    eventProperties["timestamp_to"] = properties.timestampTo;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Player Scrub Forward", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "timestamp_from": properties.timestampFrom,
        "timestamp_to": properties.timestampTo,
        }, "pV6Bdn4PqjhF", "25cb0720fcb3a5e6f2b6e6f372c66e6afedb08599bce17f19de25dd94495abe6");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Player Scrub Forward", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CollectionClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  collectionId: string | null | undefined;
  collectionName: string | null | undefined;
  countryCode: string | null | undefined;
}
/**
 * Collection Clicked: This event fires when a user clicks to view a Collection of content, going from the Collection List to a Collection Detail. Formerly "collection_clicked".
 *
 * When to trigger this event:
 * 1. User clicks on a collection from the Collection List screen
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Abf5X5BqCddx/trigger/jB_w0OVof
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.collectionId: The object ID of the Collection the user navigated through to reach this activity.
 * @param properties.collectionName: The name of the Collection the user navigated through to reach this activity.
 * @param properties.countryCode: This property indicates the two-character country code for the event/transaction.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Abf5X5BqCddx}
 */
export function collectionClicked(properties: CollectionClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Abf5X5BqCddx", "65eb5719d30924144b5cad5b99e5d15dd73f0c7d58e7986e909d89f1a6e50cf4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Collection Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "collection_id": properties.collectionId,
      "collection_name": properties.collectionName,
      "country_code": properties.countryCode,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Abf5X5BqCddx", "Collection Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "eoTgwiC_8ygd", name: "collection_id", value: properties.collectionId},
      {id: "lOwu9g624k-t", name: "collection_name", value: properties.collectionName},
      {id: "MtjpHq5b4s9w", name: "country_code", value: properties.countryCode},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.collectionId !== undefined && properties.collectionId !== null) {
    eventProperties["collection_id"] = properties.collectionId;
  }
  if (properties.collectionName !== undefined && properties.collectionName !== null) {
    eventProperties["collection_name"] = properties.collectionName;
  }
  if (properties.countryCode !== undefined && properties.countryCode !== null) {
    eventProperties["country_code"] = properties.countryCode;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Collection Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "collection_id": properties.collectionId,
        "collection_name": properties.collectionName,
        "country_code": properties.countryCode,
        }, "Abf5X5BqCddx", "65eb5719d30924144b5cad5b99e5d15dd73f0c7d58e7986e909d89f1a6e50cf4");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Collection Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CollectionCourseClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  collectionId: string | null | undefined;
  collectionName: string | null | undefined;
}
/**
 * Collection Course Clicked: This event fires when a user clicks on a Course from within a Collection view. Formerly "collection_course_clicked".
 *
 * When to trigger this event:
 * 1. User clicks on the course card from the Collection detail screen
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/7tylo0o4TznJ/trigger/vRQKo8qgI
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.collectionId: The object ID of the Collection the user navigated through to reach this activity.
 * @param properties.collectionName: The name of the Collection the user navigated through to reach this activity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/7tylo0o4TznJ}
 */
export function collectionCourseClicked(
  properties: CollectionCourseClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7tylo0o4TznJ", "2c5415dc41b26930f66204a2a0af567721822006fe3d694f674c9eeb6e86da01", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Collection Course Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "collection_id": properties.collectionId,
      "collection_name": properties.collectionName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7tylo0o4TznJ", "Collection Course Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "eoTgwiC_8ygd", name: "collection_id", value: properties.collectionId},
      {id: "lOwu9g624k-t", name: "collection_name", value: properties.collectionName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.collectionId !== undefined && properties.collectionId !== null) {
    eventProperties["collection_id"] = properties.collectionId;
  }
  if (properties.collectionName !== undefined && properties.collectionName !== null) {
    eventProperties["collection_name"] = properties.collectionName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Collection Course Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "collection_id": properties.collectionId,
        "collection_name": properties.collectionName,
        }, "7tylo0o4TznJ", "2c5415dc41b26930f66204a2a0af567721822006fe3d694f674c9eeb6e86da01");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Collection Course Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CourseMarkedAsCompleteProperties {
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType | null | undefined;
  userId_: string;
  isOnPath: boolean | null | undefined;
  videoId: string | null | undefined;
  playListId: string | null | undefined;
  siteidLegacy: string | null | undefined;
  playActivitiesIncourseCompleted: number;
  playCoursesInlevelCompleted: number;
  playLevelsInpathCompleted: number;
}
/**
 * Course Marked as Complete: This event fires when a user explicitly marks a Course as "Complete". Formerly "course_mark_as_complete".
 *
 * @param properties the properties associatied with this event
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.isOnPath: This property indicates whether this action was performed to a piece of content within the context of a user's path or not.
 * @param properties.videoId: This property indicates the ID of the video associated with this action.
 * @param properties.playListId: This is an incorrectly formatted property. Please pass playlist_id ONLY instead, the next time this is worked on.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 * @param properties.playActivitiesIncourseCompleted: This user trait indicates the total amount of activities (video lesson, practice mode, feedback mode) the user has completed within their active course, as provided by the backend. Could be used with play_activities_incourse_total to calculate a percentage.
 * @param properties.playCoursesInlevelCompleted: This user trait indicates the number of completed courses within the users' active level, as pulled from the backend. Could be used with play_courses_inlevel_total to calculate a percentage.
 * @param properties.playLevelsInpathCompleted: This user trait indicates the amount of levels within a path that this user has fully completed, as pulled from the backend. Please update every time the user switches levels, either actively or passively.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/IGuhspr5wks6}
 */
export function courseMarkedAsComplete(
  properties: CourseMarkedAsCompleteProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "IGuhspr5wks6", "3f8f42f8a5150ff0dbf878a74b56435f8ef0c5de3145e26aa2982bdf216377b5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Course Marked as Complete", {
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "is_on_path": properties.isOnPath,
      "video_id": properties.videoId,
      "play_list_id": properties.playListId,
      "siteId": properties.siteidLegacy,
      }, {
      "play_activities_incourse_completed": properties.playActivitiesIncourseCompleted,
      "play_courses_inlevel_completed": properties.playCoursesInlevelCompleted,
      "play_levels_inpath_completed": properties.playLevelsInpathCompleted,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("IGuhspr5wks6", "Course Marked as Complete", messages, [
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "Q4hiTa0pVJxi", name: "is_on_path", value: properties.isOnPath},
      {id: "2nuQGFmwvEx3", name: "video_id", value: properties.videoId},
      {id: "qH1yAE0tO-", name: "play_list_id", value: properties.playListId},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], [
      {id:"ncFNXtyhlk", name: "play_activities_incourse_completed", value: properties.playActivitiesIncourseCompleted},
      {id:"MRGVziVa4A", name: "play_courses_inlevel_completed", value: properties.playCoursesInlevelCompleted},
      {id:"yJI1ZxM7xy", name: "play_levels_inpath_completed", value: properties.playLevelsInpathCompleted},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  eventPropertiesPlayWeb["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventPropertiesPlayWeb["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventPropertiesPlayWeb["course_name"] = properties.courseName;
  }
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.lessonId !== undefined && properties.lessonId !== null) {
    eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  }
  if (properties.lessonSlug !== undefined && properties.lessonSlug !== null) {
    eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  }
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventPropertiesPlayWeb["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventPropertiesPlayWeb["instrument"] = properties.instrument;
  }
  eventPropertiesPlayWeb["playlist"] = properties.playlist;
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventPropertiesPlayWeb["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventPropertiesPlayWeb["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventPropertiesPlayWeb["path_id"] = properties.pathId;
  }
  if (properties.genre !== undefined && properties.genre !== null) {
    eventPropertiesPlayWeb["genre"] = properties.genre;
  }
  if (properties.isOnPath !== undefined && properties.isOnPath !== null) {
    eventPropertiesPlayWeb["is_on_path"] = properties.isOnPath;
  }
  if (properties.videoId !== undefined && properties.videoId !== null) {
    eventPropertiesPlayWeb["video_id"] = properties.videoId;
  }
  if (properties.playListId !== undefined && properties.playListId !== null) {
    eventPropertiesPlayWeb["play_list_id"] = properties.playListId;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};
  userPropertiesPlayWeb["play_activities_incourse_completed"] = properties.playActivitiesIncourseCompleted;
  userPropertiesPlayWeb["play_courses_inlevel_completed"] = properties.playCoursesInlevelCompleted;
  userPropertiesPlayWeb["play_levels_inpath_completed"] = properties.playLevelsInpathCompleted;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Course Marked as Complete", {
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "is_on_path": properties.isOnPath,
        "video_id": properties.videoId,
        "play_list_id": properties.playListId,
        "siteId": properties.siteidLegacy,
        }, "IGuhspr5wks6", "3f8f42f8a5150ff0dbf878a74b56435f8ef0c5de3145e26aa2982bdf216377b5");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userPropertiesPlayWeb));
    PlayWeb.logEvent("Course Marked as Complete", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface CourseUnmarkedAsCompleteProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  path: PathValueType | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  playlist: PlaylistValueType;
  playlistId: string | null | undefined;
  level: string | null | undefined;
  pathId: string | null | undefined;
  genre: GenreValueType | null | undefined;
  isOnPath: boolean | null | undefined;
  videoId: string | null | undefined;
  playListId: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Course Unmarked as Complete: This event fires when a user explicitly clicks to unmark a Course as complete. Formerly "course_mark_as_complete_undo".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.isOnPath: This property indicates whether this action was performed to a piece of content within the context of a user's path or not.
 * @param properties.videoId: This property indicates the ID of the video associated with this action.
 * @param properties.playListId: This is an incorrectly formatted property. Please pass playlist_id ONLY instead, the next time this is worked on.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xN0aVODE6AQ5}
 */
export function courseUnmarkedAsComplete(
  properties: CourseUnmarkedAsCompleteProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xN0aVODE6AQ5", "3091e1127045bdfdbcbef8a0af1c112a36a7199ebe05488231a5123c3d6ae7a9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Course Unmarked as Complete", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "is_on_path": properties.isOnPath,
      "video_id": properties.videoId,
      "play_list_id": properties.playListId,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xN0aVODE6AQ5", "Course Unmarked as Complete", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "Q4hiTa0pVJxi", name: "is_on_path", value: properties.isOnPath},
      {id: "2nuQGFmwvEx3", name: "video_id", value: properties.videoId},
      {id: "qH1yAE0tO-", name: "play_list_id", value: properties.playListId},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.lessonId !== undefined && properties.lessonId !== null) {
    eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  }
  if (properties.lessonSlug !== undefined && properties.lessonSlug !== null) {
    eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  }
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  eventPropertiesPlayWeb["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventPropertiesPlayWeb["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventPropertiesPlayWeb["course_name"] = properties.courseName;
  }
  if (properties.path !== undefined && properties.path !== null) {
    eventPropertiesPlayWeb["path"] = properties.path;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventPropertiesPlayWeb["instrument"] = properties.instrument;
  }
  eventPropertiesPlayWeb["playlist"] = properties.playlist;
  if (properties.playlistId !== undefined && properties.playlistId !== null) {
    eventPropertiesPlayWeb["playlist_id"] = properties.playlistId;
  }
  if (properties.level !== undefined && properties.level !== null) {
    eventPropertiesPlayWeb["level"] = properties.level;
  }
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventPropertiesPlayWeb["path_id"] = properties.pathId;
  }
  if (properties.genre !== undefined && properties.genre !== null) {
    eventPropertiesPlayWeb["genre"] = properties.genre;
  }
  if (properties.isOnPath !== undefined && properties.isOnPath !== null) {
    eventPropertiesPlayWeb["is_on_path"] = properties.isOnPath;
  }
  if (properties.videoId !== undefined && properties.videoId !== null) {
    eventPropertiesPlayWeb["video_id"] = properties.videoId;
  }
  if (properties.playListId !== undefined && properties.playListId !== null) {
    eventPropertiesPlayWeb["play_list_id"] = properties.playListId;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Course Unmarked as Complete", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "is_on_path": properties.isOnPath,
        "video_id": properties.videoId,
        "play_list_id": properties.playListId,
        "siteId": properties.siteidLegacy,
        }, "xN0aVODE6AQ5", "3091e1127045bdfdbcbef8a0af1c112a36a7199ebe05488231a5123c3d6ae7a9");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Course Unmarked as Complete", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface EmailSignupProperties {
  countryCode: string | null | undefined;
  locale: string;
  timezone: string | null | undefined;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string;
  ctaLocation: CtaLocationValueType;
  siteidLegacy: string | null | undefined;
  ctalocationLegacy: string | null | undefined;
}
/**
 * Email Signup: 1This event is fired when the user enters their email address and clicks to sign up from the Play landing page footer (shared with Fender.com).
 *
 * When to trigger this event:
 * 1. This event fires when the user enters their email address and clicks to sign up from the Play landing page footer
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/U3vSpirGC9Al/trigger/uZ061aElh
 *
 * @param properties the properties associatied with this event
 * @param properties.countryCode: This property indicates the two-character country code for the event/transaction.
 * @param properties.locale: This property indicates the user's locale (language & country code) when this event fires. Web only.
 * @param properties.timezone: This property indicates the user's timezone.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.ctaLocation: This property describes the location of the call-to-action relating to this event.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 * @param properties.ctalocationLegacy: Please replace with cta_location only.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/U3vSpirGC9Al}
 */
export function emailSignup(properties: EmailSignupProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "U3vSpirGC9Al", "1f219f5c0b52d6e2d8d090d0051b595d8f8dfc1a4edc2e5478e2d179c5372858", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Email Signup", {
      "country_code": properties.countryCode,
      "locale": properties.locale,
      "timezone": properties.timezone,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "cta_location": properties.ctaLocation,
      "siteId": properties.siteidLegacy,
      "ctaLocation": properties.ctalocationLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("U3vSpirGC9Al", "Email Signup", messages, [
      {id: "MtjpHq5b4s9w", name: "country_code", value: properties.countryCode},
      {id: "Hegu4YQyDCM7", name: "locale", value: properties.locale},
      {id: "gnXsU9esOqgR", name: "timezone", value: properties.timezone},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "gteVFC3yPI", name: "cta_location", value: properties.ctaLocation},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      {id: "7uPiLSRly0", name: "ctaLocation", value: properties.ctalocationLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.countryCode !== undefined && properties.countryCode !== null) {
    eventPropertiesPlayWeb["country_code"] = properties.countryCode;
  }
  eventPropertiesPlayWeb["locale"] = properties.locale;
  if (properties.timezone !== undefined && properties.timezone !== null) {
    eventPropertiesPlayWeb["timezone"] = properties.timezone;
  }
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventPropertiesPlayWeb["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventPropertiesPlayWeb["utm_source"] = properties.utmSource;
  }
  eventPropertiesPlayWeb["utm_campaign"] = properties.utmCampaign;
  eventPropertiesPlayWeb["cta_location"] = properties.ctaLocation;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }
  if (properties.ctalocationLegacy !== undefined && properties.ctalocationLegacy !== null) {
    eventPropertiesPlayWeb["ctaLocation"] = properties.ctalocationLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Email Signup", {
        "country_code": properties.countryCode,
        "locale": properties.locale,
        "timezone": properties.timezone,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "cta_location": properties.ctaLocation,
        "siteId": properties.siteidLegacy,
        "ctaLocation": properties.ctalocationLegacy,
        }, "U3vSpirGC9Al", "1f219f5c0b52d6e2d8d090d0051b595d8f8dfc1a4edc2e5478e2d179c5372858");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Email Signup", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface FavoriteRemovedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  practiceSheetId: string | null | undefined;
  contentType: string | null | undefined;
}
/**
 * Favorite Removed: This event fires when a user clicks to remove a piece of content from Favorites. Formerly "favorite_remove".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.contentType: This property indicates the type of content.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/CqZ8QDql7ncY}
 */
export function favoriteRemoved(properties: FavoriteRemovedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "CqZ8QDql7ncY", "681a75ab493e4af8daebc6252ca4c5e336b09cf2e134fb072494e9fc0083a279", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Favorite Removed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "practice_sheet_id": properties.practiceSheetId,
      "content_type": properties.contentType,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("CqZ8QDql7ncY", "Favorite Removed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "l44CHl0Xv_GV", name: "content_type", value: properties.contentType},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  if (properties.practiceSheetId !== undefined && properties.practiceSheetId !== null) {
    eventProperties["practice_sheet_id"] = properties.practiceSheetId;
  }
  if (properties.contentType !== undefined && properties.contentType !== null) {
    eventProperties["content_type"] = properties.contentType;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Favorite Removed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "practice_sheet_id": properties.practiceSheetId,
        "content_type": properties.contentType,
        }, "CqZ8QDql7ncY", "681a75ab493e4af8daebc6252ca4c5e336b09cf2e134fb072494e9fc0083a279");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Favorite Removed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FavoriteAddedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string | null | undefined;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  practiceSheetId: string | null | undefined;
  contentType: string | null | undefined;
}
/**
 * Favorite Added: This event fires when a user clicks to set a Favorite on a piece of content. Formerly "favorite_set".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.contentType: This property indicates the type of content.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/fkSvHDgYeLoO}
 */
export function favoriteAdded(properties: FavoriteAddedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "fkSvHDgYeLoO", "a156af79d7b0fcc4223f4ef6bf36dcd9d848c9231685585cfa8abce14bce3fb3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Favorite Added", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "practice_sheet_id": properties.practiceSheetId,
      "content_type": properties.contentType,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("fkSvHDgYeLoO", "Favorite Added", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "l44CHl0Xv_GV", name: "content_type", value: properties.contentType},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.lessonId !== undefined && properties.lessonId !== null) {
    eventProperties["lesson_id"] = properties.lessonId;
  }
  if (properties.lessonSlug !== undefined && properties.lessonSlug !== null) {
    eventProperties["lesson_slug"] = properties.lessonSlug;
  }
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.courseId !== undefined && properties.courseId !== null) {
    eventProperties["course_id"] = properties.courseId;
  }
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  if (properties.practiceSheetId !== undefined && properties.practiceSheetId !== null) {
    eventProperties["practice_sheet_id"] = properties.practiceSheetId;
  }
  if (properties.contentType !== undefined && properties.contentType !== null) {
    eventProperties["content_type"] = properties.contentType;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Favorite Added", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        "practice_sheet_id": properties.practiceSheetId,
        "content_type": properties.contentType,
        }, "fkSvHDgYeLoO", "a156af79d7b0fcc4223f4ef6bf36dcd9d848c9231685585cfa8abce14bce3fb3");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Favorite Added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StreakIconClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Streak Icon Clicked: This event fires when users click on the fire icon to view information about their streak. Formerly "Fire Icon"
 *
 * When to trigger this event:
 * 1. User taps the streaks counter icon to learn more (and as of now, launch a tooltip explanation)
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/0EXZNEbec9iR/trigger/K4iz-9d6b
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/0EXZNEbec9iR}
 */
export function streakIconClicked(properties: StreakIconClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0EXZNEbec9iR", "de38ed2658be2f8e6e0e99bc0757077afe359614649f59687d4b1559f51b70b0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Streak Icon Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0EXZNEbec9iR", "Streak Icon Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Streak Icon Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "0EXZNEbec9iR", "de38ed2658be2f8e6e0e99bc0757077afe359614649f59687d4b1559f51b70b0");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Streak Icon Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonMarkedAsCompleteProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  path: PathValueType;
  instrument: InstrumentValueType;
  playlist: PlaylistValueType;
  playlistId: string;
  level: string;
  pathId: string | null | undefined;
  genre: GenreValueType;
  isOnPath: boolean | null | undefined;
  videoId: string | null | undefined;
}
/**
 * Lesson Marked as Complete: This event fires when a user explicitly clicks to mark a lesson as complete. Formerly "lesson_mark_as_complete".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.isOnPath: This property indicates whether this action was performed to a piece of content within the context of a user's path or not.
 * @param properties.videoId: This property indicates the ID of the video associated with this action.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/YmJFucVrG4xu}
 */
export function lessonMarkedAsComplete(
  properties: LessonMarkedAsCompleteProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YmJFucVrG4xu", "25d3f14304507db49592640694d655f5073753c2768d5781d0cbb158dfb5ca4a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Marked as Complete", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "is_on_path": properties.isOnPath,
      "video_id": properties.videoId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YmJFucVrG4xu", "Lesson Marked as Complete", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "Q4hiTa0pVJxi", name: "is_on_path", value: properties.isOnPath},
      {id: "2nuQGFmwvEx3", name: "video_id", value: properties.videoId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["path"] = properties.path;
  eventProperties["instrument"] = properties.instrument;
  eventProperties["playlist"] = properties.playlist;
  eventProperties["playlist_id"] = properties.playlistId;
  eventProperties["level"] = properties.level;
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventProperties["path_id"] = properties.pathId;
  }
  eventProperties["genre"] = properties.genre;
  if (properties.isOnPath !== undefined && properties.isOnPath !== null) {
    eventProperties["is_on_path"] = properties.isOnPath;
  }
  if (properties.videoId !== undefined && properties.videoId !== null) {
    eventProperties["video_id"] = properties.videoId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Marked as Complete", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "is_on_path": properties.isOnPath,
        "video_id": properties.videoId,
        }, "YmJFucVrG4xu", "25d3f14304507db49592640694d655f5073753c2768d5781d0cbb158dfb5ca4a");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Marked as Complete", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonUnmarkedAsCompleteProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  path: PathValueType;
  instrument: InstrumentValueType;
  playlist: PlaylistValueType;
  playlistId: string;
  level: string;
  pathId: string | null | undefined;
  genre: GenreValueType;
  isOnPath: boolean | null | undefined;
  videoId: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Unmarked as Complete: This event fires when a user explicitly clicks to undo marking a lesson as complete. Formerly "lesson_mark_as_complete_undo".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.path: This property indicates the current players' path type/genre where this event was fired. Might been seen formerly as 'genre' or 'style'. Might want to rename as 'path_type' someday.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playlist: This property indicates the concatenated description of the user's path, e.g. instrument, genre, and level all in a single string
 * @param properties.playlistId: This property indicates the unique ID of the playlist/path.
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 * @param properties.pathId: This property indicates the ID of the path this event is referencing.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.isOnPath: This property indicates whether this action was performed to a piece of content within the context of a user's path or not.
 * @param properties.videoId: This property indicates the ID of the video associated with this action.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/8tLAF6SC9ea3}
 */
export function lessonUnmarkedAsComplete(
  properties: LessonUnmarkedAsCompleteProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8tLAF6SC9ea3", "eb13cd3b937676959b91df15513a6d1f293d13bf0bd2d9406c89a3adf327054c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Unmarked as Complete", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "path": properties.path,
      "instrument": properties.instrument,
      "playlist": properties.playlist,
      "playlist_id": properties.playlistId,
      "level": properties.level,
      "path_id": properties.pathId,
      "genre": properties.genre,
      "is_on_path": properties.isOnPath,
      "video_id": properties.videoId,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8tLAF6SC9ea3", "Lesson Unmarked as Complete", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "lYzSBYzuCdm", name: "path", value: properties.path},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "gqawccin2TP", name: "playlist", value: properties.playlist},
      {id: "5iW5ksSw7ZF", name: "playlist_id", value: properties.playlistId},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      {id: "T991pAbYsmmd", name: "path_id", value: properties.pathId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "Q4hiTa0pVJxi", name: "is_on_path", value: properties.isOnPath},
      {id: "2nuQGFmwvEx3", name: "video_id", value: properties.videoId},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventPropertiesPlayWeb["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventPropertiesPlayWeb["course_name"] = properties.courseName;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  eventPropertiesPlayWeb["path"] = properties.path;
  eventPropertiesPlayWeb["instrument"] = properties.instrument;
  eventPropertiesPlayWeb["playlist"] = properties.playlist;
  eventPropertiesPlayWeb["playlist_id"] = properties.playlistId;
  eventPropertiesPlayWeb["level"] = properties.level;
  if (properties.pathId !== undefined && properties.pathId !== null) {
    eventPropertiesPlayWeb["path_id"] = properties.pathId;
  }
  eventPropertiesPlayWeb["genre"] = properties.genre;
  if (properties.isOnPath !== undefined && properties.isOnPath !== null) {
    eventPropertiesPlayWeb["is_on_path"] = properties.isOnPath;
  }
  if (properties.videoId !== undefined && properties.videoId !== null) {
    eventPropertiesPlayWeb["video_id"] = properties.videoId;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Unmarked as Complete", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "path": properties.path,
        "instrument": properties.instrument,
        "playlist": properties.playlist,
        "playlist_id": properties.playlistId,
        "level": properties.level,
        "path_id": properties.pathId,
        "genre": properties.genre,
        "is_on_path": properties.isOnPath,
        "video_id": properties.videoId,
        "siteId": properties.siteidLegacy,
        }, "8tLAF6SC9ea3", "eb13cd3b937676959b91df15513a6d1f293d13bf0bd2d9406c89a3adf327054c");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Unmarked as Complete", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface MiniPlayerToggledProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  miniPlayerActivate: boolean;
}
/**
 * Mini Player Toggled: The mini player mode was activated or deactivated. The "mini_player_activate" property contains the state the player is changing to (mini player or full player).
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.miniPlayerActivate: Was the Mini Player mode activated? True if yes, False if returning to Full Player mode.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ZK8AvXXJVMfi}
 */
export function miniPlayerToggled(properties: MiniPlayerToggledProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZK8AvXXJVMfi", "892fd064ee4560af7a45a786d787fc68d701fde1c330cfd8afbcae0acb35db11", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Mini Player Toggled", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "mini_player_activate": properties.miniPlayerActivate,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZK8AvXXJVMfi", "Mini Player Toggled", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "UGjnbZCjX-Gl", name: "mini_player_activate", value: properties.miniPlayerActivate},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  eventProperties["mini_player_activate"] = properties.miniPlayerActivate;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Mini Player Toggled", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "mini_player_activate": properties.miniPlayerActivate,
        }, "ZK8AvXXJVMfi", "892fd064ee4560af7a45a786d787fc68d701fde1c330cfd8afbcae0acb35db11");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Mini Player Toggled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PracticeModeExitProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  practiceSheetId: string;
  practiceSheetSlug: string;
  practiceSheetTitle: string;
  tempo: number | null | undefined;
}
/**
 * Practice Mode Exit: This event is fired when the user exists a practice mode.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.practiceSheetSlug: The URL slug of the Practice Sheet object.
 * @param properties.practiceSheetTitle: The title/name of the Practice Sheet object.
 * @param properties.tempo: This property indicates the tempo in use (in BPM) for this event.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/gx87boT5Y0mR}
 */
export function practiceModeExit(properties: PracticeModeExitProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gx87boT5Y0mR", "e36e0f7a3b425a36578df38da664332d951aade1df10f2ebe645d9d067e6f8f1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Practice Mode Exit", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "practice_sheet_id": properties.practiceSheetId,
      "practice_sheet_slug": properties.practiceSheetSlug,
      "practice_sheet_title": properties.practiceSheetTitle,
      "tempo": properties.tempo,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gx87boT5Y0mR", "Practice Mode Exit", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "yXTt08qnhNIn", name: "practice_sheet_slug", value: properties.practiceSheetSlug},
      {id: "5r0YaYOdTY7x", name: "practice_sheet_title", value: properties.practiceSheetTitle},
      {id: "Sn3T9-7teIjt", name: "tempo", value: properties.tempo},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["practice_sheet_id"] = properties.practiceSheetId;
  eventProperties["practice_sheet_slug"] = properties.practiceSheetSlug;
  eventProperties["practice_sheet_title"] = properties.practiceSheetTitle;
  if (properties.tempo !== undefined && properties.tempo !== null) {
    eventProperties["tempo"] = properties.tempo;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Practice Mode Exit", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "practice_sheet_id": properties.practiceSheetId,
        "practice_sheet_slug": properties.practiceSheetSlug,
        "practice_sheet_title": properties.practiceSheetTitle,
        "tempo": properties.tempo,
        }, "gx87boT5Y0mR", "e36e0f7a3b425a36578df38da664332d951aade1df10f2ebe645d9d067e6f8f1");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Practice Mode Exit", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PracticeModeLaunchedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  practiceSheetId: string | null | undefined;
  practiceSheetSlug: string;
  practiceSheetTitle: string | null | undefined;
  tempo: number | null | undefined;
  referrer: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Practice Mode Launched: This event is fired when a user launches Practice Mode. See also "Practice Mode" Page and/or Screen event.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.practiceSheetSlug: The URL slug of the Practice Sheet object.
 * @param properties.practiceSheetTitle: The title/name of the Practice Sheet object.
 * @param properties.tempo: This property indicates the tempo in use (in BPM) for this event.
 * @param properties.referrer: This property indicates the type of content that occurred before the user performed this action. On web, this will be a URL, on mobile, this will be a content type (e.g. course, up-next, favorites)
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/fiGPIdbfbRkF}
 */
export function practiceModeLaunched(
  properties: PracticeModeLaunchedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "fiGPIdbfbRkF", "95bc5c493c1d8b64e4109b12f76c5e1eebd19576f5c9674b04732c72adddabce", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Practice Mode Launched", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "practice_sheet_id": properties.practiceSheetId,
      "practice_sheet_slug": properties.practiceSheetSlug,
      "practice_sheet_title": properties.practiceSheetTitle,
      "tempo": properties.tempo,
      "referrer": properties.referrer,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("fiGPIdbfbRkF", "Practice Mode Launched", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "yXTt08qnhNIn", name: "practice_sheet_slug", value: properties.practiceSheetSlug},
      {id: "5r0YaYOdTY7x", name: "practice_sheet_title", value: properties.practiceSheetTitle},
      {id: "Sn3T9-7teIjt", name: "tempo", value: properties.tempo},
      {id: "MZ1ieOZ1jCcq", name: "referrer", value: properties.referrer},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.practiceSheetId !== undefined && properties.practiceSheetId !== null) {
    eventPropertiesPlayWeb["practice_sheet_id"] = properties.practiceSheetId;
  }
  eventPropertiesPlayWeb["practice_sheet_slug"] = properties.practiceSheetSlug;
  if (properties.practiceSheetTitle !== undefined && properties.practiceSheetTitle !== null) {
    eventPropertiesPlayWeb["practice_sheet_title"] = properties.practiceSheetTitle;
  }
  if (properties.tempo !== undefined && properties.tempo !== null) {
    eventPropertiesPlayWeb["tempo"] = properties.tempo;
  }
  if (properties.referrer !== undefined && properties.referrer !== null) {
    eventPropertiesPlayWeb["referrer"] = properties.referrer;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Practice Mode Launched", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "practice_sheet_id": properties.practiceSheetId,
        "practice_sheet_slug": properties.practiceSheetSlug,
        "practice_sheet_title": properties.practiceSheetTitle,
        "tempo": properties.tempo,
        "referrer": properties.referrer,
        "siteId": properties.siteidLegacy,
        }, "fiGPIdbfbRkF", "95bc5c493c1d8b64e4109b12f76c5e1eebd19576f5c9674b04732c72adddabce");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Practice Mode Launched", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface PracticeModeNextLessonClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  practiceSheetId: string | null | undefined;
  practiceSheetSlug: string | null | undefined;
  practiceSheetTitle: string;
  tempo: number | null | undefined;
  nextActivityId: string | null | undefined;
  nextActivitySlug: string | null | undefined;
  nextActivityTitle: string | null | undefined;
  nextActivityType: string | null | undefined;
}
/**
 * Practice Mode Next Lesson Clicked: This event is fired when the user clicks to go to the next lesson from a Practice Mode.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.practiceSheetSlug: The URL slug of the Practice Sheet object.
 * @param properties.practiceSheetTitle: The title/name of the Practice Sheet object.
 * @param properties.tempo: This property indicates the tempo in use (in BPM) for this event.
 * @param properties.nextActivityId: This property indicates the ID of the next activity that occurs after the user performs this action.
 * @param properties.nextActivitySlug: This property indicates the slug of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityTitle: This property indicates the title of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityType: This property indicates the type of the next activity that occurs after the user performs this action.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/0sjJPUdi-lNb}
 */
export function practiceModeNextLessonClicked(
  properties: PracticeModeNextLessonClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0sjJPUdi-lNb", "db3edd3fca75bd055b25860cbf05e743c8508d6d26d93882370b0eef077b4b10", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Practice Mode Next Lesson Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "practice_sheet_id": properties.practiceSheetId,
      "practice_sheet_slug": properties.practiceSheetSlug,
      "practice_sheet_title": properties.practiceSheetTitle,
      "tempo": properties.tempo,
      "next_activity_id": properties.nextActivityId,
      "next_activity_slug": properties.nextActivitySlug,
      "next_activity_title": properties.nextActivityTitle,
      "next_activity_type": properties.nextActivityType,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0sjJPUdi-lNb", "Practice Mode Next Lesson Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "yXTt08qnhNIn", name: "practice_sheet_slug", value: properties.practiceSheetSlug},
      {id: "5r0YaYOdTY7x", name: "practice_sheet_title", value: properties.practiceSheetTitle},
      {id: "Sn3T9-7teIjt", name: "tempo", value: properties.tempo},
      {id: "Kh9sBptRQ-0q", name: "next_activity_id", value: properties.nextActivityId},
      {id: "A2o2tN3vyDPo", name: "next_activity_slug", value: properties.nextActivitySlug},
      {id: "e-PCkn29vMKF", name: "next_activity_title", value: properties.nextActivityTitle},
      {id: "kbeM5avar8tP", name: "next_activity_type", value: properties.nextActivityType},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.practiceSheetId !== undefined && properties.practiceSheetId !== null) {
    eventProperties["practice_sheet_id"] = properties.practiceSheetId;
  }
  if (properties.practiceSheetSlug !== undefined && properties.practiceSheetSlug !== null) {
    eventProperties["practice_sheet_slug"] = properties.practiceSheetSlug;
  }
  eventProperties["practice_sheet_title"] = properties.practiceSheetTitle;
  if (properties.tempo !== undefined && properties.tempo !== null) {
    eventProperties["tempo"] = properties.tempo;
  }
  if (properties.nextActivityId !== undefined && properties.nextActivityId !== null) {
    eventProperties["next_activity_id"] = properties.nextActivityId;
  }
  if (properties.nextActivitySlug !== undefined && properties.nextActivitySlug !== null) {
    eventProperties["next_activity_slug"] = properties.nextActivitySlug;
  }
  if (properties.nextActivityTitle !== undefined && properties.nextActivityTitle !== null) {
    eventProperties["next_activity_title"] = properties.nextActivityTitle;
  }
  if (properties.nextActivityType !== undefined && properties.nextActivityType !== null) {
    eventProperties["next_activity_type"] = properties.nextActivityType;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Practice Mode Next Lesson Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "practice_sheet_id": properties.practiceSheetId,
        "practice_sheet_slug": properties.practiceSheetSlug,
        "practice_sheet_title": properties.practiceSheetTitle,
        "tempo": properties.tempo,
        "next_activity_id": properties.nextActivityId,
        "next_activity_slug": properties.nextActivitySlug,
        "next_activity_title": properties.nextActivityTitle,
        "next_activity_type": properties.nextActivityType,
        }, "0sjJPUdi-lNb", "db3edd3fca75bd055b25860cbf05e743c8508d6d26d93882370b0eef077b4b10");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Practice Mode Next Lesson Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PracticeModePlaybackCheckpointReachedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  practiceSheetId: string;
  practiceSheetSlug: string;
  practiceSheetTitle: string;
  tempo: number | null | undefined;
  checkpointPercent: number | null | undefined;
  collectionId: string | null | undefined;
  collectionName: string | null | undefined;
  lessonType: LessonTypeValueType | null | undefined;
  tablaturePickLevel: number;
  siteidLegacy: string | null | undefined;
}
/**
 * Practice Mode Playback Checkpoint Reached: This event fires at pre-determined checkpoints during the playback of a Practice Mode. It fires at the 0%, 25%, 50%, 75%, and 100% points of the sheet music (repeats are accounted for). Each checkpoint value can only be fired one time by the user during that session, so skipping around won't trigger a checkpoint multiple times.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.practiceSheetId: The unique ID of the Practice Sheet object.
 * @param properties.practiceSheetSlug: The URL slug of the Practice Sheet object.
 * @param properties.practiceSheetTitle: The title/name of the Practice Sheet object.
 * @param properties.tempo: This property indicates the tempo in use (in BPM) for this event.
 * @param properties.checkpointPercent: The checkpoint that was just passed during playback, based on the entire length of the sheet music. Expected values: 0, 25, 50, 75, 100
 * @param properties.collectionId: The object ID of the Collection the user navigated through to reach this activity.
 * @param properties.collectionName: The name of the Collection the user navigated through to reach this activity.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.tablaturePickLevel: The pick level of the tablature, which determines things like if the engine uses 'slash' notation, or displays mini chord diagrams.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/LfjGMhgojNKN}
 */
export function practiceModePlaybackCheckpointReached(
  properties: PracticeModePlaybackCheckpointReachedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertCheckpointPercentOptional(properties.checkpointPercent));
    messages = messages.concat(assertTablaturePickLevel(properties.tablaturePickLevel));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "LfjGMhgojNKN", "c9bda3d967dc8e2ad05ca0d38c6df11463b91cd8a6b785b0df817f09b96d5264", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Practice Mode Playback Checkpoint Reached", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "practice_sheet_id": properties.practiceSheetId,
      "practice_sheet_slug": properties.practiceSheetSlug,
      "practice_sheet_title": properties.practiceSheetTitle,
      "tempo": properties.tempo,
      "checkpoint_percent": properties.checkpointPercent,
      "collection_id": properties.collectionId,
      "collection_name": properties.collectionName,
      "lesson_type": properties.lessonType,
      "tablature_pick_level": properties.tablaturePickLevel,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("LfjGMhgojNKN", "Practice Mode Playback Checkpoint Reached", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "N8SYMYOK_4n9", name: "practice_sheet_id", value: properties.practiceSheetId},
      {id: "yXTt08qnhNIn", name: "practice_sheet_slug", value: properties.practiceSheetSlug},
      {id: "5r0YaYOdTY7x", name: "practice_sheet_title", value: properties.practiceSheetTitle},
      {id: "Sn3T9-7teIjt", name: "tempo", value: properties.tempo},
      {id: "o2Hyp08Kr_X6", name: "checkpoint_percent", value: properties.checkpointPercent},
      {id: "eoTgwiC_8ygd", name: "collection_id", value: properties.collectionId},
      {id: "lOwu9g624k-t", name: "collection_name", value: properties.collectionName},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "c47t9iNYDw-M", name: "tablature_pick_level", value: properties.tablaturePickLevel},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Practice Mode Playback Checkpoint Reached': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["practice_sheet_id"] = properties.practiceSheetId;
  eventPropertiesPlayWeb["practice_sheet_slug"] = properties.practiceSheetSlug;
  eventPropertiesPlayWeb["practice_sheet_title"] = properties.practiceSheetTitle;
  if (properties.tempo !== undefined && properties.tempo !== null) {
    eventPropertiesPlayWeb["tempo"] = properties.tempo;
  }
  if (properties.checkpointPercent !== undefined && properties.checkpointPercent !== null) {
    eventPropertiesPlayWeb["checkpoint_percent"] = properties.checkpointPercent;
  }
  if (properties.collectionId !== undefined && properties.collectionId !== null) {
    eventPropertiesPlayWeb["collection_id"] = properties.collectionId;
  }
  if (properties.collectionName !== undefined && properties.collectionName !== null) {
    eventPropertiesPlayWeb["collection_name"] = properties.collectionName;
  }
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  eventPropertiesPlayWeb["tablature_pick_level"] = properties.tablaturePickLevel;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Practice Mode Playback Checkpoint Reached", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "practice_sheet_id": properties.practiceSheetId,
        "practice_sheet_slug": properties.practiceSheetSlug,
        "practice_sheet_title": properties.practiceSheetTitle,
        "tempo": properties.tempo,
        "checkpoint_percent": properties.checkpointPercent,
        "collection_id": properties.collectionId,
        "collection_name": properties.collectionName,
        "lesson_type": properties.lessonType,
        "tablature_pick_level": properties.tablaturePickLevel,
        "siteId": properties.siteidLegacy,
        }, "LfjGMhgojNKN", "c9bda3d967dc8e2ad05ca0d38c6df11463b91cd8a6b785b0df817f09b96d5264");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Practice Mode Playback Checkpoint Reached", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface PresetDownloadedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  countryCode: string | null | undefined;
  presetId: string | null | undefined;
  timezone: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Preset Downloaded: This event is fired when a user clicks to download a Tone preset from the Tone tab on a Lesson Detail. Formerly "preset_click".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.countryCode: This property indicates the two-character country code for the event/transaction.
 * @param properties.presetId: This property indicates the ID number of the Fender Tone preset.
 * @param properties.timezone: This property indicates the user's timezone.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/FbsXTsqml93P}
 */
export function presetDownloaded(properties: PresetDownloadedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FbsXTsqml93P", "84cc05ff52462f0c3fea1315fd6f733e3d0f1d356d76eeda7166b595f461917e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Preset Downloaded", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "country_code": properties.countryCode,
      "preset_id": properties.presetId,
      "timezone": properties.timezone,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FbsXTsqml93P", "Preset Downloaded", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "MtjpHq5b4s9w", name: "country_code", value: properties.countryCode},
      {id: "qYdjesCu15Nw", name: "preset_id", value: properties.presetId},
      {id: "gnXsU9esOqgR", name: "timezone", value: properties.timezone},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  eventPropertiesPlayWeb["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventPropertiesPlayWeb["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventPropertiesPlayWeb["course_name"] = properties.courseName;
  }
  if (properties.countryCode !== undefined && properties.countryCode !== null) {
    eventPropertiesPlayWeb["country_code"] = properties.countryCode;
  }
  if (properties.presetId !== undefined && properties.presetId !== null) {
    eventPropertiesPlayWeb["preset_id"] = properties.presetId;
  }
  if (properties.timezone !== undefined && properties.timezone !== null) {
    eventPropertiesPlayWeb["timezone"] = properties.timezone;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Preset Downloaded", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "country_code": properties.countryCode,
        "preset_id": properties.presetId,
        "timezone": properties.timezone,
        "siteId": properties.siteidLegacy,
        }, "FbsXTsqml93P", "84cc05ff52462f0c3fea1315fd6f733e3d0f1d356d76eeda7166b595f461917e");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Preset Downloaded", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LessonFeedbackClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Feedback Clicked: This event fires when the user clicks on the Feedback button on a lesson detail. Formerly "Navigation Lesson Feedback Clicked".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2xdfInuDg4Ez}
 */
export function lessonFeedbackClicked(
  properties: LessonFeedbackClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2xdfInuDg4Ez", "200f159021b00d0c771d5271b52a4db6c04723a7da8874f6e8e16af1e72171ec", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Feedback Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2xdfInuDg4Ez", "Lesson Feedback Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Feedback Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "2xdfInuDg4Ez", "200f159021b00d0c771d5271b52a4db6c04723a7da8874f6e8e16af1e72171ec");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Feedback Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LessonInfoClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Info Clicked: User clicked on "Info" button from within a lesson view. Formerly "lessonRelatedClicked"
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/If9WmL3LNFNs}
 */
export function lessonInfoClicked(properties: LessonInfoClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "If9WmL3LNFNs", "322226945808bcd411f9f31e9d27a419505836b8f3071e1d1b1685001fdcf2ba", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Info Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("If9WmL3LNFNs", "Lesson Info Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Info Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "If9WmL3LNFNs", "322226945808bcd411f9f31e9d27a419505836b8f3071e1d1b1685001fdcf2ba");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Info Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LessonRelatedClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Related Clicked: User clicked on "Related Lessons" button from within a lesson view. Formerly "Selected Related".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ITH4zwrBtaV4}
 */
export function lessonRelatedClicked(
  properties: LessonRelatedClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ITH4zwrBtaV4", "4a9b98f813bca886211ebc7430740b21e67e61990a465b5c660e4ed9a5b1cbc7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Related Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ITH4zwrBtaV4", "Lesson Related Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Related Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "ITH4zwrBtaV4", "4a9b98f813bca886211ebc7430740b21e67e61990a465b5c660e4ed9a5b1cbc7");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Related Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LessonTablatureClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Tablature Clicked: User clicked on "Tablature" button from within a lesson view (selected by default). Formerly "Selected Tabs".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/N8SdOM-0-Tyu}
 */
export function lessonTablatureClicked(
  properties: LessonTablatureClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "N8SdOM-0-Tyu", "83783903cd97fca7c13f4061561f77977e4c35860c0fa9d6856ba768cc3d005e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Tablature Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("N8SdOM-0-Tyu", "Lesson Tablature Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Tablature Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "N8SdOM-0-Tyu", "83783903cd97fca7c13f4061561f77977e4c35860c0fa9d6856ba768cc3d005e");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Tablature Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LessonToneClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Tone Clicked: This event fires when a user clicked on the "Tone" button when viewing a lesson detail. Formerly "Selected Tone".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/JxUJG2iEUxPJ}
 */
export function lessonToneClicked(properties: LessonToneClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "JxUJG2iEUxPJ", "e65b649f6466ef12b19411c615bbcea1140c8266d2c386781a775d4b18ecba79", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Tone Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("JxUJG2iEUxPJ", "Lesson Tone Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Tone Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "JxUJG2iEUxPJ", "e65b649f6466ef12b19411c615bbcea1140c8266d2c386781a775d4b18ecba79");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Tone Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LessonToolsClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Tools Clicked: User clicked on "Tools" button from within a lesson view. Formerly "Selected Tools".
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/53o5K1EcOemt}
 */
export function lessonToolsClicked(properties: LessonToolsClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "53o5K1EcOemt", "66685d709370b8729ca8e6eab777d065f54523141bcf51e2df006816b2f9750f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Tools Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("53o5K1EcOemt", "Lesson Tools Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Tools Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "siteId": properties.siteidLegacy,
        }, "53o5K1EcOemt", "66685d709370b8729ca8e6eab777d065f54523141bcf51e2df006816b2f9750f");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Tools Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface SessionMilestoneCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  countryCode: string | null | undefined;
  endDate: string | null | undefined;
  locale: string | null | undefined;
  milestoneContextsessionDuration: string | null | undefined;
  milestoneContextweekOf: string | null | undefined;
  milestoneType: MilestoneTypeValueType | null | undefined;
  startDate: string | null | undefined;
  timezone: string | null | undefined;
  videosCompleted: number | null | undefined;
  videosWatched: number | null | undefined;
  milestoneContext: MilestoneContext;
  milestoneContextmilestoneNumber: number | null | undefined;
}
/**
 * Session Milestone Completed: This event is fired when a milestone is reached, such as completing a streak.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.countryCode: This property indicates the two-character country code for the event/transaction.
 * @param properties.endDate: This property indicates the end date of the event.
 * @param properties.locale: This property indicates the user's locale (language & country code) when this event fires. Web only.
 * @param properties.milestoneContextsessionDuration: This property indicates the duration of the session relating to the milestone.
 * @param properties.milestoneContextweekOf: This property indicates the timestamp for the week the milestone occurred.
 * @param properties.milestoneType: This property indicates the type of milestone for this event, e.g. 'Daily Streak'
 * @param properties.startDate: This property indicates the start date of the event.
 * @param properties.timezone: This property indicates the user's timezone.
 * @param properties.videosCompleted: This property indicates the number of videos watched to (presumably) near 100% in relation to this event.
 * @param properties.videosWatched: This property indicates the number of videos watched in any amount in relation to this event.
 * @param properties.milestoneContext: This property contains a subset of context data for this milestone.
 * @param properties.milestoneContextmilestoneNumber: This property indicates the number of the milestone.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/uqAgiYvNdp2U}
 */
export function sessionMilestoneCompleted(
  properties: SessionMilestoneCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMilestoneContext(properties.milestoneContext));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uqAgiYvNdp2U", "667796ea162e57cc119fa321df2efa50f8520e3530bd5569e29570d3a2834c3e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Session Milestone Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "country_code": properties.countryCode,
      "end_date": properties.endDate,
      "locale": properties.locale,
      "milestone_context.session_duration": properties.milestoneContextsessionDuration,
      "milestone_context.week_of": properties.milestoneContextweekOf,
      "milestone_type": properties.milestoneType,
      "start_date": properties.startDate,
      "timezone": properties.timezone,
      "videos_completed": properties.videosCompleted,
      "videos_watched": properties.videosWatched,
      "milestone_context": {
        "milestone_context.week_of": properties.milestoneContext.milestoneContextweekOf,
        "milestone_context.milestone_number": properties.milestoneContext.milestoneContextmilestoneNumber,
        "milestone_context.session_duration": properties.milestoneContext.milestoneContextsessionDuration,
      },
      "milestone_context.milestone_number": properties.milestoneContextmilestoneNumber,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uqAgiYvNdp2U", "Session Milestone Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "MtjpHq5b4s9w", name: "country_code", value: properties.countryCode},
      {id: "vj6GCYyfHW_J", name: "end_date", value: properties.endDate},
      {id: "Hegu4YQyDCM7", name: "locale", value: properties.locale},
      {id: "sOIbw2YCVKCg", name: "milestone_context.session_duration", value: properties.milestoneContextsessionDuration},
      {id: "9ZP8hFzF01xr", name: "milestone_context.week_of", value: properties.milestoneContextweekOf},
      {id: "rugPlrsQ0bXh", name: "milestone_type", value: properties.milestoneType},
      {id: "UWf6HUoGnpyJ", name: "start_date", value: properties.startDate},
      {id: "gnXsU9esOqgR", name: "timezone", value: properties.timezone},
      {id: "LqOV4FGlq9iw", name: "videos_completed", value: properties.videosCompleted},
      {id: "Ndy7fsB0FZ5E", name: "videos_watched", value: properties.videosWatched},
      {id: "VNFcJ28SMBX", name: "milestone_context", value: properties.milestoneContext},
      {id: "WL0M0RnNaVNd", name: "milestone_context.milestone_number", value: properties.milestoneContextmilestoneNumber},
      ], []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Session Milestone Completed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.countryCode !== undefined && properties.countryCode !== null) {
    eventProperties["country_code"] = properties.countryCode;
  }
  if (properties.endDate !== undefined && properties.endDate !== null) {
    eventProperties["end_date"] = properties.endDate;
  }
  if (properties.locale !== undefined && properties.locale !== null) {
    eventProperties["locale"] = properties.locale;
  }
  if (properties.milestoneContextsessionDuration !== undefined && properties.milestoneContextsessionDuration !== null) {
    eventProperties["milestone_context.session_duration"] = properties.milestoneContextsessionDuration;
  }
  if (properties.milestoneContextweekOf !== undefined && properties.milestoneContextweekOf !== null) {
    eventProperties["milestone_context.week_of"] = properties.milestoneContextweekOf;
  }
  if (properties.milestoneType !== undefined && properties.milestoneType !== null) {
    eventProperties["milestone_type"] = properties.milestoneType;
  }
  if (properties.startDate !== undefined && properties.startDate !== null) {
    eventProperties["start_date"] = properties.startDate;
  }
  if (properties.timezone !== undefined && properties.timezone !== null) {
    eventProperties["timezone"] = properties.timezone;
  }
  if (properties.videosCompleted !== undefined && properties.videosCompleted !== null) {
    eventProperties["videos_completed"] = properties.videosCompleted;
  }
  if (properties.videosWatched !== undefined && properties.videosWatched !== null) {
    eventProperties["videos_watched"] = properties.videosWatched;
  }
  eventProperties["milestone_context"] = {
  "milestone_context.week_of": properties.milestoneContext.milestoneContextweekOf,
  "milestone_context.milestone_number": properties.milestoneContext.milestoneContextmilestoneNumber,
  "milestone_context.session_duration": properties.milestoneContext.milestoneContextsessionDuration,
  };
  if (properties.milestoneContextmilestoneNumber !== undefined && properties.milestoneContextmilestoneNumber !== null) {
    eventProperties["milestone_context.milestone_number"] = properties.milestoneContextmilestoneNumber;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Session Milestone Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "country_code": properties.countryCode,
        "end_date": properties.endDate,
        "locale": properties.locale,
        "milestone_context.session_duration": properties.milestoneContextsessionDuration,
        "milestone_context.week_of": properties.milestoneContextweekOf,
        "milestone_type": properties.milestoneType,
        "start_date": properties.startDate,
        "timezone": properties.timezone,
        "videos_completed": properties.videosCompleted,
        "videos_watched": properties.videosWatched,
        "milestone_context": {
          "milestone_context.week_of": properties.milestoneContext.milestoneContextweekOf,
          "milestone_context.milestone_number": properties.milestoneContext.milestoneContextmilestoneNumber,
          "milestone_context.session_duration": properties.milestoneContext.milestoneContextsessionDuration,
        },
        "milestone_context.milestone_number": properties.milestoneContextmilestoneNumber,
        }, "uqAgiYvNdp2U", "667796ea162e57cc119fa321df2efa50f8520e3530bd5569e29570d3a2834c3e");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Session Milestone Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlaybackCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
}
/**
 * Video Playback Completed: This event fires when video playback is complete (95%) and only when the session is finished. See the Segment Video spec for more details.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ZVf4IjYeoXqu}
 */
export function videoPlaybackCompleted(
  properties: VideoPlaybackCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZVf4IjYeoXqu", "b38d3dd0e775efbaa1697b89dfd890d1f50c12a3a2fd31990b4ea793accc38bd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Playback Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZVf4IjYeoXqu", "Video Playback Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Playback Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        }, "ZVf4IjYeoXqu", "b38d3dd0e775efbaa1697b89dfd890d1f50c12a3a2fd31990b4ea793accc38bd");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Playback Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlaybackPausedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
}
/**
 * Video Playback Paused: This event fires when a user performs "Video Player Paused" and the playback experience returns a paused state.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/CLvzZTuMW5Wm}
 */
export function videoPlaybackPaused(properties: VideoPlaybackPausedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "CLvzZTuMW5Wm", "62f8bc9470550d122207afe52a702e04e29d96fd70d41d344733f174691a074e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Playback Paused", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("CLvzZTuMW5Wm", "Video Playback Paused", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Playback Paused", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        }, "CLvzZTuMW5Wm", "62f8bc9470550d122207afe52a702e04e29d96fd70d41d344733f174691a074e");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Playback Paused", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlaybackResumedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
}
/**
 * Video Playback Resumed: This event fires when playback is resumed, by the user, after being paused. See Segment's Video spec for more details.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/zJoK-ezv7XIm}
 */
export function videoPlaybackResumed(
  properties: VideoPlaybackResumedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "zJoK-ezv7XIm", "9572ff9fe0904ef71eb7b054001a49831dd1b3be65cfecac0c26ec2646351dd1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Playback Resumed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("zJoK-ezv7XIm", "Video Playback Resumed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Playback Resumed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        }, "zJoK-ezv7XIm", "9572ff9fe0904ef71eb7b054001a49831dd1b3be65cfecac0c26ec2646351dd1");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Playback Resumed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayerSpeedChangedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  fromSpeed: any | null | undefined;
  toSpeed: string | null | undefined;
}
/**
 * Video Player Speed Changed: This event fires when the user changes the speed on a video (can be set slower than normal speed or higher than normal speed). Web player only feature.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.fromSpeed: This property indicates the speed value before the action is performed.
 * @param properties.toSpeed: This property indicates the speed value after the action is performed.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/i9l9GsCRrdpK}
 */
export function videoPlayerSpeedChanged(
  properties: VideoPlayerSpeedChangedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "i9l9GsCRrdpK", "0d728de101560ef72a2f357f8c8f6cf600139984802f32b2a7da66c1e760d1f1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Player Speed Changed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "from_speed": properties.fromSpeed,
      "to_speed": properties.toSpeed,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("i9l9GsCRrdpK", "Video Player Speed Changed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "NScTC_94VVKX", name: "from_speed", value: properties.fromSpeed},
      {id: "r0kfwegc6zW0", name: "to_speed", value: properties.toSpeed},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.fromSpeed !== undefined && properties.fromSpeed !== null) {
    eventProperties["from_speed"] = properties.fromSpeed;
  }
  if (properties.toSpeed !== undefined && properties.toSpeed !== null) {
    eventProperties["to_speed"] = properties.toSpeed;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Player Speed Changed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "from_speed": properties.fromSpeed,
        "to_speed": properties.toSpeed,
        }, "i9l9GsCRrdpK", "0d728de101560ef72a2f357f8c8f6cf600139984802f32b2a7da66c1e760d1f1");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Player Speed Changed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoQualityUpdatedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  fullScreen: boolean | null | undefined;
  position: any | null | undefined;
  quality: string | null | undefined;
  sound: number | null | undefined;
  totalLength: number | null | undefined;
  videoId: string | null | undefined;
  videoPlayer: string | null | undefined;
}
/**
 * Video Quality Updated: This event is fired during HLS playback when bandwidth improves (or declines) during a video playback session.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoId: This property indicates the ID of the video associated with this action.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/sLeYI18cBMQ6}
 */
export function videoQualityUpdated(properties: VideoQualityUpdatedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sLeYI18cBMQ6", "b7aac9861ee5bdce68086cf4d03c5510a0a2fbdeff190db8053c0d5a452292f0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Quality Updated", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "full_screen": properties.fullScreen,
      "position": properties.position,
      "quality": properties.quality,
      "sound": properties.sound,
      "total_length": properties.totalLength,
      "video_id": properties.videoId,
      "video_player": properties.videoPlayer,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sLeYI18cBMQ6", "Video Quality Updated", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "2nuQGFmwvEx3", name: "video_id", value: properties.videoId},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.videoId !== undefined && properties.videoId !== null) {
    eventProperties["video_id"] = properties.videoId;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Quality Updated", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "full_screen": properties.fullScreen,
        "position": properties.position,
        "quality": properties.quality,
        "sound": properties.sound,
        "total_length": properties.totalLength,
        "video_id": properties.videoId,
        "video_player": properties.videoPlayer,
        }, "sLeYI18cBMQ6", "b7aac9861ee5bdce68086cf4d03c5510a0a2fbdeff190db8053c0d5a452292f0");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Quality Updated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionLastChanceOfferProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adBodycopy: string;
  sku: string;
}
/**
 * Subscription Last Chance Offer: User sees an offer for a "Last Chance" 50% annual plan. This is shown to a user in the app when they have 24 hours or less remaining in their Test Drive period. They'll see it one time per platform.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Yf8ZPqLNe7u}
 */
export function subscriptionLastChanceOffer(
  properties: SubscriptionLastChanceOfferProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Yf8ZPqLNe7u", "80c1dcd230eaa5add20c5002a02a8b20ebcaf9eacfeb7f6ad925781de5c12078", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Last Chance Offer", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_bodycopy": properties.adBodycopy,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Yf8ZPqLNe7u", "Subscription Last Chance Offer", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionLastChanceOfferAnnualClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  ctaButtoncopy: string;
  ctaButtoncolor: string;
  adProvider: AdProviderValueType;
  adIdentifier: string | null | undefined;
}
/**
 * Subscription Last Chance Offer Annual Clicked: User clicked the affirmative CTA for the "Last Chance, 50% off" offer that leads them to an IAP prompt (on mobile) or the Checkout screen (on web) to complete their purchase.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.ctaButtoncolor: The HEX value of the CTA button's color.
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/rpo1XqsVt0c}
 */
export function subscriptionLastChanceOfferAnnualClicked(
  properties: SubscriptionLastChanceOfferAnnualClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rpo1XqsVt0c", "cf34919859c801e76abf6e52b200a91731ccdd7290d3540fdcb35680dccb5b21", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Last Chance Offer Annual Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "cta_buttoncolor": properties.ctaButtoncolor,
      "ad_provider": properties.adProvider,
      "ad_identifier": properties.adIdentifier,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rpo1XqsVt0c", "Subscription Last Chance Offer Annual Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "naeMKuvblqV", name: "cta_buttoncolor", value: properties.ctaButtoncolor},
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["cta_buttoncolor"] = properties.ctaButtoncolor;
  eventProperties["ad_provider"] = properties.adProvider;
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Last Chance Offer Annual Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "cta_buttoncolor": properties.ctaButtoncolor,
        "ad_provider": properties.adProvider,
        "ad_identifier": properties.adIdentifier,
        }, "rpo1XqsVt0c", "cf34919859c801e76abf6e52b200a91731ccdd7290d3540fdcb35680dccb5b21");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Last Chance Offer Annual Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionLastChanceOfferDeclinedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adIdentifier: string | null | undefined;
  adProvider: AdProviderValueType;
}
/**
 * Subscription Last Chance Offer Declined: User clicked the negative CTA for the "Last Chance, 50% off" offer that dismisses the offer screen. For Last Chance, this is an "X" button in the corner.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adIdentifier: This property indicates the name of the design file for the A/B ad being displayed for reference.
 * @param properties.adProvider: This property indicates where the ad came from, and is currently hardcoded as 'fender_internal'.

Helpful for any future A/B testing
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MoTr1adzFry}
 */
export function subscriptionLastChanceOfferDeclined(
  properties: SubscriptionLastChanceOfferDeclinedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MoTr1adzFry", "f62f7737911245b1280c817da26f8b4bbcce40178f3155c04d36b0c435221700", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Last Chance Offer Declined", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_identifier": properties.adIdentifier,
      "ad_provider": properties.adProvider,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MoTr1adzFry", "Subscription Last Chance Offer Declined", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "R5OeHsPGhjH", name: "ad_identifier", value: properties.adIdentifier},
      {id: "s2mvyUO7Zhm", name: "ad_provider", value: properties.adProvider},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.adIdentifier !== undefined && properties.adIdentifier !== null) {
    eventProperties["ad_identifier"] = properties.adIdentifier;
  }
  eventProperties["ad_provider"] = properties.adProvider;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Last Chance Offer Declined", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ad_identifier": properties.adIdentifier,
        "ad_provider": properties.adProvider,
        }, "MoTr1adzFry", "f62f7737911245b1280c817da26f8b4bbcce40178f3155c04d36b0c435221700");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Last Chance Offer Declined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingQuizInstrumentProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Onboarding Quiz Instrument: User landed on the Onboarding Quiz instrument selection screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TziH2UPnCar/trigger/E8pmzaJJv
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TziH2UPnCar}
 */
export function onboardingQuizInstrument(
  properties: OnboardingQuizInstrumentProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "TziH2UPnCar", "d294dc8184c9fde9b19f865374f3e961b5dc6c80dac3b4cf2b7aab2fd5c87027", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Instrument", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("TziH2UPnCar", "Onboarding Quiz Instrument", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingQuizGenreProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
  instrument: InstrumentValueType;
}
/**
 * Onboarding Quiz Genre: User landed on the Onboarding Quiz genre selection screen. This is seen after choosing an instrument (unless the instrument has no associated genres, like Ukulele).
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MkgaqfhmQMW/trigger/pFPb562rE
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MkgaqfhmQMW}
 */
export function onboardingQuizGenre(properties: OnboardingQuizGenreProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MkgaqfhmQMW", "65336af35e3aa657d64531ee901e77f7a15943f0e9b3db6d29fc2f66a413bad9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Genre", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "instrument": properties.instrument,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MkgaqfhmQMW", "Onboarding Quiz Genre", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["instrument"] = properties.instrument;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingQuizInstrumentClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  userId_: string;
  instrument: InstrumentValueType;
  playPathInstrument: PlayPathInstrumentValueType;
}
/**
 * Onboarding Quiz Instrument Clicked: User clicked an instrument on the Onboarding Quiz genre selection screen.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.playPathInstrument: The user's current Instrument. Formerly 'currentInstrument'
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/_gXpgB7tl6k}
 */
export function onboardingQuizInstrumentClicked(
  properties: OnboardingQuizInstrumentClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_gXpgB7tl6k", "2c11f867e3689ee760ae25b43edda5cabff9ae27fbd533785ce3dbe03ba3beae", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Instrument Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "instrument": properties.instrument,
      }, {
      "play_path_instrument": properties.playPathInstrument,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_gXpgB7tl6k", "Onboarding Quiz Instrument Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      ], [
      {id:"SGB4eQ5cPO", name: "play_path_instrument", value: properties.playPathInstrument},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["instrument"] = properties.instrument;

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_path_instrument"] = properties.playPathInstrument;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Quiz Instrument Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "instrument": properties.instrument,
        }, "_gXpgB7tl6k", "2c11f867e3689ee760ae25b43edda5cabff9ae27fbd533785ce3dbe03ba3beae");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Onboarding Quiz Instrument Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingQuizGenreClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  userId_: string;
  instrument: InstrumentValueType;
  genre: GenreValueType;
  playPathGenre: PlayPathGenreValueType;
}
/**
 * Onboarding Quiz Genre Clicked: User clicked a genre on the Onboarding Quiz genre selection screen.
 *
 * When to trigger this event:
 * 1. User clicks a genre
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-dTx2EItYVW/trigger/QC26FZPbW
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.playPathGenre: The user's currently selected Genre. Formerly 'currentPath'.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-dTx2EItYVW}
 */
export function onboardingQuizGenreClicked(
  properties: OnboardingQuizGenreClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-dTx2EItYVW", "65f9ca7c461cd0a7940249d710de9c82bba8f1cab25b26c831934f7faacf62c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Genre Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "instrument": properties.instrument,
      "genre": properties.genre,
      }, {
      "play_path_genre": properties.playPathGenre,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-dTx2EItYVW", "Onboarding Quiz Genre Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      ], [
      {id:"KxkjsavOnd", name: "play_path_genre", value: properties.playPathGenre},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["instrument"] = properties.instrument;
  eventProperties["genre"] = properties.genre;

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_path_genre"] = properties.playPathGenre;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Quiz Genre Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "instrument": properties.instrument,
        "genre": properties.genre,
        }, "-dTx2EItYVW", "65f9ca7c461cd0a7940249d710de9c82bba8f1cab25b26c831934f7faacf62c3");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Onboarding Quiz Genre Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PathChangedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  userId_: string;
  setDuringOnboarding: boolean | null | undefined;
  instrument: InstrumentValueType;
  genre: GenreValueType;
  playPathLevel: number;
  playPathInstrument: PlayPathInstrumentValueType;
  playPathGenre: PlayPathGenreValueType;
  fcidLegacy: string | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Path Changed: After a user has made an instrument and genre choice (with the exception that no genre choice is needed for Ukulele), this event fires to confirm that the user's Path has actually been changed. This event can be fired from places like the Onboarding Quiz and Change Path screens.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.setDuringOnboarding: This property tracks if a 'Path Changed' event happened as a result of a user using the Onboarding Quiz UI (True) or not (False).
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.playPathLevel: The user's current Path level. Formerly 'currentLevel' or 'level' which are strings.
 * @param properties.playPathInstrument: The user's current Instrument. Formerly 'currentInstrument'
 * @param properties.playPathGenre: The user's currently selected Genre. Formerly 'currentPath'.
 * @param properties.fcidLegacy: This property indicates the Fender Connect user ID, but is legacy. Continue to send this alongside fc_id if the client is currently, until we can migrate all reporting to fc_id. NOTE TO DEVS: please stop sending this and send fc_id instead
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/w74d6lmvDhb}
 */
export function pathChanged(properties: PathChangedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "w74d6lmvDhb", "cbd32e05464148ca5c503aa4427d72fa846bf8acd9de64e3a5b6a03a748c94c2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Path Changed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "set_during_onboarding": properties.setDuringOnboarding,
      "instrument": properties.instrument,
      "genre": properties.genre,
      "fcId": properties.fcidLegacy,
      "siteId": properties.siteidLegacy,
      }, {
      "play_path_level": properties.playPathLevel,
      "play_path_instrument": properties.playPathInstrument,
      "play_path_genre": properties.playPathGenre,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("w74d6lmvDhb", "Path Changed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Mefy2r79f_x", name: "set_during_onboarding", value: properties.setDuringOnboarding},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "If9yUjDUw", name: "fcId", value: properties.fcidLegacy},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], [
      {id:"Mp7u_2_vso", name: "play_path_level", value: properties.playPathLevel},
      {id:"SGB4eQ5cPO", name: "play_path_instrument", value: properties.playPathInstrument},
      {id:"KxkjsavOnd", name: "play_path_genre", value: properties.playPathGenre},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.setDuringOnboarding !== undefined && properties.setDuringOnboarding !== null) {
    eventPropertiesPlayWeb["set_during_onboarding"] = properties.setDuringOnboarding;
  }
  eventPropertiesPlayWeb["instrument"] = properties.instrument;
  eventPropertiesPlayWeb["genre"] = properties.genre;
  if (properties.fcidLegacy !== undefined && properties.fcidLegacy !== null) {
    eventPropertiesPlayWeb["fcId"] = properties.fcidLegacy;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};
  userPropertiesPlayWeb["play_path_level"] = properties.playPathLevel;
  userPropertiesPlayWeb["play_path_instrument"] = properties.playPathInstrument;
  userPropertiesPlayWeb["play_path_genre"] = properties.playPathGenre;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Path Changed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "set_during_onboarding": properties.setDuringOnboarding,
        "instrument": properties.instrument,
        "genre": properties.genre,
        "fcId": properties.fcidLegacy,
        "siteId": properties.siteidLegacy,
        }, "w74d6lmvDhb", "cbd32e05464148ca5c503aa4427d72fa846bf8acd9de64e3a5b6a03a748c94c2");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userPropertiesPlayWeb));
    PlayWeb.logEvent("Path Changed", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface AccountFCContinuedProperties {
  siteId: SiteIdValueType | null | undefined;
  accountCreate: boolean | null | undefined;
  screen: string | null | undefined;
}
/**
 * Account FC Continued: This event fires when a user clicks on a button to continue the account creation or sign-in process using their email address with/for a first-party Fender Connect account. This can fire on “Account Creation Picker”, “Account FC Creation”, or “Account Sign-In Picker” screens.
 *
 * @param properties the properties associatied with this event
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.accountCreate: This property indicates whether an account continue action is happening for a first-time creation (true) or a sign-in action (false)
 * @param properties.screen: This property indicates the name or type of screen this event is seen on.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/hTiZQecbf}
 */
export function accountFcContinued(properties: AccountFCContinuedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hTiZQecbf", "937d87a450cf3f374295d5318efd18af113af247dd8b8aa9ea5f3613a972f4df", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Account FC Continued", {
      "site_id": properties.siteId,
      "account_create": properties.accountCreate,
      "screen": properties.screen,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hTiZQecbf", "Account FC Continued", messages, [
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "KoExUo6ixz", name: "account_create", value: properties.accountCreate},
      {id: "crcwHDE1m6d7", name: "screen", value: properties.screen},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.accountCreate !== undefined && properties.accountCreate !== null) {
    eventProperties["account_create"] = properties.accountCreate;
  }
  if (properties.screen !== undefined && properties.screen !== null) {
    eventProperties["screen"] = properties.screen;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account FC Continued", {
        "site_id": properties.siteId,
        "account_create": properties.accountCreate,
        "screen": properties.screen,
        }, "hTiZQecbf", "937d87a450cf3f374295d5318efd18af113af247dd8b8aa9ea5f3613a972f4df");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Account FC Continued", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchResultClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  searchText: string | null | undefined;
}
/**
 * Search Result Clicked: This event fires when a user clicks on a search result to view the piece of content.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.searchText: This property indicates the search term typed by the user when performing a search.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/S-B-71Jgvp}
 */
export function searchResultClicked(properties: SearchResultClickedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "S-B-71Jgvp", "ed07b8cdf9baa9ea799cc565dcea026ccf4021006bebc6135d7639700e54031d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Result Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "search_text": properties.searchText,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("S-B-71Jgvp", "Search Result Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "jRzjRkfVYAXF", name: "search_text", value: properties.searchText},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  if (properties.searchText !== undefined && properties.searchText !== null) {
    eventProperties["search_text"] = properties.searchText;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Result Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        "search_text": properties.searchText,
        }, "S-B-71Jgvp", "ed07b8cdf9baa9ea799cc565dcea026ccf4021006bebc6135d7639700e54031d");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Search Result Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LandingProperties {
  name: string;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  utmMedium: string;
  utmSource: string | null | undefined;
  utmCampaign: string;
  customDestinationPageName_: string;
  marketingVersion: string;
}
/**
 * Landing: This event fires when the user visits the Fender Play web landing page at fender.com/play, but is logged out. If logged in, they would fire "Home" instead.
 *
 * When to trigger this event:
 * 1. This event fires when an unauthorized user visits the Play Unauth Landing Page
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TjJlBZsTEE/trigger/cC9zIgU9S
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.marketingVersion: This property indicates the version for this page (e.g.: Play v5)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TjJlBZsTEE}
 */
export function landing(properties: LandingProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "TjJlBZsTEE", "51615de17a546e6adf6362f239e59318c04df6b87ea79b3696733f9d373b2151", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Landing", {
      "name": properties.name,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "marketing_version": properties.marketingVersion,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("TjJlBZsTEE", "Landing", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "aKtObcCELA", name: "marketing_version", value: properties.marketingVersion},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["utm_medium"] = properties.utmMedium;
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  eventProperties["utm_campaign"] = properties.utmCampaign;
  eventProperties["marketing_version"] = properties.marketingVersion;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface CheckoutProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Checkout: This event fires when the Checkout page is loaded. Formerly "/play/checkout"
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xQw0jDPST6}
 */
export function checkout(properties: CheckoutProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xQw0jDPST6", "b81065a0c4cfabcc1f8ff863289c765004ec733d641c248a763630957c1bacf5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Checkout", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xQw0jDPST6", "Checkout", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionBundleProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
  name: string;
}
/**
 * Subscription Bundle: This event fires when the user loads the discrete plans URL which allows for the selection of monthly Play, annual Play, and annual Play + physical product subscription bundles.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/vEoT_Jf2Qt1}
 */
export function subscriptionBundle(properties: SubscriptionBundleProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "vEoT_Jf2Qt1", "51107ee5731473ee706fc14bc6c438144ea17a8442d0a419f13c49512bd4381e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Bundle", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("vEoT_Jf2Qt1", "Subscription Bundle", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface SubscriptionPromotionBundleClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  sku: string;
}
/**
 * Subscription Promotion Bundle Clicked: This event fires when the user clicks to select the physical product + Play subscription bundle option.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/8nEJ38Fmek}
 */
export function subscriptionPromotionBundleClicked(
  properties: SubscriptionPromotionBundleClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8nEJ38Fmek", "5eacde6c114001056b559234a5e2eb6bb294a2f8466cc25421bcc8eb7cda023f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Promotion Bundle Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8nEJ38Fmek", "Subscription Promotion Bundle Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Promotion Bundle Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "sku": properties.sku,
        }, "8nEJ38Fmek", "5eacde6c114001056b559234a5e2eb6bb294a2f8466cc25421bcc8eb7cda023f");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Promotion Bundle Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionPromotionMonthlyClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  sku: string;
}
/**
 * Subscription Promotion Monthly Clicked: This event fires when the user clicks to select the monthly subscription plan option (without the physical product bundled in).
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eijOlcxmzZ}
 */
export function subscriptionPromotionMonthlyClicked(
  properties: SubscriptionPromotionMonthlyClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eijOlcxmzZ", "371f4f7d96c2e3fc26c2443d00744eafae03b20ad76b706c1205f4960dd6d4a6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Promotion Monthly Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eijOlcxmzZ", "Subscription Promotion Monthly Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Promotion Monthly Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "sku": properties.sku,
        }, "eijOlcxmzZ", "371f4f7d96c2e3fc26c2443d00744eafae03b20ad76b706c1205f4960dd6d4a6");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Promotion Monthly Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionPromotionAnnualClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  sku: string;
}
/**
 * Subscription Promotion Annual Clicked: This event fires when the user clicks to select the annual subscription plan option (without the physical product bundled in).
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/4Kk80oS8Dh}
 */
export function subscriptionPromotionAnnualClicked(
  properties: SubscriptionPromotionAnnualClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4Kk80oS8Dh", "d91d6007c60bd79c62792a95c86f6afdad454d400a86f3e1ff0cca0eff6022cc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Promotion Annual Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4Kk80oS8Dh", "Subscription Promotion Annual Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Promotion Annual Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "sku": properties.sku,
        }, "4Kk80oS8Dh", "d91d6007c60bd79c62792a95c86f6afdad454d400a86f3e1ff0cca0eff6022cc");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Subscription Promotion Annual Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PromotionCheckoutProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
  name: string;
}
/**
 * Promotion Checkout: This event fires when a user loads the checkout page from a promotional subscription offering.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Ag8hnR2S1a}
 */
export function promotionCheckout(properties: PromotionCheckoutProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Ag8hnR2S1a", "0fda181dbf5bb623249986b8a0c84fbf1ab87cd929bee4693d0f64615192face", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Promotion Checkout", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Ag8hnR2S1a", "Promotion Checkout", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FeedbackModeProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string | null | undefined;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
  mmsResourceLinkId: string;
}
/**
 * Feedback Mode: This event fires when the user loads a feedback mode detail screen or page.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.mmsResourceLinkId: A unique ID that refers to the MatchMySound activity. We use this attribute to map our Course object to the specific MMS activity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mk2PkiM3sV}
 */
export function feedbackMode(properties: FeedbackModeProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mk2PkiM3sV", "5eee2162b2e797406bc4d07935c62ab45ba4230f6efdfe67defd8b84ba0b6280", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Feedback Mode", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "name": properties.name,
      "mms_resource_link_id": properties.mmsResourceLinkId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mk2PkiM3sV", "Feedback Mode", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "7_oEan8VC", name: "mms_resource_link_id", value: properties.mmsResourceLinkId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.courseId !== undefined && properties.courseId !== null) {
    eventProperties["course_id"] = properties.courseId;
  }
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["name"] = properties.name;
  eventProperties["mms_resource_link_id"] = properties.mmsResourceLinkId;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FeedbackModeOnboardingProperties {
  name: string;
  step: number;
  totalSteps: number;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  customDestinationPageName_: string;
  firstRun: boolean | null | undefined;
}
/**
 * Feedback Mode Onboarding: The Feedback Mode Onboarding loaded, either automatically (when the user first visits a Feedback Mode activity) or via the "what is this?" button next to a Feedback Mode activity.
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.step: The current step/page that a user is seeing in a UI component like the Onboarding Tour or a step in a checkout process. Used to track how many of the total steps/pages a user sees.
 * @param properties.totalSteps: The total number of steps/pages that exist in a UI component like the Onboarding Tour. Used to track how many steps/pages a user sees.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.firstRun: Used to track whether or not an Onboarding Modal was automatically opened by our app when a user first encounters a specific feature (first_run=true); or, whether it was manually triggered via a user's action, like clicking a 'what is this?' or 'help' button (first_run=false).
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/1fCgaCV8xt}
 */
export function feedbackModeOnboarding(
  properties: FeedbackModeOnboardingProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1fCgaCV8xt", "21e3b1fe620b654ea9a7ed5133f14c30de1521dddb558b16fe089ba82d65ad81", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Feedback Mode Onboarding", {
      "name": properties.name,
      "step": properties.step,
      "total_steps": properties.totalSteps,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "first_run": properties.firstRun,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1fCgaCV8xt", "Feedback Mode Onboarding", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "oh6t-j8ZgC", name: "step", value: properties.step},
      {id: "6fWvBbCfYv", name: "total_steps", value: properties.totalSteps},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "c9ATW-BG9o", name: "first_run", value: properties.firstRun},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  eventProperties["step"] = properties.step;
  eventProperties["total_steps"] = properties.totalSteps;
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.firstRun !== undefined && properties.firstRun !== null) {
    eventProperties["first_run"] = properties.firstRun;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FeedbackModeOnboardingAdvancedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  step: number;
  totalSteps: number;
  siteidLegacy: string | null | undefined;
}
/**
 * Feedback Mode Onboarding Advanced: This fires whenever a user clicks the "NEXT" button in the onboarding modal, which will advance to the next slide/screen.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.step: The current step/page that a user is seeing in a UI component like the Onboarding Tour or a step in a checkout process. Used to track how many of the total steps/pages a user sees.
 * @param properties.totalSteps: The total number of steps/pages that exist in a UI component like the Onboarding Tour. Used to track how many steps/pages a user sees.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/A-b1A5Plyr}
 */
export function feedbackModeOnboardingAdvanced(
  properties: FeedbackModeOnboardingAdvancedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "A-b1A5Plyr", "c7e49241a42c708be1db20279921a731ecd8f9d138aeb1aa8ce20d4309b2ea80", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Feedback Mode Onboarding Advanced", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "step": properties.step,
      "total_steps": properties.totalSteps,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("A-b1A5Plyr", "Feedback Mode Onboarding Advanced", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "oh6t-j8ZgC", name: "step", value: properties.step},
      {id: "6fWvBbCfYv", name: "total_steps", value: properties.totalSteps},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["step"] = properties.step;
  eventPropertiesPlayWeb["total_steps"] = properties.totalSteps;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Mode Onboarding Advanced", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "step": properties.step,
        "total_steps": properties.totalSteps,
        "siteId": properties.siteidLegacy,
        }, "A-b1A5Plyr", "c7e49241a42c708be1db20279921a731ecd8f9d138aeb1aa8ce20d4309b2ea80");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Feedback Mode Onboarding Advanced", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface FeedbackModeOnboardingDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  step: number;
  totalSteps: number;
  siteidLegacy: string | null | undefined;
}
/**
 * Feedback Mode Onboarding Dismissed: This event fires whenever a user clicks the close button in the onboarding modal. They can do this during any step/slide of the modal.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.step: The current step/page that a user is seeing in a UI component like the Onboarding Tour or a step in a checkout process. Used to track how many of the total steps/pages a user sees.
 * @param properties.totalSteps: The total number of steps/pages that exist in a UI component like the Onboarding Tour. Used to track how many steps/pages a user sees.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/qdUF3h1JdB}
 */
export function feedbackModeOnboardingDismissed(
  properties: FeedbackModeOnboardingDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qdUF3h1JdB", "c90070eaf3bbbfacc4a7c48b51c6d24f16ee62814e5f84aad8d92b6982075de6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Feedback Mode Onboarding Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "step": properties.step,
      "total_steps": properties.totalSteps,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qdUF3h1JdB", "Feedback Mode Onboarding Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "oh6t-j8ZgC", name: "step", value: properties.step},
      {id: "6fWvBbCfYv", name: "total_steps", value: properties.totalSteps},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["step"] = properties.step;
  eventPropertiesPlayWeb["total_steps"] = properties.totalSteps;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Mode Onboarding Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "step": properties.step,
        "total_steps": properties.totalSteps,
        "siteId": properties.siteidLegacy,
        }, "qdUF3h1JdB", "c90070eaf3bbbfacc4a7c48b51c6d24f16ee62814e5f84aad8d92b6982075de6");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Feedback Mode Onboarding Dismissed", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface FeedbackModeOnboardingCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  step: number;
  totalSteps: number;
  siteidLegacy: string | null | undefined;
}
/**
 * Feedback Mode Onboarding Completed: This fires whenever a user clicks the final CTA in the onboarding modal, which then closes the modal.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.step: The current step/page that a user is seeing in a UI component like the Onboarding Tour or a step in a checkout process. Used to track how many of the total steps/pages a user sees.
 * @param properties.totalSteps: The total number of steps/pages that exist in a UI component like the Onboarding Tour. Used to track how many steps/pages a user sees.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/_ya8ZSzDd7}
 */
export function feedbackModeOnboardingCompleted(
  properties: FeedbackModeOnboardingCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_ya8ZSzDd7", "a53c0681f6ed98aa471ae9a6de362ddd1b018644f158d5731baacb9dcbd39502", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Feedback Mode Onboarding Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "step": properties.step,
      "total_steps": properties.totalSteps,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_ya8ZSzDd7", "Feedback Mode Onboarding Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "oh6t-j8ZgC", name: "step", value: properties.step},
      {id: "6fWvBbCfYv", name: "total_steps", value: properties.totalSteps},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["step"] = properties.step;
  eventPropertiesPlayWeb["total_steps"] = properties.totalSteps;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Mode Onboarding Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "step": properties.step,
        "total_steps": properties.totalSteps,
        "siteId": properties.siteidLegacy,
        }, "_ya8ZSzDd7", "a53c0681f6ed98aa471ae9a6de362ddd1b018644f158d5731baacb9dcbd39502");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Feedback Mode Onboarding Completed", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface FeedbackModeScoreReceivedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string | null | undefined;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  mmsScoreOverall: number;
  mmsScoreRhythm: number;
  mmsScorePitch: number;
  mmsLengthPlayedPercentage: number;
  mmsResourceLinkId: string;
  mmsScoreTempo: number;
}
/**
 * Feedback Mode Score Received: This event fires when a user receives a score from MatchMySound after stopping or completing their exercise, while "recording" via their microphone. They are shown their summary score, and the detailed scoring feedback is revealed underneath the tablature.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.mmsScoreOverall: From the MatchMySound score data, this is the user's overall score.

This attribute on the MMS side is called 'score'. It is calculated by averaging the 'rhythm score' and 'pitch score'
 * @param properties.mmsScoreRhythm: From the MathMySound score data, this is the user's rhythm/timing score.

This score is NOT shown to the user in the UI, but is rather used to calculate the 'timing score'.

This attribute on the MMS side is called 'rhythm_score'

 * @param properties.mmsScorePitch: From the MathMySound score data, this is the user's pitch score.

This attribute on the MMS side is called 'nscore'
 * @param properties.mmsLengthPlayedPercentage: From the MathMySound score data, this is how much of the exercise the user played during their recorded session, up to a maximum of 100%.

This attribute on the MMS side is called 'match_percent'
 * @param properties.mmsResourceLinkId: A unique ID that refers to the MatchMySound activity. We use this attribute to map our Course object to the specific MMS activity.
 * @param properties.mmsScoreTempo: Tempo score. This may be irrelevant to our use case, since we don't assign a 'tempo goal' to the exercises, but we'll record it anyway just in case we need the data.

This score is NOT shown to the user in the UI, but is rather used to calculate the 'timing score'.

This attribute on the MMS side is called 'tempo_score'
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/unibDpWg-8}
 */
export function feedbackModeScoreReceived(
  properties: FeedbackModeScoreReceivedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "unibDpWg-8", "e0c3af0ccdc70de239a4176f5db6ed0b48f106c7116c7ad0833f71be442ef1ac", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Feedback Mode Score Received", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "mms_score_overall": properties.mmsScoreOverall,
      "mms_score_rhythm": properties.mmsScoreRhythm,
      "mms_score_pitch": properties.mmsScorePitch,
      "mms_length_played_percentage": properties.mmsLengthPlayedPercentage,
      "mms_resource_link_id": properties.mmsResourceLinkId,
      "mms_score_tempo": properties.mmsScoreTempo,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("unibDpWg-8", "Feedback Mode Score Received", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "-IJsbAmByK", name: "mms_score_overall", value: properties.mmsScoreOverall},
      {id: "qimtvJqag-", name: "mms_score_rhythm", value: properties.mmsScoreRhythm},
      {id: "hNF-CROxV", name: "mms_score_pitch", value: properties.mmsScorePitch},
      {id: "YtsCwToLM5", name: "mms_length_played_percentage", value: properties.mmsLengthPlayedPercentage},
      {id: "7_oEan8VC", name: "mms_resource_link_id", value: properties.mmsResourceLinkId},
      {id: "GXUyk28XVM", name: "mms_score_tempo", value: properties.mmsScoreTempo},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.courseId !== undefined && properties.courseId !== null) {
    eventProperties["course_id"] = properties.courseId;
  }
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["mms_score_overall"] = properties.mmsScoreOverall;
  eventProperties["mms_score_rhythm"] = properties.mmsScoreRhythm;
  eventProperties["mms_score_pitch"] = properties.mmsScorePitch;
  eventProperties["mms_length_played_percentage"] = properties.mmsLengthPlayedPercentage;
  eventProperties["mms_resource_link_id"] = properties.mmsResourceLinkId;
  eventProperties["mms_score_tempo"] = properties.mmsScoreTempo;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Mode Score Received", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "mms_score_overall": properties.mmsScoreOverall,
        "mms_score_rhythm": properties.mmsScoreRhythm,
        "mms_score_pitch": properties.mmsScorePitch,
        "mms_length_played_percentage": properties.mmsLengthPlayedPercentage,
        "mms_resource_link_id": properties.mmsResourceLinkId,
        "mms_score_tempo": properties.mmsScoreTempo,
        }, "unibDpWg-8", "e0c3af0ccdc70de239a4176f5db6ed0b48f106c7116c7ad0833f71be442ef1ac");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Feedback Mode Score Received", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface GoogleSignInClickedProperties {
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  targetUrl: string | null | undefined;
}
/**
 * Google Sign In Clicked: This event fires when the user clicks to sign in with Google.
 *
 * When to trigger this event:
 * 1. User clicks "Sign in with Google"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mdUACA89uf/trigger/AvnVmMxyq5
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.targetUrl: This property indicates the URL targeted for this action, e.g. 'http://www.fender.com'
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/mdUACA89uf}
 */
export function googleSignInClicked(properties: GoogleSignInClickedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mdUACA89uf", "81ed12bf3de00027ac22f430b7cefe415cdffa851de685d406841a72a3166f98", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Google Sign In Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "site_id": properties.siteId,
      "target_url": properties.targetUrl,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mdUACA89uf", "Google Sign In Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "QzjC77D_h", name: "target_url", value: properties.targetUrl},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.targetUrl !== undefined && properties.targetUrl !== null) {
    eventProperties["target_url"] = properties.targetUrl;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Google Sign In Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "site_id": properties.siteId,
        "target_url": properties.targetUrl,
        }, "mdUACA89uf", "81ed12bf3de00027ac22f430b7cefe415cdffa851de685d406841a72a3166f98");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Google Sign In Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FacebookSignInClickedProperties {
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  targetUrl: string | null | undefined;
}
/**
 * Facebook Sign In Clicked: This event fires when the user clicks to sign in with Facebook.
 *
 * When to trigger this event:
 * 1. User clicks "Sign in with Facebook"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/sQRTPUyHxi/trigger/8sSIHdNFm
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.targetUrl: This property indicates the URL targeted for this action, e.g. 'http://www.fender.com'
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/sQRTPUyHxi}
 */
export function facebookSignInClicked(
  properties: FacebookSignInClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sQRTPUyHxi", "89ba2ea53cb05c2f5ac7f7476877628a122f013978446e82a3b2617c64af73a3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Facebook Sign In Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "site_id": properties.siteId,
      "target_url": properties.targetUrl,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sQRTPUyHxi", "Facebook Sign In Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "QzjC77D_h", name: "target_url", value: properties.targetUrl},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.targetUrl !== undefined && properties.targetUrl !== null) {
    eventProperties["target_url"] = properties.targetUrl;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Facebook Sign In Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "site_id": properties.siteId,
        "target_url": properties.targetUrl,
        }, "sQRTPUyHxi", "89ba2ea53cb05c2f5ac7f7476877628a122f013978446e82a3b2617c64af73a3");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Facebook Sign In Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AppleSignInClickedProperties {
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  targetUrl: string | null | undefined;
}
/**
 * Apple Sign In Clicked: This event fires when the user clicks to Sign In with Apple.
 *
 * When to trigger this event:
 * 1. User clicks "Sign in with Apple"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/DfyxwpTAgl/trigger/nfiWCPPDC
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.targetUrl: This property indicates the URL targeted for this action, e.g. 'http://www.fender.com'
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/DfyxwpTAgl}
 */
export function appleSignInClicked(properties: AppleSignInClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DfyxwpTAgl", "5732ffebb27f9616784640e55dde2190740a601b0897ad60c6f2eee8352cecb0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Apple Sign In Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "site_id": properties.siteId,
      "target_url": properties.targetUrl,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DfyxwpTAgl", "Apple Sign In Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "QzjC77D_h", name: "target_url", value: properties.targetUrl},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.targetUrl !== undefined && properties.targetUrl !== null) {
    eventProperties["target_url"] = properties.targetUrl;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Apple Sign In Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "site_id": properties.siteId,
        "target_url": properties.targetUrl,
        }, "DfyxwpTAgl", "5732ffebb27f9616784640e55dde2190740a601b0897ad60c6f2eee8352cecb0");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Apple Sign In Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SignUpLinkClickedProperties {
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
}
/**
 * Sign Up Link Clicked: This event fires when the user clicks to switch to "sign up" from the "sign in" view.
 *
 * When to trigger this event:
 * 1. User clicks "Sign Up" after "Don't have a Fender account?"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/RlDHAbvMo/trigger/6h11Oy0tT
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/RlDHAbvMo}
 */
export function signUpLinkClicked(properties: SignUpLinkClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RlDHAbvMo", "ae70aa0ffd30d8e33c6764d28095a2663789d6d90af4df90fd3f3c02516e5871", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Sign Up Link Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "site_id": properties.siteId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RlDHAbvMo", "Sign Up Link Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Link Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "site_id": properties.siteId,
        }, "RlDHAbvMo", "ae70aa0ffd30d8e33c6764d28095a2663789d6d90af4df90fd3f3c02516e5871");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Sign Up Link Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NavigationClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  navigationLabel: string;
  hasDropdown: boolean;
}
/**
 * Navigation Clicked: This event fires when the user interacts/clicks within the navigation menu. Formerly "Click Main Navigation"
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/X6JeGSE_y1/trigger/-7w6wXIEV
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.navigationLabel: This property has the name of the navigation item. We don't want to blindly pass values through here (e.g. html, 'new!', other languages, etc.) because then we can't combine the data.
 * @param properties.hasDropdown: This indicates whether the navigation item clicked on with this event has an expansion interaction/is parent level (true) or not/is child level (false)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/X6JeGSE_y1}
 */
export function navigationClicked(properties: NavigationClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "X6JeGSE_y1", "a95ece1d43db18ea8b2668361fd347e59d7a9840e17704025172377937e92838", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Navigation Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "navigation_label": properties.navigationLabel,
      "has_dropdown": properties.hasDropdown,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("X6JeGSE_y1", "Navigation Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "0YgYIBtrs3", name: "navigation_label", value: properties.navigationLabel},
      {id: "wEAX4tL_s", name: "has_dropdown", value: properties.hasDropdown},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["navigation_label"] = properties.navigationLabel;
  eventProperties["has_dropdown"] = properties.hasDropdown;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Navigation Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "navigation_label": properties.navigationLabel,
        "has_dropdown": properties.hasDropdown,
        }, "X6JeGSE_y1", "a95ece1d43db18ea8b2668361fd347e59d7a9840e17704025172377937e92838");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Navigation Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ActivityStartedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  activityId: string | null | undefined;
  activitySlug: string | null | undefined;
  activityType: ActivityTypeValueType;
  activityTitle: string | null | undefined;
  activityScore: number | null | undefined;
  activityTypeLesson: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  userId_: string;
  repeat: number | null | undefined;
  playLevelsInpathTotal: number;
  playCoursesInlevelTotal: number;
  playActivitiesIncourseTotal: number;
  activityInstrument: ActivityInstrumentValueType | null | undefined;
  activityGenre: ActivityGenreValueType | null | undefined;
  activityLevel: number | null | undefined;
}
/**
 * Activity Started: This event fires when a learning activity (lesson video, practice mode, feedback mode, chord challenge) is launched in Fender Play.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.activityId: This property indicates the internal ID of the activity object within our LMS.
 * @param properties.activitySlug: This property indicates the slug of the activity object within our LMS, which could be used for the web URL.
 * @param properties.activityType: This property indicates the main type of curriculum activity for this event.
 * @param properties.activityTitle: This property indicates the title of the activity within our LMS.
 * @param properties.activityScore: If this activity has a score (feedback mode, chord challenge), store it here.
 * @param properties.activityTypeLesson: If activity_type is set to lesson-video, subcategory of lesson type should display here.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.repeat: This property should be incremented by 1 each time (starting at 0) if user immediately repeats the activity after completing it (Activity Completed). Example: First firing sets this to 0, repeat first time sets to 1, repeat second time sets to 2.
This isn't smart enough to capture a full session or between sessions yet.
 * @param properties.playLevelsInpathTotal: This user trait indicates the total number of levels in the user's active path. Could be used with play_levels_inpath_completed to calculate a percentage.
 * @param properties.playCoursesInlevelTotal: This user trait indicates the total number of courses in the user's active level. Could be used with play_courses_inlevel_completed to calculate a percentage.
 * @param properties.playActivitiesIncourseTotal: This user trait indicates the total number of activities (lesson video, practice mode, feedback mode, etc.) within the user's active course. Could be used with play_activities_incourse_completed to calculate a percentage.
 * @param properties.activityInstrument: This property indicates the instrument for the activity. If there's more than one instrument coming from the back-end, this should be the instrument set based on where the user is accessing it (path, collection, etc.)
 * @param properties.activityGenre: This property indicates the genre for the activity, if it has one and/or is accessed on path.
 * @param properties.activityLevel: This property indicates the level number of the activity if accessed from within the users' path only (i.e. not via a collection or search result, etc)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/2GfP067a44}
 */
export function activityStarted(properties: ActivityStartedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2GfP067a44", "8043a2af66488102676d2151d9f274c97b7f1c4ae327a29868bcb0c3ed69c6b0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Activity Started", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "activity_id": properties.activityId,
      "activity_slug": properties.activitySlug,
      "activity_type": properties.activityType,
      "activity_title": properties.activityTitle,
      "activity_score": properties.activityScore,
      "activity_type_lesson": properties.activityTypeLesson,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "repeat": properties.repeat,
      "activity_instrument": properties.activityInstrument,
      "activity_genre": properties.activityGenre,
      "activity_level": properties.activityLevel,
      }, {
      "play_levels_inpath_total": properties.playLevelsInpathTotal,
      "play_courses_inlevel_total": properties.playCoursesInlevelTotal,
      "play_activities_incourse_total": properties.playActivitiesIncourseTotal,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2GfP067a44", "Activity Started", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "0scsV5MvF5XV", name: "activity_id", value: properties.activityId},
      {id: "zmPMjKsIoF9c", name: "activity_slug", value: properties.activitySlug},
      {id: "58S6ZDoyrY", name: "activity_type", value: properties.activityType},
      {id: "VwSYbEn4f5J1", name: "activity_title", value: properties.activityTitle},
      {id: "sGabZ0AU9S", name: "activity_score", value: properties.activityScore},
      {id: "KoZ57WH5Cj", name: "activity_type_lesson", value: properties.activityTypeLesson},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "NqKuRVUhGD", name: "repeat", value: properties.repeat},
      {id: "QumFqYQn2", name: "activity_instrument", value: properties.activityInstrument},
      {id: "gNSL69a17C", name: "activity_genre", value: properties.activityGenre},
      {id: "T2tOfp7ar5", name: "activity_level", value: properties.activityLevel},
      ], [
      {id:"vlpRgflD6k", name: "play_levels_inpath_total", value: properties.playLevelsInpathTotal},
      {id:"Q5AbiasxcS", name: "play_courses_inlevel_total", value: properties.playCoursesInlevelTotal},
      {id:"L0pxxo9RuJ", name: "play_activities_incourse_total", value: properties.playActivitiesIncourseTotal},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.activityId !== undefined && properties.activityId !== null) {
    eventProperties["activity_id"] = properties.activityId;
  }
  if (properties.activitySlug !== undefined && properties.activitySlug !== null) {
    eventProperties["activity_slug"] = properties.activitySlug;
  }
  eventProperties["activity_type"] = properties.activityType;
  if (properties.activityTitle !== undefined && properties.activityTitle !== null) {
    eventProperties["activity_title"] = properties.activityTitle;
  }
  if (properties.activityScore !== undefined && properties.activityScore !== null) {
    eventProperties["activity_score"] = properties.activityScore;
  }
  if (properties.activityTypeLesson !== undefined && properties.activityTypeLesson !== null) {
    eventProperties["activity_type_lesson"] = properties.activityTypeLesson;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  if (properties.repeat !== undefined && properties.repeat !== null) {
    eventProperties["repeat"] = properties.repeat;
  }
  if (properties.activityInstrument !== undefined && properties.activityInstrument !== null) {
    eventProperties["activity_instrument"] = properties.activityInstrument;
  }
  if (properties.activityGenre !== undefined && properties.activityGenre !== null) {
    eventProperties["activity_genre"] = properties.activityGenre;
  }
  if (properties.activityLevel !== undefined && properties.activityLevel !== null) {
    eventProperties["activity_level"] = properties.activityLevel;
  }

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_levels_inpath_total"] = properties.playLevelsInpathTotal;
  userProperties["play_courses_inlevel_total"] = properties.playCoursesInlevelTotal;
  userProperties["play_activities_incourse_total"] = properties.playActivitiesIncourseTotal;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Activity Started", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "activity_id": properties.activityId,
        "activity_slug": properties.activitySlug,
        "activity_type": properties.activityType,
        "activity_title": properties.activityTitle,
        "activity_score": properties.activityScore,
        "activity_type_lesson": properties.activityTypeLesson,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        "repeat": properties.repeat,
        "activity_instrument": properties.activityInstrument,
        "activity_genre": properties.activityGenre,
        "activity_level": properties.activityLevel,
        }, "2GfP067a44", "8043a2af66488102676d2151d9f274c97b7f1c4ae327a29868bcb0c3ed69c6b0");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ActivityCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  activityId: string | null | undefined;
  activitySlug: string | null | undefined;
  activityType: ActivityTypeValueType;
  activityTitle: string | null | undefined;
  activityScore: number | null | undefined;
  activityTypeLesson: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  userId_: string;
  nextActivityType: string | null | undefined;
  nextActivitySlug: string | null | undefined;
  nextActivityId: string | null | undefined;
  nextActivityTitle: string | null | undefined;
  playLevelsInpathCompleted: number;
  playCoursesInlevelCompleted: number;
  playActivitiesIncourseCompleted: number;
  isOnPath: boolean | null | undefined;
  activityInstrument: ActivityInstrumentValueType | null | undefined;
  activityGenre: ActivityGenreValueType | null | undefined;
  activityLevel: number | null | undefined;
}
/**
 * Activity Completed: This event fires when enough of an activity within the Fender Play curriculum has been viewed/used by a user, it's considered complete.
 *
 * When to trigger this event:
 * 1. Basics lesson watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/ph7CWay2S
 * 2. Song lesson watched to 95% (originally 3m30s but found too many outliers)
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/nUvzac5xE
 * 3. Exercise lesson video watched to 90% of total video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/tJn4REZKX
 * 4. Riff lesson watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/Jbamz8oni
 * 5. Theory lesson watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/NM31rD0VN
 * 6. Technique lesson watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/7f6Gffdb1
 * 7. Chord lesson watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/YmxILZOWO
 * 8. Tone lesson watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/ycDNk3-xI
 * 9. Glossary video (not considered a lesson) watched to 75% of video length
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/RCdXsS74A
 * 10. Feedback Mode receives a score back with no error message interrupting
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/EBsqxbPV2
 * 11. Practice Mode viewed to 25% measure-based completion if a skill or 50% measure-based completion if a song.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/dIE2WxpH6
 * 12. Chord challenge completed modal is popped up and dismissed (with or without score)
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/mPw8dBstw
 * 13. Course is completed when all lesson video activities are completed (with their own logic) but agnostic to practice mode, feedback mode, or any future chord challenges or other activity types (which are optional to the learning process). For mobile, this is coming from the backend, so could be a false positive if the user had previously completed the course.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK/trigger/yoNEDdqmx
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.activityId: This property indicates the internal ID of the activity object within our LMS.
 * @param properties.activitySlug: This property indicates the slug of the activity object within our LMS, which could be used for the web URL.
 * @param properties.activityType: This property indicates the main type of curriculum activity for this event.
 * @param properties.activityTitle: This property indicates the title of the activity within our LMS.
 * @param properties.activityScore: If this activity has a score (feedback mode, chord challenge), store it here.
 * @param properties.activityTypeLesson: If activity_type is set to lesson-video, subcategory of lesson type should display here.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.nextActivityType: This property indicates the type of the next activity that occurs after the user performs this action.
 * @param properties.nextActivitySlug: This property indicates the slug of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityId: This property indicates the ID of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityTitle: This property indicates the title of the next activity that occurs after the user performs this action.
 * @param properties.playLevelsInpathCompleted: This user trait indicates the amount of levels within a path that this user has fully completed, as pulled from the backend. Please update every time the user switches levels, either actively or passively.
 * @param properties.playCoursesInlevelCompleted: This user trait indicates the number of completed courses within the users' active level, as pulled from the backend. Could be used with play_courses_inlevel_total to calculate a percentage.
 * @param properties.playActivitiesIncourseCompleted: This user trait indicates the total amount of activities (video lesson, practice mode, feedback mode) the user has completed within their active course, as provided by the backend. Could be used with play_activities_incourse_total to calculate a percentage.
 * @param properties.isOnPath: This property indicates whether this action was performed to a piece of content within the context of a user's path or not.
 * @param properties.activityInstrument: This property indicates the instrument for the activity. If there's more than one instrument coming from the back-end, this should be the instrument set based on where the user is accessing it (path, collection, etc.)
 * @param properties.activityGenre: This property indicates the genre for the activity, if it has one and/or is accessed on path.
 * @param properties.activityLevel: This property indicates the level number of the activity if accessed from within the users' path only (i.e. not via a collection or search result, etc)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/T6Rvgx_qdK}
 */
export function activityCompleted(properties: ActivityCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "T6Rvgx_qdK", "4eb9d73e0ab2bcccd681aa73d944e04ae26cebdebdeaa2ad25f51b0b1eff8ed5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Activity Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "activity_id": properties.activityId,
      "activity_slug": properties.activitySlug,
      "activity_type": properties.activityType,
      "activity_title": properties.activityTitle,
      "activity_score": properties.activityScore,
      "activity_type_lesson": properties.activityTypeLesson,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "next_activity_type": properties.nextActivityType,
      "next_activity_slug": properties.nextActivitySlug,
      "next_activity_id": properties.nextActivityId,
      "next_activity_title": properties.nextActivityTitle,
      "is_on_path": properties.isOnPath,
      "activity_instrument": properties.activityInstrument,
      "activity_genre": properties.activityGenre,
      "activity_level": properties.activityLevel,
      }, {
      "play_levels_inpath_completed": properties.playLevelsInpathCompleted,
      "play_courses_inlevel_completed": properties.playCoursesInlevelCompleted,
      "play_activities_incourse_completed": properties.playActivitiesIncourseCompleted,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("T6Rvgx_qdK", "Activity Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "0scsV5MvF5XV", name: "activity_id", value: properties.activityId},
      {id: "zmPMjKsIoF9c", name: "activity_slug", value: properties.activitySlug},
      {id: "58S6ZDoyrY", name: "activity_type", value: properties.activityType},
      {id: "VwSYbEn4f5J1", name: "activity_title", value: properties.activityTitle},
      {id: "sGabZ0AU9S", name: "activity_score", value: properties.activityScore},
      {id: "KoZ57WH5Cj", name: "activity_type_lesson", value: properties.activityTypeLesson},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "kbeM5avar8tP", name: "next_activity_type", value: properties.nextActivityType},
      {id: "A2o2tN3vyDPo", name: "next_activity_slug", value: properties.nextActivitySlug},
      {id: "Kh9sBptRQ-0q", name: "next_activity_id", value: properties.nextActivityId},
      {id: "e-PCkn29vMKF", name: "next_activity_title", value: properties.nextActivityTitle},
      {id: "Q4hiTa0pVJxi", name: "is_on_path", value: properties.isOnPath},
      {id: "QumFqYQn2", name: "activity_instrument", value: properties.activityInstrument},
      {id: "gNSL69a17C", name: "activity_genre", value: properties.activityGenre},
      {id: "T2tOfp7ar5", name: "activity_level", value: properties.activityLevel},
      ], [
      {id:"yJI1ZxM7xy", name: "play_levels_inpath_completed", value: properties.playLevelsInpathCompleted},
      {id:"MRGVziVa4A", name: "play_courses_inlevel_completed", value: properties.playCoursesInlevelCompleted},
      {id:"ncFNXtyhlk", name: "play_activities_incourse_completed", value: properties.playActivitiesIncourseCompleted},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.activityId !== undefined && properties.activityId !== null) {
    eventProperties["activity_id"] = properties.activityId;
  }
  if (properties.activitySlug !== undefined && properties.activitySlug !== null) {
    eventProperties["activity_slug"] = properties.activitySlug;
  }
  eventProperties["activity_type"] = properties.activityType;
  if (properties.activityTitle !== undefined && properties.activityTitle !== null) {
    eventProperties["activity_title"] = properties.activityTitle;
  }
  if (properties.activityScore !== undefined && properties.activityScore !== null) {
    eventProperties["activity_score"] = properties.activityScore;
  }
  if (properties.activityTypeLesson !== undefined && properties.activityTypeLesson !== null) {
    eventProperties["activity_type_lesson"] = properties.activityTypeLesson;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  if (properties.nextActivityType !== undefined && properties.nextActivityType !== null) {
    eventProperties["next_activity_type"] = properties.nextActivityType;
  }
  if (properties.nextActivitySlug !== undefined && properties.nextActivitySlug !== null) {
    eventProperties["next_activity_slug"] = properties.nextActivitySlug;
  }
  if (properties.nextActivityId !== undefined && properties.nextActivityId !== null) {
    eventProperties["next_activity_id"] = properties.nextActivityId;
  }
  if (properties.nextActivityTitle !== undefined && properties.nextActivityTitle !== null) {
    eventProperties["next_activity_title"] = properties.nextActivityTitle;
  }
  if (properties.isOnPath !== undefined && properties.isOnPath !== null) {
    eventProperties["is_on_path"] = properties.isOnPath;
  }
  if (properties.activityInstrument !== undefined && properties.activityInstrument !== null) {
    eventProperties["activity_instrument"] = properties.activityInstrument;
  }
  if (properties.activityGenre !== undefined && properties.activityGenre !== null) {
    eventProperties["activity_genre"] = properties.activityGenre;
  }
  if (properties.activityLevel !== undefined && properties.activityLevel !== null) {
    eventProperties["activity_level"] = properties.activityLevel;
  }

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_levels_inpath_completed"] = properties.playLevelsInpathCompleted;
  userProperties["play_courses_inlevel_completed"] = properties.playCoursesInlevelCompleted;
  userProperties["play_activities_incourse_completed"] = properties.playActivitiesIncourseCompleted;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Activity Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "activity_id": properties.activityId,
        "activity_slug": properties.activitySlug,
        "activity_type": properties.activityType,
        "activity_title": properties.activityTitle,
        "activity_score": properties.activityScore,
        "activity_type_lesson": properties.activityTypeLesson,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        "next_activity_type": properties.nextActivityType,
        "next_activity_slug": properties.nextActivitySlug,
        "next_activity_id": properties.nextActivityId,
        "next_activity_title": properties.nextActivityTitle,
        "is_on_path": properties.isOnPath,
        "activity_instrument": properties.activityInstrument,
        "activity_genre": properties.activityGenre,
        "activity_level": properties.activityLevel,
        }, "T6Rvgx_qdK", "4eb9d73e0ab2bcccd681aa73d944e04ae26cebdebdeaa2ad25f51b0b1eff8ed5");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ActivityDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  activityId: string | null | undefined;
  activitySlug: string | null | undefined;
  activityType: ActivityTypeValueType;
  activityTitle: string | null | undefined;
  activityScore: number | null | undefined;
  activityTypeLesson: string | null | undefined;
  activityInstrument: ActivityInstrumentValueType | null | undefined;
  activityGenre: ActivityGenreValueType | null | undefined;
  activityLevel: number | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Activity Dismissed: This event fires when a user clicks close button, back button, or navigates away from an active learning activity (e.g. lesson video, practice mode, feedback mode, chord challenge)
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.activityId: This property indicates the internal ID of the activity object within our LMS.
 * @param properties.activitySlug: This property indicates the slug of the activity object within our LMS, which could be used for the web URL.
 * @param properties.activityType: This property indicates the main type of curriculum activity for this event.
 * @param properties.activityTitle: This property indicates the title of the activity within our LMS.
 * @param properties.activityScore: If this activity has a score (feedback mode, chord challenge), store it here.
 * @param properties.activityTypeLesson: If activity_type is set to lesson-video, subcategory of lesson type should display here.
 * @param properties.activityInstrument: This property indicates the instrument for the activity. If there's more than one instrument coming from the back-end, this should be the instrument set based on where the user is accessing it (path, collection, etc.)
 * @param properties.activityGenre: This property indicates the genre for the activity, if it has one and/or is accessed on path.
 * @param properties.activityLevel: This property indicates the level number of the activity if accessed from within the users' path only (i.e. not via a collection or search result, etc)
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/55lMCfXAYu}
 */
export function activityDismissed(properties: ActivityDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "55lMCfXAYu", "ee0ca78b9b51bc96d635323b4bb7f98af3ce200ba234cb6bfa48795f0c76d066", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Activity Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "activity_id": properties.activityId,
      "activity_slug": properties.activitySlug,
      "activity_type": properties.activityType,
      "activity_title": properties.activityTitle,
      "activity_score": properties.activityScore,
      "activity_type_lesson": properties.activityTypeLesson,
      "activity_instrument": properties.activityInstrument,
      "activity_genre": properties.activityGenre,
      "activity_level": properties.activityLevel,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("55lMCfXAYu", "Activity Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "0scsV5MvF5XV", name: "activity_id", value: properties.activityId},
      {id: "zmPMjKsIoF9c", name: "activity_slug", value: properties.activitySlug},
      {id: "58S6ZDoyrY", name: "activity_type", value: properties.activityType},
      {id: "VwSYbEn4f5J1", name: "activity_title", value: properties.activityTitle},
      {id: "sGabZ0AU9S", name: "activity_score", value: properties.activityScore},
      {id: "KoZ57WH5Cj", name: "activity_type_lesson", value: properties.activityTypeLesson},
      {id: "QumFqYQn2", name: "activity_instrument", value: properties.activityInstrument},
      {id: "gNSL69a17C", name: "activity_genre", value: properties.activityGenre},
      {id: "T2tOfp7ar5", name: "activity_level", value: properties.activityLevel},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.activityId !== undefined && properties.activityId !== null) {
    eventPropertiesPlayWeb["activity_id"] = properties.activityId;
  }
  if (properties.activitySlug !== undefined && properties.activitySlug !== null) {
    eventPropertiesPlayWeb["activity_slug"] = properties.activitySlug;
  }
  eventPropertiesPlayWeb["activity_type"] = properties.activityType;
  if (properties.activityTitle !== undefined && properties.activityTitle !== null) {
    eventPropertiesPlayWeb["activity_title"] = properties.activityTitle;
  }
  if (properties.activityScore !== undefined && properties.activityScore !== null) {
    eventPropertiesPlayWeb["activity_score"] = properties.activityScore;
  }
  if (properties.activityTypeLesson !== undefined && properties.activityTypeLesson !== null) {
    eventPropertiesPlayWeb["activity_type_lesson"] = properties.activityTypeLesson;
  }
  if (properties.activityInstrument !== undefined && properties.activityInstrument !== null) {
    eventPropertiesPlayWeb["activity_instrument"] = properties.activityInstrument;
  }
  if (properties.activityGenre !== undefined && properties.activityGenre !== null) {
    eventPropertiesPlayWeb["activity_genre"] = properties.activityGenre;
  }
  if (properties.activityLevel !== undefined && properties.activityLevel !== null) {
    eventPropertiesPlayWeb["activity_level"] = properties.activityLevel;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Activity Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "activity_id": properties.activityId,
        "activity_slug": properties.activitySlug,
        "activity_type": properties.activityType,
        "activity_title": properties.activityTitle,
        "activity_score": properties.activityScore,
        "activity_type_lesson": properties.activityTypeLesson,
        "activity_instrument": properties.activityInstrument,
        "activity_genre": properties.activityGenre,
        "activity_level": properties.activityLevel,
        "siteId": properties.siteidLegacy,
        }, "55lMCfXAYu", "ee0ca78b9b51bc96d635323b4bb7f98af3ce200ba234cb6bfa48795f0c76d066");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Activity Dismissed", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface CourseCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  userId_: string;
  playLevelsInpathCompleted: number;
  playCoursesInlevelCompleted: number;
  playActivitiesIncourseCompleted: number;
  siteidLegacy: string | null | undefined;
}
/**
 * Course Completed: This event fires when a user completes a course.
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.playLevelsInpathCompleted: This user trait indicates the amount of levels within a path that this user has fully completed, as pulled from the backend. Please update every time the user switches levels, either actively or passively.
 * @param properties.playCoursesInlevelCompleted: This user trait indicates the number of completed courses within the users' active level, as pulled from the backend. Could be used with play_courses_inlevel_total to calculate a percentage.
 * @param properties.playActivitiesIncourseCompleted: This user trait indicates the total amount of activities (video lesson, practice mode, feedback mode) the user has completed within their active course, as provided by the backend. Could be used with play_activities_incourse_total to calculate a percentage.
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/M-dK1lyXqw}
 */
export function courseCompleted(properties: CourseCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "M-dK1lyXqw", "b71bb1a93750f5b49b85370da64c8ba32becd46a74cd34fb6dd2c5717e12fe27", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Course Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "siteId": properties.siteidLegacy,
      }, {
      "play_levels_inpath_completed": properties.playLevelsInpathCompleted,
      "play_courses_inlevel_completed": properties.playCoursesInlevelCompleted,
      "play_activities_incourse_completed": properties.playActivitiesIncourseCompleted,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("M-dK1lyXqw", "Course Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], [
      {id:"yJI1ZxM7xy", name: "play_levels_inpath_completed", value: properties.playLevelsInpathCompleted},
      {id:"MRGVziVa4A", name: "play_courses_inlevel_completed", value: properties.playCoursesInlevelCompleted},
      {id:"ncFNXtyhlk", name: "play_activities_incourse_completed", value: properties.playActivitiesIncourseCompleted},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  eventPropertiesPlayWeb["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventPropertiesPlayWeb["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventPropertiesPlayWeb["course_name"] = properties.courseName;
  }
  eventPropertiesPlayWeb["index"] = properties.index;
  eventPropertiesPlayWeb["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventPropertiesPlayWeb["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventPropertiesPlayWeb["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventPropertiesPlayWeb["filters"] = properties.filters;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};
  userPropertiesPlayWeb["play_levels_inpath_completed"] = properties.playLevelsInpathCompleted;
  userPropertiesPlayWeb["play_courses_inlevel_completed"] = properties.playCoursesInlevelCompleted;
  userPropertiesPlayWeb["play_activities_incourse_completed"] = properties.playActivitiesIncourseCompleted;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Course Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        "siteId": properties.siteidLegacy,
        }, "M-dK1lyXqw", "b71bb1a93750f5b49b85370da64c8ba32becd46a74cd34fb6dd2c5717e12fe27");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userPropertiesPlayWeb));
    PlayWeb.logEvent("Course Completed", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface StreaksModalDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  streakType: StreakTypeValueType;
}
/**
 * Streaks Modal Dismissed: This event fires when a user dismisses the Streaks modal.
 *
 * When to trigger this event:
 * 1. User clicks "Got It!" on streak started modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eqsTitSOHu/trigger/M82gvSBfz
 * 2. User clicks "Got It!" on progress 1 modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eqsTitSOHu/trigger/yj11U2wN7
 * 3. User clicks "Got It!" on progress 2 modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eqsTitSOHu/trigger/6_pX_DZxf
 * 4. User clicks "Got It!" on streak completed modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eqsTitSOHu/trigger/LnP0wdmpu
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.streakType: This property describes the type of streak modal being displayed to the user (e.g. started, progress1, progress2, completed)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/eqsTitSOHu}
 */
export function streaksModalDismissed(
  properties: StreaksModalDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eqsTitSOHu", "666a84088bb3a46fddbaf7c9f93f893030800658d11061c3fa82dba5ce016639", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Streaks Modal Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "streak_type": properties.streakType,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eqsTitSOHu", "Streaks Modal Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "mq06XERbMU", name: "streak_type", value: properties.streakType},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["streak_type"] = properties.streakType;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Streaks Modal Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "streak_type": properties.streakType,
        }, "eqsTitSOHu", "666a84088bb3a46fddbaf7c9f93f893030800658d11061c3fa82dba5ce016639");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Streaks Modal Dismissed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StreaksModalLearnClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  streakType: StreakTypeValueType;
}
/**
 * Streaks Modal Learn Clicked: This event fires when the user clicks to "Learn More" from a Streaks modal.
 *
 * When to trigger this event:
 * 1. User clicks "Learn More" on streak start modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/EQKe2GQeiX/trigger/M2OnidN_S
 * 2. User clicks "Learn More" on first progress streak modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/EQKe2GQeiX/trigger/iOf9Ep6-2
 * 3. User clicks "Learn More" on second streaks progress modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/EQKe2GQeiX/trigger/nMD6hy4pc
 * 4. User clicks "Learn More" on streak completed modal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/EQKe2GQeiX/trigger/hkOSTpLlQ
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.streakType: This property describes the type of streak modal being displayed to the user (e.g. started, progress1, progress2, completed)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/EQKe2GQeiX}
 */
export function streaksModalLearnClicked(
  properties: StreaksModalLearnClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "EQKe2GQeiX", "1fb3d89a2a3d0085f3bb0ebe3b06c5ce23feadbbaad13db1cbfd02f70ac0652b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Streaks Modal Learn Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "streak_type": properties.streakType,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("EQKe2GQeiX", "Streaks Modal Learn Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "mq06XERbMU", name: "streak_type", value: properties.streakType},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["streak_type"] = properties.streakType;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Streaks Modal Learn Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "streak_type": properties.streakType,
        }, "EQKe2GQeiX", "1fb3d89a2a3d0085f3bb0ebe3b06c5ce23feadbbaad13db1cbfd02f70ac0652b");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Streaks Modal Learn Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeSongClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  songName: string | null | undefined;
  artistName: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
}
/**
 * Home Song Clicked: This event fires when the user clicks on a song on the home screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-AM67EVH2s/trigger/5dL8CXTac
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.songName: This property indicates the name of the song related to this event.
 * @param properties.artistName: This property indicates the artist name related to this event.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/-AM67EVH2s}
 */
export function homeSongClicked(properties: HomeSongClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-AM67EVH2s", "77aeeda6521acdb656b14345b824128eaf80862643b8fb6caf8c7a82e7968537", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Song Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "song_name": properties.songName,
      "artist_name": properties.artistName,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-AM67EVH2s", "Home Song Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "QnMiQTBryI", name: "song_name", value: properties.songName},
      {id: "OGv5NKrj3m", name: "artist_name", value: properties.artistName},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.songName !== undefined && properties.songName !== null) {
    eventProperties["song_name"] = properties.songName;
  }
  if (properties.artistName !== undefined && properties.artistName !== null) {
    eventProperties["artist_name"] = properties.artistName;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Song Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "song_name": properties.songName,
        "artist_name": properties.artistName,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        }, "-AM67EVH2s", "77aeeda6521acdb656b14345b824128eaf80862643b8fb6caf8c7a82e7968537");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Song Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeCollectionClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  title: string | null | undefined;
}
/**
 * Home Collection Clicked: This event fires when the user clicks to view a collection from the home screen.
 *
 * When to trigger this event:
 * 1. User clicks a collection
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MtygEiOTI-/trigger/liOkcYpor
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.title: This property indicates the title or name of the item it's referring to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MtygEiOTI-}
 */
export function homeCollectionClicked(
  properties: HomeCollectionClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MtygEiOTI-", "abbe912ffede2b4abad7681bf195adb69c437bdfffdd4d77cf927317ad49eb63", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Collection Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "title": properties.title,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MtygEiOTI-", "Home Collection Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "Vhp2wSvQllLx", name: "title", value: properties.title},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  if (properties.title !== undefined && properties.title !== null) {
    eventProperties["title"] = properties.title;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Collection Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        "title": properties.title,
        }, "MtygEiOTI-", "abbe912ffede2b4abad7681bf195adb69c437bdfffdd4d77cf927317ad49eb63");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Collection Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeRiffClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  songName: string | null | undefined;
  artistName: string | null | undefined;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
}
/**
 * Home Riff Clicked: This event fires when the user clicks to view a riff from the home screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/PsUBR7ij21/trigger/ggqFjUFJ7
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.songName: This property indicates the name of the song related to this event.
 * @param properties.artistName: This property indicates the artist name related to this event.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/PsUBR7ij21}
 */
export function homeRiffClicked(properties: HomeRiffClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PsUBR7ij21", "a58fb9b0dfc2f4b4d19d91b04628cb68c28a8ed41d680139ca8402249e2bb56f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Riff Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "song_name": properties.songName,
      "artist_name": properties.artistName,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PsUBR7ij21", "Home Riff Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "QnMiQTBryI", name: "song_name", value: properties.songName},
      {id: "OGv5NKrj3m", name: "artist_name", value: properties.artistName},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.songName !== undefined && properties.songName !== null) {
    eventProperties["song_name"] = properties.songName;
  }
  if (properties.artistName !== undefined && properties.artistName !== null) {
    eventProperties["artist_name"] = properties.artistName;
  }
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Riff Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "song_name": properties.songName,
        "artist_name": properties.artistName,
        "index": properties.index,
        "eventType": properties.eventType,
        "queryID": properties.queryID,
        "objectID": properties.objectID,
        "filters": properties.filters,
        }, "PsUBR7ij21", "a58fb9b0dfc2f4b4d19d91b04628cb68c28a8ed41d680139ca8402249e2bb56f");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Riff Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeArticleClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  title: string | null | undefined;
}
/**
 * Home Article Clicked: This event fires when the user clicks to view an article from the home screen.
 *
 * When to trigger this event:
 * 1. User clicks an article thumbnail or title
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/By74HhDO7n/trigger/74JMrOHy6
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.title: This property indicates the title or name of the item it's referring to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/By74HhDO7n}
 */
export function homeArticleClicked(properties: HomeArticleClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "By74HhDO7n", "222ee4c110bf2ebbb04b91416f35b01a29085e5ee7493726428a748994708af6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Article Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "title": properties.title,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("By74HhDO7n", "Home Article Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Vhp2wSvQllLx", name: "title", value: properties.title},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.title !== undefined && properties.title !== null) {
    eventProperties["title"] = properties.title;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Article Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "title": properties.title,
        }, "By74HhDO7n", "222ee4c110bf2ebbb04b91416f35b01a29085e5ee7493726428a748994708af6");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Article Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeArticlesViewallClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Home Articles Viewall Clicked: This event fires when the user clicks to view all articles from the home screen.
 *
 * When to trigger this event:
 * 1. User clicks "view all articles" link
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/lvtIXd1T_o/trigger/xoloYMjz32
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/lvtIXd1T_o}
 */
export function homeArticlesViewallClicked(
  properties: HomeArticlesViewallClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lvtIXd1T_o", "49db8d684847d29d4af6348a6e23de86790e7994e53734b4bdb12615bd218b21", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Articles Viewall Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lvtIXd1T_o", "Home Articles Viewall Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Articles Viewall Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "lvtIXd1T_o", "49db8d684847d29d4af6348a6e23de86790e7994e53734b4bdb12615bd218b21");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Articles Viewall Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeCollectionsViewallClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Home Collections Viewall Clicked: This event fires when the user clicks to view all collections from the home screen.
 *
 * When to trigger this event:
 * 1. User clicks "view all collections"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/wgJ3jO2la5/trigger/wPYnlHKXf
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/wgJ3jO2la5}
 */
export function homeCollectionsViewallClicked(
  properties: HomeCollectionsViewallClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wgJ3jO2la5", "1036dc6e078a25b938fdb62f698b7c4e0165b78376b391b3a7e5aa7f42b2fd3c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Collections Viewall Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wgJ3jO2la5", "Home Collections Viewall Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Collections Viewall Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "wgJ3jO2la5", "1036dc6e078a25b938fdb62f698b7c4e0165b78376b391b3a7e5aa7f42b2fd3c");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Collections Viewall Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeSongsViewallClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Home Songs Viewall Clicked: This event fires when the user clicks to view all songs on the home screen.
 *
 * When to trigger this event:
 * 1. User clicks "view all songs"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/87m-IWNCUc/trigger/Jor1XoHeI
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/87m-IWNCUc}
 */
export function homeSongsViewallClicked(
  properties: HomeSongsViewallClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "87m-IWNCUc", "0de4407f35456dd98dfcd352f6a867041408fed0d390ab0cbbb75ff649b69a44", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Songs Viewall Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("87m-IWNCUc", "Home Songs Viewall Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Songs Viewall Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "87m-IWNCUc", "0de4407f35456dd98dfcd352f6a867041408fed0d390ab0cbbb75ff649b69a44");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Songs Viewall Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeRiffsViewallClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Home Riffs Viewall Clicked: This event fires when the user clicks to view all riffs from the home screen, on Web only.
 *
 * When to trigger this event:
 * 1. User clicks "view all riffs"
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/NaOOe8_jPG/trigger/8NfZ3QwTo
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/NaOOe8_jPG}
 */
export function homeRiffsViewallClicked(
  properties: HomeRiffsViewallClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NaOOe8_jPG", "05f122532a9aa7775d85c43d17d33a96c7e824b6cb0d121b98a0ee2a4ef3c9ad", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Riffs Viewall Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NaOOe8_jPG", "Home Riffs Viewall Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Riffs Viewall Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "NaOOe8_jPG", "05f122532a9aa7775d85c43d17d33a96c7e824b6cb0d121b98a0ee2a4ef3c9ad");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Riffs Viewall Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeFeaturedClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  title: string | null | undefined;
  position: any | null | undefined;
}
/**
 * Home Featured Clicked: This event fires when the user clicks on a piece of featured content (e.g. app feature announcements) from the home screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/t5xGU5WBgA/trigger/8V4VIQGWn
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.title: This property indicates the title or name of the item it's referring to.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/t5xGU5WBgA}
 */
export function homeFeaturedClicked(properties: HomeFeaturedClickedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "t5xGU5WBgA", "6faa30a29a35587a09fc8013a70ac1f7edfc3e0a5f744c30e4836c1ab6c99507", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Featured Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "title": properties.title,
      "position": properties.position,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("t5xGU5WBgA", "Home Featured Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Vhp2wSvQllLx", name: "title", value: properties.title},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.title !== undefined && properties.title !== null) {
    eventProperties["title"] = properties.title;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Featured Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "title": properties.title,
        "position": properties.position,
        }, "t5xGU5WBgA", "6faa30a29a35587a09fc8013a70ac1f7edfc3e0a5f744c30e4836c1ab6c99507");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Featured Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NavigationOpenedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  fcidLegacy: string | null | undefined;
}
/**
 * Navigation Opened: This event fires when the user clicks to open up/expand the navigation menu.
 *
 * When to trigger this event:
 * 1. User clicks "hamburger" icon
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/HtKVDSEb2Wv/trigger/Ygo1NwmBi
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.fcidLegacy: This property indicates the Fender Connect user ID, but is legacy. Continue to send this alongside fc_id if the client is currently, until we can migrate all reporting to fc_id. NOTE TO DEVS: please stop sending this and send fc_id instead
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/HtKVDSEb2Wv}
 */
export function navigationOpened(properties: NavigationOpenedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HtKVDSEb2Wv", "2a4d7e60bed52703ae5dd320a240942056ec9195589be73acc247fef45fe65f4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Navigation Opened", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "fcId": properties.fcidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HtKVDSEb2Wv", "Navigation Opened", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "If9yUjDUw", name: "fcId", value: properties.fcidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.fcidLegacy !== undefined && properties.fcidLegacy !== null) {
    eventPropertiesPlayWeb["fcId"] = properties.fcidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Navigation Opened", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "fcId": properties.fcidLegacy,
        }, "HtKVDSEb2Wv", "2a4d7e60bed52703ae5dd320a240942056ec9195589be73acc247fef45fe65f4");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Navigation Opened", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface NavigationDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Navigation Dismissed: This event fires when the user clicks to collapse/close the navigation menu, on Web only.
 *
 * When to trigger this event:
 * 1. User clicks X icon or clicks outside of the menu area to close it
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TRR6xl2Fxs/trigger/oZb6J3txh
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TRR6xl2Fxs}
 */
export function navigationDismissed(properties: NavigationDismissedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "TRR6xl2Fxs", "b8cb762f6d6db5c39e9a627d3b18f4dbaa70d931de7fdb5cdf0abc708a859460", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Navigation Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("TRR6xl2Fxs", "Navigation Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Navigation Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "TRR6xl2Fxs", "b8cb762f6d6db5c39e9a627d3b18f4dbaa70d931de7fdb5cdf0abc708a859460");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Navigation Dismissed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeHeroStartedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  title: string | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  userLogic: UserLogicValueType;
}
/**
 * Home Hero Started: This event fires when the hero video on the home view is played from the beginning (either explicit Play button click or auto-play)
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/JdsfOnXYz/trigger/K_O_uOKHk
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.title: This property indicates the title or name of the item it's referring to.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.userLogic: This property indicates the logic being used for Play Home to determine if the user is new (no progress/activities started) or returning (has progress).
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/JdsfOnXYz}
 */
export function homeHeroStarted(properties: HomeHeroStartedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "JdsfOnXYz", "1514d4abc45bd5e6d581023f024b007d32b0255a49495356575d262d5ed93719", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Hero Started", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "title": properties.title,
      "instrument": properties.instrument,
      "user_logic": properties.userLogic,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("JdsfOnXYz", "Home Hero Started", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Vhp2wSvQllLx", name: "title", value: properties.title},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "LuuUe9AkmU", name: "user_logic", value: properties.userLogic},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.title !== undefined && properties.title !== null) {
    eventProperties["title"] = properties.title;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  eventProperties["user_logic"] = properties.userLogic;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Hero Started", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "title": properties.title,
        "instrument": properties.instrument,
        "user_logic": properties.userLogic,
        }, "JdsfOnXYz", "1514d4abc45bd5e6d581023f024b007d32b0255a49495356575d262d5ed93719");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Hero Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeHeroPausedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  title: string | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  userLogic: UserLogicValueType;
}
/**
 * Home Hero Paused: This event fires when the user clicks to pause the hero video on the home screen. This is not fired on Play iOS.
 *
 * When to trigger this event:
 * 1. User clicks "pause" button
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/kQtbdTw7SX/trigger/AjF65ADIC
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.title: This property indicates the title or name of the item it's referring to.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.userLogic: This property indicates the logic being used for Play Home to determine if the user is new (no progress/activities started) or returning (has progress).
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/kQtbdTw7SX}
 */
export function homeHeroPaused(properties: HomeHeroPausedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kQtbdTw7SX", "abc8b11925650547e53b019e820dc277dce50da6bf36d2a2a87e2522612af585", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Hero Paused", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "title": properties.title,
      "instrument": properties.instrument,
      "user_logic": properties.userLogic,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kQtbdTw7SX", "Home Hero Paused", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Vhp2wSvQllLx", name: "title", value: properties.title},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "LuuUe9AkmU", name: "user_logic", value: properties.userLogic},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.title !== undefined && properties.title !== null) {
    eventProperties["title"] = properties.title;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  eventProperties["user_logic"] = properties.userLogic;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Hero Paused", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "title": properties.title,
        "instrument": properties.instrument,
        "user_logic": properties.userLogic,
        }, "kQtbdTw7SX", "abc8b11925650547e53b019e820dc277dce50da6bf36d2a2a87e2522612af585");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Hero Paused", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeHeroCompletedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  title: string | null | undefined;
  instrument: InstrumentValueType | null | undefined;
  userLogic: UserLogicValueType;
}
/**
 * Home Hero Completed: This event fires when the user passes the 95% playback mark on the hero video on the home screen.
 *
 * When to trigger this event:
 * 1. Playhead passes 90% mark on hero video
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/UoRM5FvqD/trigger/LIrJt4fj5
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.title: This property indicates the title or name of the item it's referring to.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.userLogic: This property indicates the logic being used for Play Home to determine if the user is new (no progress/activities started) or returning (has progress).
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/UoRM5FvqD}
 */
export function homeHeroCompleted(properties: HomeHeroCompletedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "UoRM5FvqD", "a8e8c593eac993d72d34cb5db4e78e047e55a8df496315f1d4de4d223d404822", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Hero Completed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "title": properties.title,
      "instrument": properties.instrument,
      "user_logic": properties.userLogic,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("UoRM5FvqD", "Home Hero Completed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Vhp2wSvQllLx", name: "title", value: properties.title},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "LuuUe9AkmU", name: "user_logic", value: properties.userLogic},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.title !== undefined && properties.title !== null) {
    eventProperties["title"] = properties.title;
  }
  if (properties.instrument !== undefined && properties.instrument !== null) {
    eventProperties["instrument"] = properties.instrument;
  }
  eventProperties["user_logic"] = properties.userLogic;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Hero Completed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "title": properties.title,
        "instrument": properties.instrument,
        "user_logic": properties.userLogic,
        }, "UoRM5FvqD", "a8e8c593eac993d72d34cb5db4e78e047e55a8df496315f1d4de4d223d404822");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Hero Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomePathLastClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  activityId: string | null | undefined;
  activitySlug: string | null | undefined;
  activityType: ActivityTypeValueType;
  activityTitle: string | null | undefined;
  activityScore: number | null | undefined;
  activityTypeLesson: string | null | undefined;
}
/**
 * Home Path Last Clicked: This event fires when the user has previous progress on their path and clicks to view their last activity (lesson, practice mode, feedback mode)
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/aon72EDeuy/trigger/iEVU6KuwK
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.activityId: This property indicates the internal ID of the activity object within our LMS.
 * @param properties.activitySlug: This property indicates the slug of the activity object within our LMS, which could be used for the web URL.
 * @param properties.activityType: This property indicates the main type of curriculum activity for this event.
 * @param properties.activityTitle: This property indicates the title of the activity within our LMS.
 * @param properties.activityScore: If this activity has a score (feedback mode, chord challenge), store it here.
 * @param properties.activityTypeLesson: If activity_type is set to lesson-video, subcategory of lesson type should display here.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/aon72EDeuy}
 */
export function homePathLastClicked(properties: HomePathLastClickedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aon72EDeuy", "d5171bd13d9d28f708e09df7103b51b6d7af22b602fb86b7eec49f977bbd18da", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Path Last Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "activity_id": properties.activityId,
      "activity_slug": properties.activitySlug,
      "activity_type": properties.activityType,
      "activity_title": properties.activityTitle,
      "activity_score": properties.activityScore,
      "activity_type_lesson": properties.activityTypeLesson,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aon72EDeuy", "Home Path Last Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "0scsV5MvF5XV", name: "activity_id", value: properties.activityId},
      {id: "zmPMjKsIoF9c", name: "activity_slug", value: properties.activitySlug},
      {id: "58S6ZDoyrY", name: "activity_type", value: properties.activityType},
      {id: "VwSYbEn4f5J1", name: "activity_title", value: properties.activityTitle},
      {id: "sGabZ0AU9S", name: "activity_score", value: properties.activityScore},
      {id: "KoZ57WH5Cj", name: "activity_type_lesson", value: properties.activityTypeLesson},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.activityId !== undefined && properties.activityId !== null) {
    eventProperties["activity_id"] = properties.activityId;
  }
  if (properties.activitySlug !== undefined && properties.activitySlug !== null) {
    eventProperties["activity_slug"] = properties.activitySlug;
  }
  eventProperties["activity_type"] = properties.activityType;
  if (properties.activityTitle !== undefined && properties.activityTitle !== null) {
    eventProperties["activity_title"] = properties.activityTitle;
  }
  if (properties.activityScore !== undefined && properties.activityScore !== null) {
    eventProperties["activity_score"] = properties.activityScore;
  }
  if (properties.activityTypeLesson !== undefined && properties.activityTypeLesson !== null) {
    eventProperties["activity_type_lesson"] = properties.activityTypeLesson;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Path Last Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "activity_id": properties.activityId,
        "activity_slug": properties.activitySlug,
        "activity_type": properties.activityType,
        "activity_title": properties.activityTitle,
        "activity_score": properties.activityScore,
        "activity_type_lesson": properties.activityTypeLesson,
        }, "aon72EDeuy", "d5171bd13d9d28f708e09df7103b51b6d7af22b602fb86b7eec49f977bbd18da");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Path Last Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomePathNextClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  nextActivityId: string | null | undefined;
  nextActivitySlug: string | null | undefined;
  nextActivityType: string | null | undefined;
  nextActivityTitle: string | null | undefined;
}
/**
 * Home Path Next Clicked: This event fires when the user clicks to view their path (v1) or next up activity (v2) from the home screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/FC2zvnJcLN/trigger/1PKfA-z0K
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.nextActivityId: This property indicates the ID of the next activity that occurs after the user performs this action.
 * @param properties.nextActivitySlug: This property indicates the slug of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityType: This property indicates the type of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityTitle: This property indicates the title of the next activity that occurs after the user performs this action.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/FC2zvnJcLN}
 */
export function homePathNextClicked(properties: HomePathNextClickedProperties
  ) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FC2zvnJcLN", "6af2e908f238f6525c603068bc280ffe1265f866aa073e8c3ef940af7ee84fdd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Path Next Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "next_activity_id": properties.nextActivityId,
      "next_activity_slug": properties.nextActivitySlug,
      "next_activity_type": properties.nextActivityType,
      "next_activity_title": properties.nextActivityTitle,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FC2zvnJcLN", "Home Path Next Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Kh9sBptRQ-0q", name: "next_activity_id", value: properties.nextActivityId},
      {id: "A2o2tN3vyDPo", name: "next_activity_slug", value: properties.nextActivitySlug},
      {id: "kbeM5avar8tP", name: "next_activity_type", value: properties.nextActivityType},
      {id: "e-PCkn29vMKF", name: "next_activity_title", value: properties.nextActivityTitle},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.nextActivityId !== undefined && properties.nextActivityId !== null) {
    eventProperties["next_activity_id"] = properties.nextActivityId;
  }
  if (properties.nextActivitySlug !== undefined && properties.nextActivitySlug !== null) {
    eventProperties["next_activity_slug"] = properties.nextActivitySlug;
  }
  if (properties.nextActivityType !== undefined && properties.nextActivityType !== null) {
    eventProperties["next_activity_type"] = properties.nextActivityType;
  }
  if (properties.nextActivityTitle !== undefined && properties.nextActivityTitle !== null) {
    eventProperties["next_activity_title"] = properties.nextActivityTitle;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Path Next Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "next_activity_id": properties.nextActivityId,
        "next_activity_slug": properties.nextActivitySlug,
        "next_activity_type": properties.nextActivityType,
        "next_activity_title": properties.nextActivityTitle,
        }, "FC2zvnJcLN", "6af2e908f238f6525c603068bc280ffe1265f866aa073e8c3ef940af7ee84fdd");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Path Next Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomePathStartClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  genre: GenreValueType;
  instrument: InstrumentValueType;
  nextActivityId: string | null | undefined;
  nextActivitySlug: string | null | undefined;
  nextActivityType: string | null | undefined;
  nextActivityTitle: string | null | undefined;
}
/**
 * Home Path Start Clicked: This event fires when a brand new user clicks to start their path from the home screen. This will be gradually deprecated while new endpoints are integrated.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/hVJPMHnh_x/trigger/8YZjqLRfD
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.instrument: This property indicates the instrument selected relating to this event or the users' active path.
 * @param properties.nextActivityId: This property indicates the ID of the next activity that occurs after the user performs this action.
 * @param properties.nextActivitySlug: This property indicates the slug of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityType: This property indicates the type of the next activity that occurs after the user performs this action.
 * @param properties.nextActivityTitle: This property indicates the title of the next activity that occurs after the user performs this action.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/hVJPMHnh_x}
 */
export function homePathStartClicked(
  properties: HomePathStartClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hVJPMHnh_x", "98c5334c58c468e61f916be0d4ae934ac1c01e5ef45d0dfa420518df361f65f1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Path Start Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "genre": properties.genre,
      "instrument": properties.instrument,
      "next_activity_id": properties.nextActivityId,
      "next_activity_slug": properties.nextActivitySlug,
      "next_activity_type": properties.nextActivityType,
      "next_activity_title": properties.nextActivityTitle,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hVJPMHnh_x", "Home Path Start Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      {id: "5cyV2g8tiTr", name: "instrument", value: properties.instrument},
      {id: "Kh9sBptRQ-0q", name: "next_activity_id", value: properties.nextActivityId},
      {id: "A2o2tN3vyDPo", name: "next_activity_slug", value: properties.nextActivitySlug},
      {id: "kbeM5avar8tP", name: "next_activity_type", value: properties.nextActivityType},
      {id: "e-PCkn29vMKF", name: "next_activity_title", value: properties.nextActivityTitle},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["genre"] = properties.genre;
  eventProperties["instrument"] = properties.instrument;
  if (properties.nextActivityId !== undefined && properties.nextActivityId !== null) {
    eventProperties["next_activity_id"] = properties.nextActivityId;
  }
  if (properties.nextActivitySlug !== undefined && properties.nextActivitySlug !== null) {
    eventProperties["next_activity_slug"] = properties.nextActivitySlug;
  }
  if (properties.nextActivityType !== undefined && properties.nextActivityType !== null) {
    eventProperties["next_activity_type"] = properties.nextActivityType;
  }
  if (properties.nextActivityTitle !== undefined && properties.nextActivityTitle !== null) {
    eventProperties["next_activity_title"] = properties.nextActivityTitle;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Path Start Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "genre": properties.genre,
        "instrument": properties.instrument,
        "next_activity_id": properties.nextActivityId,
        "next_activity_slug": properties.nextActivitySlug,
        "next_activity_type": properties.nextActivityType,
        "next_activity_title": properties.nextActivityTitle,
        }, "hVJPMHnh_x", "98c5334c58c468e61f916be0d4ae934ac1c01e5ef45d0dfa420518df361f65f1");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Path Start Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeProperties {
  name: string;
  index: IndexValueType;
  eventType: EventTypeValueType;
  queryID: string | null | undefined;
  objectID: string | null | undefined;
  filters: Filters | null | undefined;
  userId_: string;
  customDestinationPageName_: string;
  isNewUser: boolean | null | undefined;
  genre: GenreValueType | null | undefined;
  playCountrycodeFromstore: string;
}
/**
 * Home: This event fires when the user views the home/welcome page/screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/a4GwOy5bu1/trigger/s4h66oVmj
 *
 * @param properties the properties associatied with this event
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.index: This is a variable required by Algolia as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. Hardcode to 'prod_play_search' for now
 * @param properties.eventType: This is required by Algolia, as per https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.queryID: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/. To pull this value, grab clickAnalytics from Algolia implementation to retrieve queryID in your search response.
 * @param properties.objectID: The unique identifier of a specific item stored in Algolia. We set this objectID value to be the same as the corresponding ID of the item in our LMS. For example, the course ID for 'Basket Case' ('a1770163-ad2e-4825-b57e-a6c86622cb12') is the same as the objectID for the same course within Algolia.

Needs to be set on all Algolia generated content lists, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.filters: This is desired by Algolia, as per: https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.isNewUser: This property indicates if the user just came from onboarding (true) or is a returning user (false)
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 * @param properties.playCountrycodeFromstore: This user trait indicates the user's two-digit country code as pulled by the Play client apps from either geolocation data (web) or App Store country (mobile). See also country_code on transaction track events.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/a4GwOy5bu1}
 */
export function home(properties: HomeProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "a4GwOy5bu1", "23ac451321ecc2adabe5c75dd58347776f49c809225f9c129a190b6be7655e80", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home", {
      "name": properties.name,
      "index": properties.index,
      "eventType": properties.eventType,
      "queryID": properties.queryID,
      "objectID": properties.objectID,
      "filters": properties.filters,
      "is_new_user": properties.isNewUser,
      "genre": properties.genre,
      }, {
      "play_countrycode_fromstore": properties.playCountrycodeFromstore,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("a4GwOy5bu1", "Home", messages, [
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "AwgaTVWZxS", name: "index", value: properties.index},
      {id: "3FVzmVo9KM", name: "eventType", value: properties.eventType},
      {id: "5hruN43LxW", name: "queryID", value: properties.queryID},
      {id: "agUC4EFerc", name: "objectID", value: properties.objectID},
      {id: "aa0dn0zK2d", name: "filters", value: properties.filters},
      {id: "OC-kEeC8WV", name: "is_new_user", value: properties.isNewUser},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      ], [
      {id:"ygHoxvjtVs", name: "play_countrycode_fromstore", value: properties.playCountrycodeFromstore},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["name"] = properties.name;
  eventProperties["index"] = properties.index;
  eventProperties["eventType"] = properties.eventType;
  if (properties.queryID !== undefined && properties.queryID !== null) {
    eventProperties["queryID"] = properties.queryID;
  }
  if (properties.objectID !== undefined && properties.objectID !== null) {
    eventProperties["objectID"] = properties.objectID;
  }
  if (properties.filters !== undefined && properties.filters !== null) {
    eventProperties["filters"] = properties.filters;
  }
  if (properties.isNewUser !== undefined && properties.isNewUser !== null) {
    eventProperties["is_new_user"] = properties.isNewUser;
  }
  if (properties.genre !== undefined && properties.genre !== null) {
    eventProperties["genre"] = properties.genre;
  }

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_countrycode_fromstore"] = properties.playCountrycodeFromstore;

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface LessonClickedProperties {
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  songName: string | null | undefined;
  artistName: string | null | undefined;
  isLocked: boolean | null | undefined;
  siteidLegacy: string | null | undefined;
}
/**
 * Lesson Clicked: This event is fired when a user clicks on a lesson from their path, a course detail, search results, or an end of previous lesson video card. Replaces "Lesson Click" if still fired.
 *
 * When to trigger this event:
 * 1. User clicks on a lesson within a course
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/1Ub9t3e_Fg/trigger/nqKFaxeoq
 * 2. User clicks on a direct-lesson search result (not collection or course result)
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/1Ub9t3e_Fg/trigger/stDd3heTG
 *
 * @param properties the properties associatied with this event
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.songName: This property indicates the name of the song related to this event.
 * @param properties.artistName: This property indicates the artist name related to this event.
 * @param properties.isLocked: This property indicates whether the piece of content interacted with is locked (i.e. inaccessible royalty-bearing song by unpaying user), or not (non-royalty bearing by any user, or royalty-bearing by paying user).
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/1Ub9t3e_Fg}
 */
export function lessonClicked(properties: LessonClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1Ub9t3e_Fg", "d7d282d88260e2ec7a553a1c915c73d4db2c8a29b38f40175a6660b5a65296ef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Clicked", {
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "song_name": properties.songName,
      "artist_name": properties.artistName,
      "is_locked": properties.isLocked,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1Ub9t3e_Fg", "Lesson Clicked", messages, [
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "QnMiQTBryI", name: "song_name", value: properties.songName},
      {id: "OGv5NKrj3m", name: "artist_name", value: properties.artistName},
      {id: "4N1i1OEGWb", name: "is_locked", value: properties.isLocked},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  eventPropertiesPlayWeb["lesson_id"] = properties.lessonId;
  eventPropertiesPlayWeb["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventPropertiesPlayWeb["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventPropertiesPlayWeb["lesson_name"] = properties.lessonName;
  }
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.songName !== undefined && properties.songName !== null) {
    eventPropertiesPlayWeb["song_name"] = properties.songName;
  }
  if (properties.artistName !== undefined && properties.artistName !== null) {
    eventPropertiesPlayWeb["artist_name"] = properties.artistName;
  }
  if (properties.isLocked !== undefined && properties.isLocked !== null) {
    eventPropertiesPlayWeb["is_locked"] = properties.isLocked;
  }
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Clicked", {
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "song_name": properties.songName,
        "artist_name": properties.artistName,
        "is_locked": properties.isLocked,
        "siteId": properties.siteidLegacy,
        }, "1Ub9t3e_Fg", "d7d282d88260e2ec7a553a1c915c73d4db2c8a29b38f40175a6660b5a65296ef");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Lesson Clicked", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface LevelClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  isLocked: boolean | null | undefined;
  level: string;
}
/**
 * Level Clicked: This event is fired when the user clicks to navigate to a new level on their existing path.
 *
 * When to trigger this event:
 * 1. User clicks on a level from the My Path dropdown in side navigation
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/a-_gB9-Koz/trigger/qffLsJ9Go
 * 2.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/a-_gB9-Koz/trigger/A2KfT3lOA
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.isLocked: This property indicates whether the piece of content interacted with is locked (i.e. inaccessible royalty-bearing song by unpaying user), or not (non-royalty bearing by any user, or royalty-bearing by paying user).
 * @param properties.level: This property indicates the level number relating to this event being fired (i.e. Level Clicked) OR the current level of the player's path when this event was fired.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/a-_gB9-Koz}
 */
export function levelClicked(properties: LevelClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "a-_gB9-Koz", "7454aa2710317c6377040d9d9edff74edec106925f479fbe863f3a688984316c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Level Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "is_locked": properties.isLocked,
      "level": properties.level,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("a-_gB9-Koz", "Level Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "4N1i1OEGWb", name: "is_locked", value: properties.isLocked},
      {id: "DmU_IR1g8_0", name: "level", value: properties.level},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.isLocked !== undefined && properties.isLocked !== null) {
    eventProperties["is_locked"] = properties.isLocked;
  }
  eventProperties["level"] = properties.level;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Level Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "is_locked": properties.isLocked,
        "level": properties.level,
        }, "a-_gB9-Koz", "7454aa2710317c6377040d9d9edff74edec106925f479fbe863f3a688984316c");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Level Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingQuizGenreSkippedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  userId_: string;
  playPathGenre: PlayPathGenreValueType;
  genre: GenreValueType;
}
/**
 * Onboarding Quiz Genre Skipped: This event fires when the user skips the genre setting portion of onboarding. Note that genre will be automatically defaulted to "rock" for bass or guitar if skipped, hence why we want to update those properties even if not explicitly set by the user.
 *
 * When to trigger this event:
 * 1. User clicks X in upper right
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/kB56ihBWlh/trigger/nY30p2pr1
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.playPathGenre: The user's currently selected Genre. Formerly 'currentPath'.
 * @param properties.genre: The path's genre. This will eventually replace the 'path' property as it is more descriptive of a property name.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/kB56ihBWlh}
 */
export function onboardingQuizGenreSkipped(
  properties: OnboardingQuizGenreSkippedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kB56ihBWlh", "dc34b4b675b7ce9bf2eae8c878f0af60d6a31313025eae600bd965882301a1e8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Genre Skipped", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "genre": properties.genre,
      }, {
      "play_path_genre": properties.playPathGenre,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kB56ihBWlh", "Onboarding Quiz Genre Skipped", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "hhpNuLXPWJX", name: "genre", value: properties.genre},
      ], [
      {id:"KxkjsavOnd", name: "play_path_genre", value: properties.playPathGenre},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["genre"] = properties.genre;

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_path_genre"] = properties.playPathGenre;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Quiz Genre Skipped", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "genre": properties.genre,
        }, "kB56ihBWlh", "dc34b4b675b7ce9bf2eae8c878f0af60d6a31313025eae600bd965882301a1e8");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Onboarding Quiz Genre Skipped", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingQuizAbilityProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Onboarding Quiz Ability: This event fires when the user loads the level setting/ability screen as part of onboarding.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Vc8TVkxLgd/trigger/RmSLbgMjz
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Vc8TVkxLgd}
 */
export function onboardingQuizAbility(
  properties: OnboardingQuizAbilityProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Vc8TVkxLgd", "27d59404f78e66b9e779f4d6350c0f63e675c24419dd7000131d72203e57860c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Ability", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Vc8TVkxLgd", "Onboarding Quiz Ability", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingQuizAbilityClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  userId_: string;
  abilityText: string;
  abilityLevel: number;
  playAbility: string;
  playAbilityLevel: number;
}
/**
 * Onboarding Quiz Ability Clicked: This event fires when the user selects their ability level during onboarding.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ZHozTTWluh/trigger/2Vx_uH_BS
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.abilityText: This property describes the text for the ability/level option the user interacted with, e.g. 'I've never played before'
 * @param properties.abilityLevel: This property indicates the number of the level we put this user on based on this action. e.g. I've never played before puts the user on level 1.
 * @param properties.playAbility: This user trait indicates what ability/level option text the user selected during onboarding. e.g. 'I've never played before'
 * @param properties.playAbilityLevel: This user trait indicates the level number we start the user on based on their ability selection during onboarding. e.g. 'I've never played before' sets this value to 1 as we start them on level 1.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/ZHozTTWluh}
 */
export function onboardingQuizAbilityClicked(
  properties: OnboardingQuizAbilityClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZHozTTWluh", "3ae4d167adcf3ccdc1cf8f09bf863b3661ada5f17c39129ed65b510781e4ac1f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Ability Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ability_text": properties.abilityText,
      "ability_level": properties.abilityLevel,
      }, {
      "play_ability": properties.playAbility,
      "play_ability_level": properties.playAbilityLevel,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZHozTTWluh", "Onboarding Quiz Ability Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "MeJ5Sbur2l", name: "ability_text", value: properties.abilityText},
      {id: "T-saMRLw3i", name: "ability_level", value: properties.abilityLevel},
      ], [
      {id:"SY2qJ53dte", name: "play_ability", value: properties.playAbility},
      {id:"xCHvXmENu-", name: "play_ability_level", value: properties.playAbilityLevel},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["ability_text"] = properties.abilityText;
  eventProperties["ability_level"] = properties.abilityLevel;

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_ability"] = properties.playAbility;
  userProperties["play_ability_level"] = properties.playAbilityLevel;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Quiz Ability Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ability_text": properties.abilityText,
        "ability_level": properties.abilityLevel,
        }, "ZHozTTWluh", "3ae4d167adcf3ccdc1cf8f09bf863b3661ada5f17c39129ed65b510781e4ac1f");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Onboarding Quiz Ability Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeHeroContinuedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  userLogic: UserLogicValueType;
  siteidLegacy: string | null | undefined;
}
/**
 * Home Hero Continued: This event is fired at 10 second intervals from the start of the entire video (i.e. not 10 second intervals from when playhead begins)
 *
 * When to trigger this event:
 * 1. 10 seconds from start of video or last interval has passed
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Go3_h2RdQj/trigger/5IPBC1Cbe
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.userLogic: This property indicates the logic being used for Play Home to determine if the user is new (no progress/activities started) or returning (has progress).
 * @param properties.siteidLegacy: This property indicates the site ID where the event occurred, but is legacy. Continue to send this alongside site_id if the client is currently, until we can migrate all reporting to site_id. NOTE TO DEVS: Please stop sending this property and send site_id instead!
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/Go3_h2RdQj}
 */
export function homeHeroContinued(properties: HomeHeroContinuedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Go3_h2RdQj", "b50f8ac28072f59758e4b909c8d2326b28ad1b342805fb37b95ed37a90e59796", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Hero Continued", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "watched_to_seconds": properties.watchedToSeconds,
      "user_logic": properties.userLogic,
      "siteId": properties.siteidLegacy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Go3_h2RdQj", "Home Hero Continued", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "LuuUe9AkmU", name: "user_logic", value: properties.userLogic},
      {id: "v93szOko9", name: "siteId", value: properties.siteidLegacy},
      ], []);
    }
  }

  // @ts-ignore
  let eventPropertiesPlayWeb: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventPropertiesPlayWeb["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventPropertiesPlayWeb["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventPropertiesPlayWeb["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventPropertiesPlayWeb["watched_to_seconds"] = properties.watchedToSeconds;
  }
  eventPropertiesPlayWeb["user_logic"] = properties.userLogic;
  if (properties.siteidLegacy !== undefined && properties.siteidLegacy !== null) {
    eventPropertiesPlayWeb["siteId"] = properties.siteidLegacy;
  }

  // @ts-ignore
  let userPropertiesPlayWeb: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Hero Continued", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "watched_to_seconds": properties.watchedToSeconds,
        "user_logic": properties.userLogic,
        "siteId": properties.siteidLegacy,
        }, "Go3_h2RdQj", "b50f8ac28072f59758e4b909c8d2326b28ad1b342805fb37b95ed37a90e59796");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Hero Continued", (Object as any).assign({}, eventPropertiesPlayWeb));
  } else {
    // do nothing
  }
}

export interface TablatureZoomChangedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  notationScale: number;
}
/**
 * Tablature Zoom Changed: A user finished changing their tablature zoom/scale setting. This is done with a "zoom" button in the tablature area. The first button click does not change the zoom level, but instead activates the button and shows the current zoom level. Subsequent clicks of the button cycle through the 3 zoom settings. After a mouse-out (web) or delay (mobile), the button returns to its initial state. At that moment, this event fires.
 *
 * When to trigger this event:
 * 1. After the mouse cursor leaves the button area and 1 second has elapsed, the button should collapse to its initial (icon-only( state. This is the time this event should trigger, recording which zoom level the user settled on.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/8-e7mlZtPN/trigger/i9ZbSSTgZ
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.notationScale: The scale/zoom of the tablature as decided by the user. Options include 1.0 (100%, default), 1.5, 2.0 (200%).
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/8-e7mlZtPN}
 */
export function tablatureZoomChanged(
  properties: TablatureZoomChangedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8-e7mlZtPN", "915f349c6627aac3c871c97e9ea379dc5eddbd68beaf859d2fb0e01204bb66ce", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tablature Zoom Changed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "notation_scale": properties.notationScale,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8-e7mlZtPN", "Tablature Zoom Changed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "WuYFNwAmRp", name: "notation_scale", value: properties.notationScale},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["notation_scale"] = properties.notationScale;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tablature Zoom Changed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "notation_scale": properties.notationScale,
        }, "8-e7mlZtPN", "915f349c6627aac3c871c97e9ea379dc5eddbd68beaf859d2fb0e01204bb66ce");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Tablature Zoom Changed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TablatureLabelChordClickedProperties {
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  courseId: string;
  courseSlug: string | null | undefined;
  courseName: string | null | undefined;
  chordLabel: string;
}
/**
 * Tablature Label Chord Clicked: A chord label appearing within tablature was clicked. When this is done, it results in a large chord diagram of that chord to be displayed for reference.
 *
 * When to trigger this event:
 * 1. User clicked a chord label that appears above the music staff in tablature.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TGWl3wbZl_/trigger/zW-lpMJxN
 *
 * @param properties the properties associatied with this event
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.courseId: The unique identifier of a Course object.
 * @param properties.courseSlug: The URL 'slug' of the Course object.
 * @param properties.courseName: This property indicates the name of the course. Preferred to 'course' or 'course_title'.
 * @param properties.chordLabel: The text label of the chord that was clicked. Examples: 'G', 'Em', 'C/G', 'B5'
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/TGWl3wbZl_}
 */
export function tablatureLabelChordClicked(
  properties: TablatureLabelChordClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "TGWl3wbZl_", "87c1b72e049530f7d96fee112b45e163d7be1ec5f84a7657b2bd361ccc42989f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tablature Label Chord Clicked", {
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "course_id": properties.courseId,
      "course_slug": properties.courseSlug,
      "course_name": properties.courseName,
      "chord_label": properties.chordLabel,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("TGWl3wbZl_", "Tablature Label Chord Clicked", messages, [
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5gq2PzU-ZOj", name: "course_id", value: properties.courseId},
      {id: "Vax8oQCzw_j", name: "course_slug", value: properties.courseSlug},
      {id: "JfKEYKTi12qs", name: "course_name", value: properties.courseName},
      {id: "-ycnnwa5Uj", name: "chord_label", value: properties.chordLabel},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["course_id"] = properties.courseId;
  if (properties.courseSlug !== undefined && properties.courseSlug !== null) {
    eventProperties["course_slug"] = properties.courseSlug;
  }
  if (properties.courseName !== undefined && properties.courseName !== null) {
    eventProperties["course_name"] = properties.courseName;
  }
  eventProperties["chord_label"] = properties.chordLabel;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tablature Label Chord Clicked", {
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "course_id": properties.courseId,
        "course_slug": properties.courseSlug,
        "course_name": properties.courseName,
        "chord_label": properties.chordLabel,
        }, "TGWl3wbZl_", "87c1b72e049530f7d96fee112b45e163d7be1ec5f84a7657b2bd361ccc42989f");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Tablature Label Chord Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PlanSelectionProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
  flowContext: FlowContextValueType;
}
/**
 * Plan Selection: This event fires when the user loads the Plans screen or page, regardless of the flow.
 *
 * When to trigger this event:
 * 1. Onboarding plans
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/BTifKuhgu3/trigger/EX8wi5tNp
 * 2. Re-subscription
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/BTifKuhgu3/trigger/uvvilytNO
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.flowContext: This property indicates from which screen/page/flow/context the user originated from.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/BTifKuhgu3}
 */
export function planSelection(properties: PlanSelectionProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "BTifKuhgu3", "c1b6db5500b7953d7d5c44b985ab6c66fee043908ea68f928f3edfc3dffdb2e1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Plan Selection", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      "flow_context": properties.flowContext,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("BTifKuhgu3", "Plan Selection", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      {id: "2alGDYcrh-", name: "flow_context", value: properties.flowContext},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;
  eventProperties["flow_context"] = properties.flowContext;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface PlanAnnualClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  flowContext: FlowContextValueType;
}
/**
 * Plan Annual Clicked: This event fires when the user clicks to select an annual plan.
 *
 * When to trigger this event:
 * 1. "Try free and subscribe" button on right side under Annual Subscription is clicked
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/YkjB5TeFxX/trigger/yQrTl4532
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.flowContext: This property indicates from which screen/page/flow/context the user originated from.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/YkjB5TeFxX}
 */
export function planAnnualClicked(properties: PlanAnnualClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YkjB5TeFxX", "278112b49d1453ebb61ef9632adfe64fcca0262f50a8afec29a8b873a5dc2322", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Plan Annual Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "flow_context": properties.flowContext,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YkjB5TeFxX", "Plan Annual Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "2alGDYcrh-", name: "flow_context", value: properties.flowContext},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["flow_context"] = properties.flowContext;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan Annual Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "flow_context": properties.flowContext,
        }, "YkjB5TeFxX", "278112b49d1453ebb61ef9632adfe64fcca0262f50a8afec29a8b873a5dc2322");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Plan Annual Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PlanMonthlyClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  flowContext: FlowContextValueType;
}
/**
 * Plan Monthly Clicked: This event fires when the user clicks to select an annual plan.
 *
 * When to trigger this event:
 * 1. "Select this plan" under Monthly Subscription on left is clicked
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/C0Ou9sDwV/trigger/aSuRwo8dOy
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.flowContext: This property indicates from which screen/page/flow/context the user originated from.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/C0Ou9sDwV}
 */
export function planMonthlyClicked(properties: PlanMonthlyClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "C0Ou9sDwV", "a29d03a514fb7e8195001a76e2c0b7a5260651cf9264f0128cc15c9e6be3187f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Plan Monthly Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "flow_context": properties.flowContext,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("C0Ou9sDwV", "Plan Monthly Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "2alGDYcrh-", name: "flow_context", value: properties.flowContext},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["flow_context"] = properties.flowContext;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan Monthly Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "flow_context": properties.flowContext,
        }, "C0Ou9sDwV", "a29d03a514fb7e8195001a76e2c0b7a5260651cf9264f0128cc15c9e6be3187f");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Plan Monthly Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SessionStartedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
}
/**
 * Session Started: This event is fired when the app recognizes the user has started a session (which expires after 30 mins of inactivity)
 *
 * When to trigger this event:
 * 1. User is seen after 30 mins of inactivity (see also fc_session_id logic)
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/QUjYseZQmH/trigger/q8fG0TE4T
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/QUjYseZQmH}
 */
export function sessionStarted(properties: SessionStartedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QUjYseZQmH", "49def95fbab8b19106de10c44016d70e52a7fa2539d0df89af6bd88a78d9dd04", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Session Started", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QUjYseZQmH", "Session Started", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Session Started", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "QUjYseZQmH", "49def95fbab8b19106de10c44016d70e52a7fa2539d0df89af6bd88a78d9dd04");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Session Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingQuizGoalProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  name: string;
  customDestinationPageName_: string;
}
/**
 * Onboarding Quiz Goal: This event fires when the user loads the goal/motivation setting screen as part of onboarding.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/reUDHN0u0/trigger/Qkg4bNFS-
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.name: This property indicates the user-friendly 'name' of the Page or Screen for tracking purposes, or sometimes a generic name for an event (such as a product name). It's usually the same as the event name itself, a level up. It should not be a slug or page title.
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/reUDHN0u0}
 */
export function onboardingQuizGoal(properties: OnboardingQuizGoalProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "reUDHN0u0", "f4403c51c87a9a9fdd59ae6dafdd59ed613ca5170ccefd15ffb0e37beeab5b80", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Goal", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "name": properties.name,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("reUDHN0u0", "Onboarding Quiz Goal", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "uN2fs2Do9g", name: "name", value: properties.name},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["name"] = properties.name;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    // destination PlayWeb
    if (PlayWeb.logPage) {
      PlayWeb.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OnboardingQuizGoalClickedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  userId_: string;
  playGoal: PlayGoalValueType;
  goal: GoalValueType;
}
/**
 * Onboarding Quiz Goal Clicked: This event fires when the user selects their goal/motivation during onboarding.
 *
 * When to trigger this event:
 * 1. User clicks/taps a goal
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/pvgz2D259/trigger/5iQGyIzUj
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.playGoal: This user property is updated with the text set by the user's goal selection from Play app onboarding.
 * @param properties.goal: This property indicates the goal the user has selected with this event.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/pvgz2D259}
 */
export function onboardingQuizGoalClicked(
  properties: OnboardingQuizGoalClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pvgz2D259", "b4a2a570488f4fe35c5b99b1a3a92fea2b87385947729a5839d63802b0c60f16", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Quiz Goal Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "goal": properties.goal,
      }, {
      "play_goal": properties.playGoal,
      });
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pvgz2D259", "Onboarding Quiz Goal Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "p6cbt9Ev43", name: "goal", value: properties.goal},
      ], [
      {id:"49zQwHQm61", name: "play_goal", value: properties.playGoal},
      ].concat([] as any[]));
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["goal"] = properties.goal;

  // @ts-ignore
  let userProperties: any = {};
  userProperties["play_goal"] = properties.playGoal;

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Quiz Goal Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "goal": properties.goal,
        }, "pvgz2D259", "b4a2a570488f4fe35c5b99b1a3a92fea2b87385947729a5839d63802b0c60f16");
    }
    // destination PlayWeb
    PlayWeb.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PlayWeb.logEvent("Onboarding Quiz Goal Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlaybackStartedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  watchedToSeconds: number | null | undefined;
  watchedToPercentage: number | null | undefined;
  position: any | null | undefined;
  totalLength: number | null | undefined;
  bitrate: number | null | undefined;
  framerate: number | null | undefined;
  videoPlayer: string | null | undefined;
  sound: number | null | undefined;
  fullScreen: boolean | null | undefined;
  quality: string | null | undefined;
  livestream: boolean;
  lessonId: string;
  lessonSlug: string;
  lessonType: LessonTypeValueType | null | undefined;
  lessonName: string | null | undefined;
}
/**
 * Video Playback Started: This event fires when a user presses Play; after the last user action required for playback to begin
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.watchedToSeconds: This property indicates the duration in seconds of the video watched at this time this event is fired.
 * @param properties.watchedToPercentage: This property indicates the percentage of the total video length watched at the time this event is fired. Will eventually be used for royalty reporting instead of watchedTo.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 * @param properties.totalLength: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.bitrate: This property indicates the bitrate used for a video playback event.
 * @param properties.framerate: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.videoPlayer: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.sound: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.fullScreen: This property provides video playback information regarding if the video is being viewed fullscreen (true) or not (false). See the Segment Video Spec for more details.
 * @param properties.quality: This property provides video playback information. See the Segment Video Spec for more details.
 * @param properties.livestream: This property indicates whether the video feed is a livestream (true) or not (false).
 * @param properties.lessonId: This property indicates the ID number of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonSlug: This property indicates the slug of the lesson where the modal was randomly generated for the user.
 * @param properties.lessonType: This property indicates the type of lesson, e.g. basics, exercise, riff, song, technique, theory, tone
 * @param properties.lessonName: The name of the lesson that this event references.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/z10lnnlqrN}
 */
export function videoPlaybackStarted(
  properties: VideoPlaybackStartedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "z10lnnlqrN", "92c75f31195ca81a243206c32c36d93a02dd62152e9c70663e663fc7ca2292b4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Playback Started", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "watched_to_seconds": properties.watchedToSeconds,
      "watched_to_percentage": properties.watchedToPercentage,
      "position": properties.position,
      "total_length": properties.totalLength,
      "bitrate": properties.bitrate,
      "framerate": properties.framerate,
      "video_player": properties.videoPlayer,
      "sound": properties.sound,
      "full_screen": properties.fullScreen,
      "quality": properties.quality,
      "livestream": properties.livestream,
      "lesson_id": properties.lessonId,
      "lesson_slug": properties.lessonSlug,
      "lesson_type": properties.lessonType,
      "lesson_name": properties.lessonName,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("z10lnnlqrN", "Video Playback Started", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "5im0C_2CGS", name: "watched_to_seconds", value: properties.watchedToSeconds},
      {id: "KEsGGB-yKJ", name: "watched_to_percentage", value: properties.watchedToPercentage},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      {id: "gS5SQLr60jWe", name: "total_length", value: properties.totalLength},
      {id: "JgDOdynSR4vU", name: "bitrate", value: properties.bitrate},
      {id: "GIZBv8YpPHMc", name: "framerate", value: properties.framerate},
      {id: "jBSd7eGLbNId", name: "video_player", value: properties.videoPlayer},
      {id: "8KmyX3OzKSJH", name: "sound", value: properties.sound},
      {id: "3c3cR-fj6Esy", name: "full_screen", value: properties.fullScreen},
      {id: "UtMWJAVOnauZ", name: "quality", value: properties.quality},
      {id: "u1lECFXOHe", name: "livestream", value: properties.livestream},
      {id: "G_XC-AJki5P", name: "lesson_id", value: properties.lessonId},
      {id: "FNDB0PTFf-d", name: "lesson_slug", value: properties.lessonSlug},
      {id: "U2RrshbKWDac", name: "lesson_type", value: properties.lessonType},
      {id: "GPqSv0hcUyyP", name: "lesson_name", value: properties.lessonName},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.watchedToSeconds !== undefined && properties.watchedToSeconds !== null) {
    eventProperties["watched_to_seconds"] = properties.watchedToSeconds;
  }
  if (properties.watchedToPercentage !== undefined && properties.watchedToPercentage !== null) {
    eventProperties["watched_to_percentage"] = properties.watchedToPercentage;
  }
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }
  if (properties.totalLength !== undefined && properties.totalLength !== null) {
    eventProperties["total_length"] = properties.totalLength;
  }
  if (properties.bitrate !== undefined && properties.bitrate !== null) {
    eventProperties["bitrate"] = properties.bitrate;
  }
  if (properties.framerate !== undefined && properties.framerate !== null) {
    eventProperties["framerate"] = properties.framerate;
  }
  if (properties.videoPlayer !== undefined && properties.videoPlayer !== null) {
    eventProperties["video_player"] = properties.videoPlayer;
  }
  if (properties.sound !== undefined && properties.sound !== null) {
    eventProperties["sound"] = properties.sound;
  }
  if (properties.fullScreen !== undefined && properties.fullScreen !== null) {
    eventProperties["full_screen"] = properties.fullScreen;
  }
  if (properties.quality !== undefined && properties.quality !== null) {
    eventProperties["quality"] = properties.quality;
  }
  eventProperties["livestream"] = properties.livestream;
  eventProperties["lesson_id"] = properties.lessonId;
  eventProperties["lesson_slug"] = properties.lessonSlug;
  if (properties.lessonType !== undefined && properties.lessonType !== null) {
    eventProperties["lesson_type"] = properties.lessonType;
  }
  if (properties.lessonName !== undefined && properties.lessonName !== null) {
    eventProperties["lesson_name"] = properties.lessonName;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Playback Started", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "watched_to_seconds": properties.watchedToSeconds,
        "watched_to_percentage": properties.watchedToPercentage,
        "position": properties.position,
        "total_length": properties.totalLength,
        "bitrate": properties.bitrate,
        "framerate": properties.framerate,
        "video_player": properties.videoPlayer,
        "sound": properties.sound,
        "full_screen": properties.fullScreen,
        "quality": properties.quality,
        "livestream": properties.livestream,
        "lesson_id": properties.lessonId,
        "lesson_slug": properties.lessonSlug,
        "lesson_type": properties.lessonType,
        "lesson_name": properties.lessonName,
        }, "z10lnnlqrN", "92c75f31195ca81a243206c32c36d93a02dd62152e9c70663e663fc7ca2292b4");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Video Playback Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ModalViewedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adBodycopy: string;
  ctaButtoncopy: string;
}
/**
 * Modal Viewed: This event is fired when a modal is presented to the user. We're firing this as a Track event rather than Page/Screen due to how modals are loaded, and consistency with other new partial screen views like tooltips.
 *
 * When to trigger this event:
 * 1. Modal is displayed to the user
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/k5zPEIvTJC/trigger/O7VkCfeUd
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/k5zPEIvTJC}
 */
export function modalViewed(properties: ModalViewedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "k5zPEIvTJC", "a8ff414cbf4a5c96f6bf56376275a2387936d511fa5b62b7d5465b87cd7a9fee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Modal Viewed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_bodycopy": properties.adBodycopy,
      "cta_buttoncopy": properties.ctaButtoncopy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("k5zPEIvTJC", "Modal Viewed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Modal Viewed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_bodycopy": properties.adBodycopy,
        "cta_buttoncopy": properties.ctaButtoncopy,
        }, "k5zPEIvTJC", "a8ff414cbf4a5c96f6bf56376275a2387936d511fa5b62b7d5465b87cd7a9fee");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Modal Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ModalDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adBodycopy: string;
  adHeadlinecopy: string | null | undefined;
  ctaButtoncopy: string;
}
/**
 * Modal Dismissed: This event is fired when the user dismisses a modal.
 *
 * When to trigger this event:
 * 1. User clicks X button, or in greyed out overlay
User clicks on secondary item IF LOGIC IS TO DISMISS MODAL, otherwise don't fire
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/CNxkVOspWO/trigger/v6Aic1vob
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/CNxkVOspWO}
 */
export function modalDismissed(properties: ModalDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "CNxkVOspWO", "9704f9e791ff6377ed6956b2cb76073469b05d0cc6a139a0e6c5855f2782dc36", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Modal Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_bodycopy": properties.adBodycopy,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "cta_buttoncopy": properties.ctaButtoncopy,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("CNxkVOspWO", "Modal Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Modal Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ad_bodycopy": properties.adBodycopy,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "cta_buttoncopy": properties.ctaButtoncopy,
        }, "CNxkVOspWO", "9704f9e791ff6377ed6956b2cb76073469b05d0cc6a139a0e6c5855f2782dc36");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Modal Dismissed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TooltipViewedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adBodycopy: string;
  ctaButtoncopy: string;
  tooltipLocation: string;
}
/**
 * Tooltip Viewed: This event is fired when an informational tooltip is displayed to the user.
 *
 * When to trigger this event:
 * 1. Tooltip is displayed
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MIaMRXbBdK/trigger/SXlZEExRz
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.tooltipLocation: This property indicates the human-readable name of the element the tooltip is referring to, i.e. 'streaks counter'. Value should be the same across all platforms.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/MIaMRXbBdK}
 */
export function tooltipViewed(properties: TooltipViewedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MIaMRXbBdK", "bb100821f19e967b55975de7d7ebad5f2392fb20a594a8654422cef8fc3bda0d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tooltip Viewed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_bodycopy": properties.adBodycopy,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "tooltip_location": properties.tooltipLocation,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MIaMRXbBdK", "Tooltip Viewed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "XodcWBaw8f", name: "tooltip_location", value: properties.tooltipLocation},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["tooltip_location"] = properties.tooltipLocation;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tooltip Viewed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_bodycopy": properties.adBodycopy,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "tooltip_location": properties.tooltipLocation,
        }, "MIaMRXbBdK", "bb100821f19e967b55975de7d7ebad5f2392fb20a594a8654422cef8fc3bda0d");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Tooltip Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TooltipDismissedProperties {
  fcId: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string | null | undefined;
  adHeadlinecopy: string | null | undefined;
  adBodycopy: string;
  ctaButtoncopy: string;
  tooltipLocation: string;
}
/**
 * Tooltip Dismissed: This event is fired when the user dismisses a tooltip.
 *
 * When to trigger this event:
 * 1. X icon in upper right is clicked or tapped, or the area outside of the tooltip element is clicked or tapped
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/uMMr1CsPmm/trigger/uICd9fqPU
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.adHeadlinecopy: This property indicates the contents of the headline copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.adBodycopy: This property indicates the contents of the body copy displayed in the ad creative.

Helpful for any future multivariate testing. Contents populated programmatically.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.tooltipLocation: This property indicates the human-readable name of the element the tooltip is referring to, i.e. 'streaks counter'. Value should be the same across all platforms.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/uMMr1CsPmm}
 */
export function tooltipDismissed(properties: TooltipDismissedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uMMr1CsPmm", "5e838c556ba6279e3da093d7c07f954d58edc83f5c09b60daa002d19fa5e1ae6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tooltip Dismissed", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "ad_headlinecopy": properties.adHeadlinecopy,
      "ad_bodycopy": properties.adBodycopy,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "tooltip_location": properties.tooltipLocation,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uMMr1CsPmm", "Tooltip Dismissed", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "25I4Fdepi9S", name: "ad_headlinecopy", value: properties.adHeadlinecopy},
      {id: "RsnHK9bbxCJ", name: "ad_bodycopy", value: properties.adBodycopy},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "XodcWBaw8f", name: "tooltip_location", value: properties.tooltipLocation},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.fcId !== undefined && properties.fcId !== null) {
    eventProperties["fc_id"] = properties.fcId;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  if (properties.fcSessionId !== undefined && properties.fcSessionId !== null) {
    eventProperties["fc_session_id"] = properties.fcSessionId;
  }
  if (properties.adHeadlinecopy !== undefined && properties.adHeadlinecopy !== null) {
    eventProperties["ad_headlinecopy"] = properties.adHeadlinecopy;
  }
  eventProperties["ad_bodycopy"] = properties.adBodycopy;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["tooltip_location"] = properties.tooltipLocation;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tooltip Dismissed", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "ad_headlinecopy": properties.adHeadlinecopy,
        "ad_bodycopy": properties.adBodycopy,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "tooltip_location": properties.tooltipLocation,
        }, "uMMr1CsPmm", "5e838c556ba6279e3da093d7c07f954d58edc83f5c09b60daa002d19fa5e1ae6");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Tooltip Dismissed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CarouselAdvancedProperties {
  siteId: SiteIdValueType | null | undefined;
  locale: string;
  position: any | null | undefined;
}
/**
 * Carousel Advanced: This event fires when a user clicks to go forward or backwards in a carousel
 *
 * When to trigger this event:
 * 1. User clicks right arrow or left arrow button
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/if_iRZ9_Yb/trigger/rVprnO4Xy
 *
 * @param properties the properties associatied with this event
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.locale: This property indicates the user's locale (language & country code) when this event fires. Web only.
 * @param properties.position: This property provides either video playback information, or sometimes information about a promotional campaign (e.g. Homepage), or sometimes an integer like in the case of a position in a product list (e.g. 3). See the Segment Video Spec, Segment Ecomm spec, or the Algolia spec (https://www.algolia.com/doc/guides/sending-events/implementing/connectors/segment/) for more details.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/if_iRZ9_Yb}
 */
export function carouselAdvanced(properties: CarouselAdvancedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "if_iRZ9_Yb", "d756463340924b1cc1c351ea88540730b7f1d4599dbca517eea555cd58f75f35", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Carousel Advanced", {
      "site_id": properties.siteId,
      "locale": properties.locale,
      "position": properties.position,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("if_iRZ9_Yb", "Carousel Advanced", messages, [
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "Hegu4YQyDCM7", name: "locale", value: properties.locale},
      {id: "g7OK1y1YgnOh", name: "position", value: properties.position},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  eventProperties["locale"] = properties.locale;
  if (properties.position !== undefined && properties.position !== null) {
    eventProperties["position"] = properties.position;
  }

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Carousel Advanced", {
        "site_id": properties.siteId,
        "locale": properties.locale,
        "position": properties.position,
        }, "if_iRZ9_Yb", "d756463340924b1cc1c351ea88540730b7f1d4599dbca517eea555cd58f75f35");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Carousel Advanced", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CTAClickedProperties {
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
  siteId: SiteIdValueType | null | undefined;
  ctaLocation: CtaLocationValueType;
  ctaButtoncopy: string;
  marketingVersion: string;
}
/**
 * CTA Clicked: This event fires when a CTA, Call to Action, button is clicked
 *
 * When to trigger this event:
 * 1. This event fires when a user clicks the "start for free"  Call to Action button or link on the Play Unauth Landing Page.

The cta_location = unauth_hero
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/0vU6tAT56
 * 2. This event fires when a user clicks a Call to Action button on the artists or link on the Play Unauth Landing Page.

The cta_location = unauth_artists
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/kJ-Ytuzzy
 * 3. This event fires when a user clicks a “call to action” button or link on the Play Unauth Landing Page in the header.

The cta_location = unauth_header
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/7JUwZW0ra
 * 4. This event fires when a user clicks a favorite songs “call to action” button or link on the Play Unauth Landing Page.

The cta_location = unauth_favoritesongs
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/NWcX8tXoA
 * 5. This event fires when a user clicks a “call to action” button or link on the Play Unauth Landing Page in the Instructor Name.

The cta_location = unauth_sydneyellen Please note that name needs to be changed to corresponding instructor's name in lowercase without any spaces
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/FhbT4g0QT
 * 6. This event fires when a user clicks a “call to action” button or link on the Play Unauth Landing Page under Questions?

The cta_location = unauth_belowfaqs
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/5oWKSR-IT
 * 7. This event fires when a user clicks a “call to action” button or link on the Play Unauth Landing Page at the footer

The cta_location = unauth_footerbanner
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1/trigger/uqHjJzQKG
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.ctaLocation: This property describes the location of the call-to-action relating to this event.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.marketingVersion: This property indicates the version for this page (e.g.: Play v5)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/xHCRxx0Kz1}
 */
export function ctaClicked(properties: CTAClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xHCRxx0Kz1", "daff93e5775d75e3bd7f3853980005aaa1d14a910b55fc887bf2a6fe47982b10", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("CTA Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "site_id": properties.siteId,
      "cta_location": properties.ctaLocation,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "marketing_version": properties.marketingVersion,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xHCRxx0Kz1", "CTA Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "gteVFC3yPI", name: "cta_location", value: properties.ctaLocation},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "6kOMS3Jqvt", name: "marketing_version", value: properties.marketingVersion},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.utmMedium !== undefined && properties.utmMedium !== null) {
    eventProperties["utm_medium"] = properties.utmMedium;
  }
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  if (properties.utmCampaign !== undefined && properties.utmCampaign !== null) {
    eventProperties["utm_campaign"] = properties.utmCampaign;
  }
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  eventProperties["cta_location"] = properties.ctaLocation;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["marketing_version"] = properties.marketingVersion;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("CTA Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "site_id": properties.siteId,
        "cta_location": properties.ctaLocation,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "marketing_version": properties.marketingVersion,
        }, "xHCRxx0Kz1", "daff93e5775d75e3bd7f3853980005aaa1d14a910b55fc887bf2a6fe47982b10");
    }
    // destination PlayWeb
    PlayWeb.logEvent("CTA Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InstructorClickedProperties {
  utmMedium: string;
  utmSource: string | null | undefined;
  utmCampaign: string;
  ctaButtoncopy: string;
  marketingVersion: string;
}
/**
 * Instructor Clicked: This event fires when a user clicks on an instructor card
 *
 * When to trigger this event:
 * 1. This event fires when a user clicks on a Instructor Card
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/aD5wdEIUN/trigger/Ydls_AZRL
 *
 * @param properties the properties associatied with this event
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google.
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google.
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google.
 * @param properties.ctaButtoncopy: The text that appears on a CTA button.
 * @param properties.marketingVersion: This property indicates the version for this page (e.g.: Play v5)
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/aD5wdEIUN}
 */
export function instructorClicked(properties: InstructorClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aD5wdEIUN", "365f49fd4d072699291c7150779040ef7050b30472e0337c32861c2f615f265e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Instructor Clicked", {
      "utm_medium": properties.utmMedium,
      "utm_source": properties.utmSource,
      "utm_campaign": properties.utmCampaign,
      "cta_buttoncopy": properties.ctaButtoncopy,
      "marketing_version": properties.marketingVersion,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aD5wdEIUN", "Instructor Clicked", messages, [
      {id: "SlKsuG0pdl8l", name: "utm_medium", value: properties.utmMedium},
      {id: "1nL-cRMi9nmx", name: "utm_source", value: properties.utmSource},
      {id: "lwig3aI-bLkv", name: "utm_campaign", value: properties.utmCampaign},
      {id: "jRqqynqTj4u", name: "cta_buttoncopy", value: properties.ctaButtoncopy},
      {id: "aKtObcCELA", name: "marketing_version", value: properties.marketingVersion},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["utm_medium"] = properties.utmMedium;
  if (properties.utmSource !== undefined && properties.utmSource !== null) {
    eventProperties["utm_source"] = properties.utmSource;
  }
  eventProperties["utm_campaign"] = properties.utmCampaign;
  eventProperties["cta_buttoncopy"] = properties.ctaButtoncopy;
  eventProperties["marketing_version"] = properties.marketingVersion;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Instructor Clicked", {
        "utm_medium": properties.utmMedium,
        "utm_source": properties.utmSource,
        "utm_campaign": properties.utmCampaign,
        "cta_buttoncopy": properties.ctaButtoncopy,
        "marketing_version": properties.marketingVersion,
        }, "aD5wdEIUN", "365f49fd4d072699291c7150779040ef7050b30472e0337c32861c2f615f265e");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Instructor Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DownloadClickedProperties {
  siteId: SiteIdValueType | null | undefined;
  locale: string;
  appStore: AppStoreValueType;
}
/**
 * Download Clicked: This event fires when a user clicks to download the Fender Play App via Apple/iOS or Google/Android
 *
 * When to trigger this event:
 * 1. This event fires when a user clicks to download the Fender Play App via Apple/iOS or Google/Android on the Play Unauth Landing Page

If a user clicks App Store:
Button link: https://app.adjust.com/anvlej
Adjust tracker name: Fendercom-Homepage

If a user clicks Google Play
Button link: https://play.google.com/store/apps/details?hl=en&id=com.fender.play&referrer=adjust_reftag%3DcQNicsU9kRTuK%26utm_source%3DFendercom-Homepage
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/IbxhX3CnN/trigger/Sxha-9yoDj
 *
 * @param properties the properties associatied with this event
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.locale: This property indicates the user's locale (language & country code) when this event fires. Web only.
 * @param properties.appStore: This property indicates whether this event is related to the Apple or Google app store.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/IbxhX3CnN}
 */
export function downloadClicked(properties: DownloadClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "IbxhX3CnN", "6c1dd4480ff7a47abb87a1a7930bec0a42eda77fa7c7597111aa1b3489eee734", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Download Clicked", {
      "site_id": properties.siteId,
      "locale": properties.locale,
      "app_store": properties.appStore,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("IbxhX3CnN", "Download Clicked", messages, [
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "Hegu4YQyDCM7", name: "locale", value: properties.locale},
      {id: "K8wBv8kRZ", name: "app_store", value: properties.appStore},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  eventProperties["locale"] = properties.locale;
  eventProperties["app_store"] = properties.appStore;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Download Clicked", {
        "site_id": properties.siteId,
        "locale": properties.locale,
        "app_store": properties.appStore,
        }, "IbxhX3CnN", "6c1dd4480ff7a47abb87a1a7930bec0a42eda77fa7c7597111aa1b3489eee734");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Download Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeProductClickedProperties {
  fcId: string;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string;
  productName: string;
  sku: string;
}
/**
 * Home Product Clicked: This event is fired when an ecomm product is clicked/tapped/selected by the user from the Play Home screen.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/VsY_SL9pZ3/trigger/B_VPpf-Oi
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 * @param properties.productName: This property describes the name of the product.
 * @param properties.sku: This property indicates the SKU for the subscription or product this transaction refers to.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/VsY_SL9pZ3}
 */
export function homeProductClicked(properties: HomeProductClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VsY_SL9pZ3", "d9aee7b5ee9cf01fabc1e928f10d0c8556d877eeea2ee6ae4b094b952d934eb5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Product Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      "product_name": properties.productName,
      "sku": properties.sku,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VsY_SL9pZ3", "Home Product Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      {id: "Asg5Ns31HQ", name: "product_name", value: properties.productName},
      {id: "rlZ8VcpYNxA", name: "sku", value: properties.sku},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["fc_id"] = properties.fcId;
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  eventProperties["fc_session_id"] = properties.fcSessionId;
  eventProperties["product_name"] = properties.productName;
  eventProperties["sku"] = properties.sku;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Product Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        "product_name": properties.productName,
        "sku": properties.sku,
        }, "VsY_SL9pZ3", "d9aee7b5ee9cf01fabc1e928f10d0c8556d877eeea2ee6ae4b094b952d934eb5");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Product Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomeProductsViewallClickedProperties {
  fcId: string;
  siteId: SiteIdValueType | null | undefined;
  fcSessionId: string;
}
/**
 * Home Products Viewall Clicked: This event is fired when the user clicks to view all ecomm products.
 *
 * When to trigger this event:
 * 1. User clicks "Shop all" in top right
 * View in Avo: https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/1xDCOusOZQ/trigger/WAsn9vYzd
 *
 * @param properties the properties associatied with this event
 * @param properties.fcId: This property indicates the Fender Connect user ID, which should be sent with every event.
Note to devs: if this property is currently sent as fcId or fcID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.siteId: This property indicates the app or website this event was fired within.
Note to devs: if this property is currently sent as siteId or siteID in your app, please ALSO send this property in addition to that one with the same value. Eventually we'll migrate everyone to use this property instead.
 * @param properties.fcSessionId: This property indicates the generated session ID (UUID) for a logged in Fender Connect user, so we can group/session-ize their event stream. Should expire after 30 mins of inactivity.
 *
 * @see {@link https://www.avo.app/schemas/yXbFvXu5GZ3j0uXXEPGy/branches/YrmPdcOBQ/events/1xDCOusOZQ}
 */
export function homeProductsViewallClicked(
  properties: HomeProductsViewallClickedProperties) {
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1xDCOusOZQ", "9ff9578b0e3f5ff4943476bb570600519fd2e9ea06e1d2f65b8cbf0eee4bcfaa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Home Products Viewall Clicked", {
      "fc_id": properties.fcId,
      "site_id": properties.siteId,
      "fc_session_id": properties.fcSessionId,
      }, {});
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1xDCOusOZQ", "Home Products Viewall Clicked", messages, [
      {id: "plMYZqsBT", name: "fc_id", value: properties.fcId},
      {id: "d3IXImY4_Z", name: "site_id", value: properties.siteId},
      {id: "vQIKatjQlb", name: "fc_session_id", value: properties.fcSessionId},
      ], []);
    }
  }

  // @ts-ignore
  let eventProperties: any = {};
  eventProperties["fc_id"] = properties.fcId;
  if (properties.siteId !== undefined && properties.siteId !== null) {
    eventProperties["site_id"] = properties.siteId;
  }
  eventProperties["fc_session_id"] = properties.fcSessionId;

  // @ts-ignore
  let userProperties: any = {};

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Products Viewall Clicked", {
        "fc_id": properties.fcId,
        "site_id": properties.siteId,
        "fc_session_id": properties.fcSessionId,
        }, "1xDCOusOZQ", "9ff9578b0e3f5ff4943476bb570600519fd2e9ea06e1d2f65b8cbf0eee4bcfaa");
    }
    // destination PlayWeb
    PlayWeb.logEvent("Home Products Viewall Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  FlowContext,
  EventType,
  PlayGoal,
  ActivityType,
  Instrument,
  Index,
  AppStore,
  PlayPathGenre,
  UserLogic,
  ActivityInstrument,
  PlayPathInstrument,
  LessonType,
  SiteId,
  ActivityGenre,
  Playlist,
  CtaLocation,
  Genre,
  PlaySubStatus,
  Path,
  StreakType,
  Goal,
  MilestoneType,
  AdProvider,
  signInLinkClicked,
  subscriptionOffer,
  subscriptionOfferAnnualClicked,
  subscriptionOfferDeclined,
  trialStarted,
  subscriptionAdBannerClicked,
  subscriptionAdModal,
  subscriptionAdModalAccepted,
  subscriptionAdModalDeclined,
  subscriptionUpgrade,
  subscriptionUpgradeAnnualClicked,
  subscriptionUpgradeMonthlyClicked,
  subscriptionUpgradeDismissed,
  completedOrder,
  onboardingTour,
  subscriptionResubscribe,
  subscriptionResubscribeAnnualClicked,
  subscriptionResubscribeMonthlyClicked,
  subscriptionResubscribeDismissed,
  songsList,
  articleDetail,
  myPath,
  articlesList,
  skillsList,
  lessonDetail,
  courseDetail,
  onboardingInstrumentPicker,
  onboardingStylePicker,
  chordsList,
  chordChallengeList,
  chordChallengeDetail,
  chordChallengePicker,
  chordChallengeTour,
  myAccount,
  collectionsList,
  collectionDetail,
  searchResults,
  favoritesList,
  favoritesListFilterPicker,
  favoritesAlert,
  practiceMode,
  tablatureFullscreen,
  markAsCompleteModal,
  checkoutStarted,
  courseClicked,
  watchedVideo,
  searchCompleted,
  tablatureCollapsed,
  tablatureExpanded,
  lessonChordsClicked,
  videoPlaybackBufferCompleted,
  videoPlayerBack10,
  videoPlayerForward10,
  videoPlayerScrubBackward,
  videoPlayerScrubForward,
  collectionClicked,
  collectionCourseClicked,
  courseMarkedAsComplete,
  courseUnmarkedAsComplete,
  emailSignup,
  favoriteRemoved,
  favoriteAdded,
  streakIconClicked,
  lessonMarkedAsComplete,
  lessonUnmarkedAsComplete,
  miniPlayerToggled,
  practiceModeExit,
  practiceModeLaunched,
  practiceModeNextLessonClicked,
  practiceModePlaybackCheckpointReached,
  presetDownloaded,
  lessonFeedbackClicked,
  lessonInfoClicked,
  lessonRelatedClicked,
  lessonTablatureClicked,
  lessonToneClicked,
  lessonToolsClicked,
  sessionMilestoneCompleted,
  videoPlaybackCompleted,
  videoPlaybackPaused,
  videoPlaybackResumed,
  videoPlayerSpeedChanged,
  videoQualityUpdated,
  subscriptionLastChanceOffer,
  subscriptionLastChanceOfferAnnualClicked,
  subscriptionLastChanceOfferDeclined,
  onboardingQuizInstrument,
  onboardingQuizGenre,
  onboardingQuizInstrumentClicked,
  onboardingQuizGenreClicked,
  pathChanged,
  accountFcContinued,
  searchResultClicked,
  landing,
  checkout,
  subscriptionBundle,
  subscriptionPromotionBundleClicked,
  subscriptionPromotionMonthlyClicked,
  subscriptionPromotionAnnualClicked,
  promotionCheckout,
  feedbackMode,
  feedbackModeOnboarding,
  feedbackModeOnboardingAdvanced,
  feedbackModeOnboardingDismissed,
  feedbackModeOnboardingCompleted,
  feedbackModeScoreReceived,
  googleSignInClicked,
  facebookSignInClicked,
  appleSignInClicked,
  signUpLinkClicked,
  navigationClicked,
  activityStarted,
  activityCompleted,
  activityDismissed,
  courseCompleted,
  homeSongClicked,
  homeCollectionClicked,
  homeRiffClicked,
  homeArticleClicked,
  homeArticlesViewallClicked,
  homeCollectionsViewallClicked,
  homeSongsViewallClicked,
  homeRiffsViewallClicked,
  homeFeaturedClicked,
  navigationOpened,
  navigationDismissed,
  homeHeroStarted,
  homeHeroPaused,
  homeHeroCompleted,
  homePathLastClicked,
  homePathNextClicked,
  homePathStartClicked,
  home,
  lessonClicked,
  levelClicked,
  onboardingQuizGenreSkipped,
  onboardingQuizAbility,
  onboardingQuizAbilityClicked,
  homeHeroContinued,
  tablatureZoomChanged,
  tablatureLabelChordClicked,
  planSelection,
  planAnnualClicked,
  planMonthlyClicked,
  sessionStarted,
  onboardingQuizGoal,
  onboardingQuizGoalClicked,
  videoPlaybackStarted,
  modalViewed,
  modalDismissed,
  tooltipViewed,
  tooltipDismissed,
  carouselAdvanced,
  ctaClicked,
  instructorClicked,
  downloadClicked,
  homeProductClicked,
  homeProductsViewallClicked,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["signInLinkClicked","subscriptionOffer","subscriptionOfferAnnualClicked","subscriptionOfferDeclined","trialStarted","subscriptionAdBannerClicked","subscriptionAdModal","subscriptionAdModalAccepted","subscriptionAdModalDeclined","subscriptionUpgrade","subscriptionUpgradeAnnualClicked","subscriptionUpgradeMonthlyClicked","subscriptionUpgradeDismissed","completedOrder","onboardingTour","subscriptionResubscribe","subscriptionResubscribeAnnualClicked","subscriptionResubscribeMonthlyClicked","subscriptionResubscribeDismissed","songsList","articleDetail","myPath","articlesList","skillsList","lessonDetail","courseDetail","onboardingInstrumentPicker","onboardingStylePicker","chordsList","chordChallengeList","chordChallengeDetail","chordChallengePicker","chordChallengeTour","myAccount","collectionsList","collectionDetail","searchResults","favoritesList","favoritesListFilterPicker","favoritesAlert","streaksModal","practiceMode","tablatureFullscreen","markAsCompleteModal","checkoutStarted","courseClicked","watchedVideo","searchCompleted","tablatureCollapsed","tablatureExpanded","lessonChordsClicked","videoPlaybackBufferCompleted","videoPlayerBack10","videoPlayerForward10","videoPlayerScrubBackward","videoPlayerScrubForward","collectionClicked","collectionCourseClicked","courseMarkedAsComplete","courseUnmarkedAsComplete","emailSignup","favoriteRemoved","favoriteAdded","streakIconClicked","lessonMarkedAsComplete","lessonUnmarkedAsComplete","miniPlayerToggled","practiceModeExit","practiceModeLaunched","practiceModeNextLessonClicked","practiceModePlaybackCheckpointReached","presetDownloaded","lessonFeedbackClicked","lessonInfoClicked","lessonRelatedClicked","lessonTablatureClicked","lessonToneClicked","lessonToolsClicked","sessionMilestoneCompleted","videoPlaybackCompleted","videoPlaybackPaused","videoPlaybackResumed","videoPlayerSpeedChanged","videoQualityUpdated","subscriptionLastChanceOffer","subscriptionLastChanceOfferAnnualClicked","subscriptionLastChanceOfferDeclined","onboardingQuizInstrument","onboardingQuizGenre","onboardingQuizInstrumentClicked","onboardingQuizGenreClicked","pathChanged","accountFcContinued","searchResultClicked","landing","checkout","subscriptionBundle","subscriptionPromotionBundleClicked","subscriptionPromotionMonthlyClicked","subscriptionPromotionAnnualClicked","promotionCheckout","feedbackMode","feedbackModeOnboarding","feedbackModeOnboardingAdvanced","feedbackModeOnboardingDismissed","feedbackModeOnboardingCompleted","feedbackModeScoreReceived","googleSignInClicked","facebookSignInClicked","appleSignInClicked","signUpLinkClicked","navigationClicked","activityStarted","activityCompleted","activityDismissed","courseCompleted","streaksModalDismissed","streaksModalLearnClicked","homeSongClicked","homeCollectionClicked","homeRiffClicked","homeArticleClicked","homeArticlesViewallClicked","homeCollectionsViewallClicked","homeSongsViewallClicked","homeRiffsViewallClicked","homeFeaturedClicked","navigationOpened","navigationDismissed","homeHeroStarted","homeHeroPaused","homeHeroCompleted","homePathLastClicked","homePathNextClicked","homePathStartClicked","home","lessonClicked","levelClicked","onboardingQuizGenreSkipped","onboardingQuizAbility","onboardingQuizAbilityClicked","homeHeroContinued","tablatureZoomChanged","tablatureLabelChordClicked","planSelection","planAnnualClicked","planMonthlyClicked","sessionStarted","onboardingQuizGoal","onboardingQuizGoalClicked","videoPlaybackStarted","modalViewed","modalDismissed","tooltipViewed","tooltipDismissed","carouselAdvanced","ctaClicked","instructorClicked","downloadClicked","homeProductClicked","homeProductsViewallClicked"]
